export const getStationName = (item) =>
  `${item.ADDRESS1} ${item.STNNAME} ${item.STATE}`;

export const STATIONS = [
  {
    X: -82.44084200005824,
    Y: 38.415404999740986,
    OBJECTID: 1,
    STNCODE: "HUN",
    STNNAME: "Huntington, West Virginia",
    ADDRESS1: "1050 8th Avenue",
    ADDRESS2: "",
    CITY: "Huntington",
    STATE: "WV",
    ZIP: "25701",
    STNTYPE: "RAIL",
    STFIPS: 54,
  },
  {
    X: -97.93006099981523,
    Y: 38.05585899999289,
    OBJECTID: 2,
    STNCODE: "HUT",
    STNNAME: "Hutchinson, Kansas",
    ADDRESS1: "North Walnut St & East 3rd Ave",
    ADDRESS2: "",
    CITY: "Hutchinson",
    STATE: "KS",
    ZIP: "67501",
    STNTYPE: "RAIL",
    STFIPS: 20,
  },
  {
    X: -85.46992499973891,
    Y: 43.39572899969363,
    OBJECTID: 3,
    STNCODE: "HWC",
    STNNAME: "Howard City, Michigan",
    ADDRESS1: "130 North Ensley St.",
    ADDRESS2: "Sunoco Station",
    CITY: "Howard City",
    STATE: "MI",
    ZIP: "49323",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -116.23317000049508,
    Y: 33.71475199970507,
    OBJECTID: 4,
    STNCODE: "IDO",
    STNNAME: "Indio, California",
    ADDRESS1: "NE Corner Hywy-111 and Monroe Street",
    ADDRESS2: "Sunline Bus Stop",
    CITY: "Indio",
    STATE: "CA",
    ZIP: "92201-3917",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -94.42929799950304,
    Y: 39.08697500029609,
    OBJECTID: 5,
    STNCODE: "IDP",
    STNNAME: "Independence, Missouri",
    ADDRESS1: "600 South Grand Ave.",
    ADDRESS2: "",
    CITY: "Independence",
    STATE: "MO",
    ZIP: "64050-3564",
    STNTYPE: "RAIL",
    STFIPS: 29,
  },
  {
    X: -86.1603090000603,
    Y: 39.76215400000717,
    OBJECTID: 6,
    STNCODE: "IND",
    STNNAME: "Indianapolis, Indiana",
    ADDRESS1: "350 South Illinois Street",
    ADDRESS2: "",
    CITY: "Indianapolis",
    STATE: "IN",
    ZIP: "46225-1198",
    STNTYPE: "RAIL",
    STFIPS: 18,
  },
  {
    X: -117.75919299965716,
    Y: 33.67476700029687,
    OBJECTID: 7,
    STNCODE: "IRV",
    STNNAME: "Irvine, California",
    ADDRESS1: "15215 Barranca Parkway",
    ADDRESS2: "Irvine Transportation Center",
    CITY: "Irvine",
    STATE: "CA",
    ZIP: "92618",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -90.19059800029743,
    Y: 32.300643999421084,
    OBJECTID: 8,
    STNCODE: "JAN",
    STNNAME: "Jackson, Mississippi",
    ADDRESS1: "300 W. Capital Street",
    ADDRESS2: "",
    CITY: "Jackson",
    STATE: "MS",
    ZIP: "39201",
    STNTYPE: "RAIL",
    STFIPS: 28,
  },
  {
    X: -81.72460200078166,
    Y: 30.366576999728807,
    OBJECTID: 9,
    STNCODE: "JAX",
    STNNAME: "Jacksonville, Florida",
    ADDRESS1: "3570 Clifford Lane",
    ADDRESS2: "",
    CITY: "Jacksonville",
    STATE: "FL",
    ZIP: "32209-2123",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -92.17038000013684,
    Y: 38.579052000149716,
    OBJECTID: 10,
    STNCODE: "JEF",
    STNNAME: "Jefferson City, Missouri",
    ADDRESS1: "101 Jefferson Street",
    ADDRESS2: "",
    CITY: "Jefferson City",
    STATE: "MO",
    ZIP: "65101",
    STNTYPE: "RAIL",
    STFIPS: 29,
  },
  {
    X: -79.24009699997652,
    Y: 42.09642400016753,
    OBJECTID: 12,
    STNCODE: "JMN",
    STNNAME: "Jamestown, New York",
    ADDRESS1: "111 West Third Street",
    ADDRESS2: "U.S. News Agency",
    CITY: "Jamestown",
    STATE: "NY",
    ZIP: "14701",
    STNTYPE: "BUS",
    STFIPS: 36,
  },
  {
    X: -88.07914000041063,
    Y: 41.52487600042713,
    OBJECTID: 13,
    STNCODE: "JOL",
    STNNAME: "Joliet, Illinois",
    ADDRESS1: "50 East Jefferson Street",
    ADDRESS2: "Union Station",
    CITY: "Joliet",
    STATE: "IL",
    ZIP: "60431",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -81.88220199932277,
    Y: 31.605908999900464,
    OBJECTID: 14,
    STNCODE: "JSP",
    STNNAME: "Jesup, Georgia",
    ADDRESS1: "176 Northwest Broad Street",
    ADDRESS2: "",
    CITY: "Jesup",
    STATE: "GA",
    ZIP: "31545-1300",
    STNTYPE: "RAIL",
    STFIPS: 13,
  },
  {
    X: -78.9224240003673,
    Y: 40.33010100006118,
    OBJECTID: 15,
    STNCODE: "JST",
    STNNAME: "Johnstown, Pennsylvania",
    ADDRESS1: "47 Walnut Street",
    ADDRESS2: "",
    CITY: "Johnstown",
    STATE: "PA",
    ZIP: "15901",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -88.99692500038844,
    Y: 42.720356000029426,
    OBJECTID: 16,
    STNCODE: "JVL",
    STNNAME: "Janesville, Wisconsin",
    ADDRESS1: "3120 North Pontiac Drive",
    ADDRESS2: "Bus Station",
    CITY: "Janesville",
    STATE: "WI",
    ZIP: "53545-0373",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -84.40029100022946,
    Y: 42.2480510002535,
    OBJECTID: 17,
    STNCODE: "JXN",
    STNNAME: "Jackson, Michigan",
    ADDRESS1: "501 E. Michigan Ave.",
    ADDRESS2: "",
    CITY: "Jackson",
    STATE: "MI",
    ZIP: "49201",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -85.58358800008608,
    Y: 42.295451999909915,
    OBJECTID: 18,
    STNCODE: "KAL",
    STNNAME: "Kalamazoo, Michigan",
    ADDRESS1: "459 North Burdick St.",
    ADDRESS2: "",
    CITY: "Kalamazoo",
    STATE: "MI",
    ZIP: "49007-3669",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -80.62181099927818,
    Y: 35.50126600012584,
    OBJECTID: 19,
    STNCODE: "KAN",
    STNNAME: "Kannapolis, North Carolina",
    ADDRESS1: "201 South Main St.",
    ADDRESS2: "",
    CITY: "Kannapolis",
    STATE: "NC",
    ZIP: "28081",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -94.58394600040754,
    Y: 39.08615100006864,
    OBJECTID: 20,
    STNCODE: "KCY",
    STNNAME: "Kansas City, Missouri",
    ADDRESS1: "30 West Pershing Rd.",
    ADDRESS2: "Union Station, Suite 160",
    CITY: "Kansas City",
    STATE: "MO",
    ZIP: "64108-2410",
    STNTYPE: "RAIL",
    STFIPS: 29,
  },
  {
    X: -89.92742199932576,
    Y: 41.24562500009375,
    OBJECTID: 21,
    STNCODE: "KEE",
    STNNAME: "Kewanee, Illinois",
    ADDRESS1: "Loomis and North Tremont Sts.",
    ADDRESS2: "",
    CITY: "Kewanee",
    STATE: "IL",
    ZIP: "61443",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -122.91176600010078,
    Y: 46.1426239993981,
    OBJECTID: 22,
    STNCODE: "KEL",
    STNNAME: "Kelso-Longview, Washington",
    ADDRESS1: "501 South First Street",
    ADDRESS2: "",
    CITY: "Kelso",
    STATE: "WA",
    ZIP: "98626",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -121.77092000005791,
    Y: 42.22587999946245,
    OBJECTID: 23,
    STNCODE: "KFS",
    STNNAME: "Klamath Falls, Oregon",
    ADDRESS1: "1600 Oak Ave.",
    ADDRESS2: "",
    CITY: "Klamath Falls",
    STATE: "OR",
    ZIP: "97601-3286",
    STNTYPE: "RAIL",
    STFIPS: 41,
  },
  {
    X: -121.12869999950533,
    Y: 36.20350999968679,
    OBJECTID: 24,
    STNCODE: "KGC",
    STNNAME: "King City, California",
    ADDRESS1: "1350 Broadway Circle",
    ADDRESS2: "MacDonalds Restaurant - south side parking lot",
    CITY: "King City",
    STATE: "CA",
    ZIP: "93930-3446",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -114.00808698492636,
    Y: 35.220316350419296,
    OBJECTID: 25,
    STNCODE: "KGG",
    STNNAME: "Kingman (Greyhound), Arizona",
    ADDRESS1: "3264 E. Andy Devine Av.",
    ADDRESS2: "Greyhound Station",
    CITY: "Kingman",
    STATE: "AZ",
    ZIP: "86401-3724",
    STNTYPE: "BUS",
    STFIPS: 4,
  },
  {
    X: -85.53649333200161,
    Y: 44.5845329144625,
    OBJECTID: 26,
    STNCODE: "KGS",
    STNNAME: "Kingsley, Michigan",
    ADDRESS1: "119 E. Main St.",
    ADDRESS2: "Kingsley Laundromat",
    CITY: "Kingsley",
    STATE: "MI",
    ZIP: "49649",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -97.72948500063222,
    Y: 31.121298000102684,
    OBJECTID: 27,
    STNCODE: "KIL",
    STNNAME: "Killeen, Texas",
    ADDRESS1: "200 East Avenue C",
    ADDRESS2: "Arrow Trailways Bus Station",
    CITY: "Killeen",
    STATE: "TX",
    ZIP: "76541-5231",
    STNTYPE: "BUS",
    STFIPS: 48,
  },
  {
    X: -71.56228599989896,
    Y: 41.48394000033079,
    OBJECTID: 28,
    STNCODE: "KIN",
    STNNAME: "West Kingston, Rhode Island",
    ADDRESS1: "1 Railroad Avenue",
    ADDRESS2: "",
    CITY: "West Kingston",
    STATE: "RI",
    ZIP: "02892-1508",
    STNTYPE: "RAIL",
    STFIPS: 44,
  },
  {
    X: -81.40512176945407,
    Y: 28.29343249411437,
    OBJECTID: 29,
    STNCODE: "KIS",
    STNNAME: "Kissimmee, Florida",
    ADDRESS1: "111 East Dakin Ave.",
    ADDRESS2: "",
    CITY: "Kissimmee",
    STATE: "FL",
    ZIP: "34741-5723",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -87.86576099987019,
    Y: 41.11913299988811,
    OBJECTID: 30,
    STNCODE: "KKI",
    STNNAME: "Kankakee, Illinois",
    ADDRESS1: "199 South East Ave.",
    ADDRESS2: "",
    CITY: "Kankakee",
    STATE: "IL",
    ZIP: "60901-3834",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -114.05207099967686,
    Y: 35.188357999921834,
    OBJECTID: 32,
    STNCODE: "KNG",
    STNNAME: "Kingman, Arizona",
    ADDRESS1: "106 4th Street",
    ADDRESS2: "",
    CITY: "Kingman",
    STATE: "AZ",
    ZIP: "86401",
    STNTYPE: "RAIL",
    STFIPS: 4,
  },
  {
    X: -71.53432763151494,
    Y: 43.21143342481275,
    OBJECTID: 33,
    STNCODE: "CNH",
    STNNAME: "Concord, New Hampshire",
    ADDRESS1: "30 Stickney Ave.",
    ADDRESS2: "Concord Transportation Center",
    CITY: "Concord",
    STATE: "NH",
    ZIP: "03301-5064",
    STNTYPE: "BUS",
    STFIPS: 33,
  },
  {
    X: -119.55650299971364,
    Y: 36.09819400025299,
    OBJECTID: 34,
    STNCODE: "COC",
    STNNAME: "Corcoran, California",
    ADDRESS1: "1099 Otis Ave.",
    ADDRESS2: "Otis and Whitney Aves.",
    CITY: "Corcoran",
    STATE: "CA",
    ZIP: "93212-2445",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -85.13355999969417,
    Y: 39.646464999759985,
    OBJECTID: 35,
    STNCODE: "COI",
    STNNAME: "Connersville, Indiana",
    ADDRESS1: "1012 Eastern Avenue",
    ADDRESS2: "",
    CITY: "Connersville",
    STATE: "IN",
    ZIP: "47331",
    STNTYPE: "RAIL",
    STFIPS: 18,
  },
  {
    X: -104.81919900043351,
    Y: 38.83192399989275,
    OBJECTID: 36,
    STNCODE: "COS",
    STNNAME: "Colorado Springs, Colorado",
    ADDRESS1: "120 South Weber Street",
    ADDRESS2: "",
    CITY: "Colorado Springs",
    STATE: "CO",
    ZIP: "80903",
    STNTYPE: "BUS",
    STFIPS: 8,
  },
  {
    X: -75.82066299999741,
    Y: 39.98561899981706,
    OBJECTID: 37,
    STNCODE: "COT",
    STNNAME: "Coatesville, Pennsylvania",
    ADDRESS1: "Third Ave. and Fleetwood St.",
    ADDRESS2: "",
    CITY: "Coatesville",
    STATE: "PA",
    ZIP: "19320",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -79.59259800039735,
    Y: 40.01810099946158,
    OBJECTID: 38,
    STNCODE: "COV",
    STNNAME: "Connellsville, Pennsylvania",
    ADDRESS1: "North Water Street and West Peach Street",
    ADDRESS2: "",
    CITY: "Connellsville",
    STATE: "PA",
    ZIP: "15425",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -120.95270499983582,
    Y: 39.09945699944103,
    OBJECTID: 39,
    STNCODE: "COX",
    STNNAME: "Colfax, California",
    ADDRESS1: "99 Railroad St. at Church St.",
    ADDRESS2: "",
    CITY: "Colfax",
    STATE: "CA",
    ZIP: "95713",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -119.52131700037921,
    Y: 34.396003999784796,
    OBJECTID: 40,
    STNCODE: "CPN",
    STNNAME: "Carpinteria, California",
    ADDRESS1: "475 Linden at Fifth Street",
    ADDRESS2: "",
    CITY: "Carpinteria",
    STATE: "CA",
    ZIP: "93013",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -86.90507653515391,
    Y: 40.07594641059842,
    OBJECTID: 41,
    STNCODE: "CRB",
    STNNAME: "Crawfordsville (Bus), Indiana",
    ADDRESS1: "1000 Smith Ave",
    ADDRESS2: "McDonald's Restaurant",
    CITY: "Crawfordsville",
    STATE: "IN",
    ZIP: "47933-1076",
    STNTYPE: "BUS",
    STFIPS: 18,
  },
  {
    X: -86.89938400017144,
    Y: 40.04425400042186,
    OBJECTID: 42,
    STNCODE: "CRF",
    STNNAME: "Crawfordsville (Amtrak), Indiana",
    ADDRESS1: "Spring and Green Streets",
    ADDRESS2: "",
    CITY: "Crawfordsville",
    STATE: "IN",
    ZIP: "47933",
    STNTYPE: "RAIL",
    STFIPS: 18,
  },
  {
    X: -75.04243500017509,
    Y: 39.927482999740675,
    OBJECTID: 43,
    STNCODE: "CRH",
    STNNAME: "Cherry Hill, New Jersey",
    ADDRESS1: "Cornell Ave. & West Marlton Pike",
    ADDRESS2: "",
    CITY: "Cherry Hill",
    STATE: "NJ",
    ZIP: "08002",
    STNTYPE: "OTHER",
    STFIPS: 34,
  },
  {
    X: -121.90804299948479,
    Y: 36.53931799922634,
    OBJECTID: 44,
    STNCODE: "CRM",
    STNNAME: "Carmel, California",
    ADDRESS1: "3645 Rio Road",
    ADDRESS2: "In front Chevron Stationn & Mart",
    CITY: "Carmel",
    STATE: "CA",
    ZIP: "93923-8609",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -94.36119800038739,
    Y: 41.05708300008047,
    OBJECTID: 45,
    STNCODE: "CRN",
    STNNAME: "Creston, Iowa",
    ADDRESS1: "Pine and Adams Avenue",
    ADDRESS2: "",
    CITY: "Creston",
    STATE: "IA",
    ZIP: "50891",
    STNTYPE: "RAIL",
    STFIPS: 19,
  },
  {
    X: -73.88384200010819,
    Y: 41.19272999978972,
    OBJECTID: 46,
    STNCODE: "CRT",
    STNNAME: "Croton Harmon, New York",
    ADDRESS1: "1 Croton Point Avenue",
    ADDRESS2: "",
    CITY: "Croton-on-Hudson",
    STATE: "NY",
    ZIP: "10520-3054",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -89.88891599977353,
    Y: 39.27932700064059,
    OBJECTID: 47,
    STNCODE: "CRV",
    STNNAME: "Carlinville, Illinois",
    ADDRESS1: "128 Alton Rd.",
    ADDRESS2: "",
    CITY: "Carlinville",
    STATE: "IL",
    ZIP: "62626-1625",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -82.83348100064762,
    Y: 34.69117700051822,
    OBJECTID: 48,
    STNCODE: "CSN",
    STNNAME: "Clemson, South Carolina",
    ADDRESS1: "Calhoun Memorial Hwy and College Ave.",
    ADDRESS2: "",
    CITY: "Clemson",
    STATE: "SC",
    ZIP: "29631",
    STNTYPE: "RAIL",
    STFIPS: 45,
  },
  {
    X: -122.9518809992087,
    Y: 46.71742199972556,
    OBJECTID: 51,
    STNCODE: "CTL",
    STNNAME: "Centralia, Washington",
    ADDRESS1: "210 Railroad Avenue",
    ADDRESS2: "",
    CITY: "Centralia",
    STATE: "WA",
    ZIP: "98531",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -78.75847599956768,
    Y: 39.65058499999782,
    OBJECTID: 52,
    STNCODE: "CUM",
    STNNAME: "Cumberland, Maryland",
    ADDRESS1: "East Harrison and Queen City Street",
    ADDRESS2: "",
    CITY: "Cumberland",
    STATE: "MD",
    ZIP: "21502",
    STNTYPE: "RAIL",
    STFIPS: 24,
  },
  {
    X: -112.33002499995376,
    Y: 48.636939999381525,
    OBJECTID: 53,
    STNCODE: "CUT",
    STNNAME: "Cut Bank, Montana",
    ADDRESS1: "101 BNSF Industrial Site",
    ADDRESS2: "Off Central Avenue/Hwy 213",
    CITY: "Cut Bank",
    STATE: "MT",
    ZIP: "59427-2934",
    STNTYPE: "RAIL",
    STFIPS: 30,
  },
  {
    X: -111.88063800034342,
    Y: 34.62577800005471,
    OBJECTID: 54,
    STNCODE: "CVD",
    STNNAME: "Camp Verde, Arizona",
    ADDRESS1: "1613 Finnie Flats Rd",
    ADDRESS2: "Burger King",
    CITY: "Camp Verde",
    STATE: "AZ",
    ZIP: "86322-5201",
    STNTYPE: "BUS",
    STFIPS: 4,
  },
  {
    X: -123.26059700035125,
    Y: 44.56523900047955,
    OBJECTID: 55,
    STNCODE: "CVI",
    STNNAME: "Corvallis, Oregon",
    ADDRESS1: "153 NW 4th Avenue",
    ADDRESS2: "Greyhound Station",
    CITY: "Corvallis",
    STATE: "OR",
    ZIP: "97330",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -78.49211099992266,
    Y: 38.03203199927742,
    OBJECTID: 56,
    STNCODE: "CVS",
    STNNAME: "Charlottesville, Virginia",
    ADDRESS1: "810 West Main St",
    ADDRESS2: "",
    CITY: "Charlottesville",
    STATE: "VA",
    ZIP: "22903",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -74.95143107618316,
    Y: 40.071729720650126,
    OBJECTID: 57,
    STNCODE: "CWH",
    STNNAME: "Cornwells Heights, Pennsylvania",
    ADDRESS1: "700 Station Ave.",
    ADDRESS2: "Station Avenue and Railroad Avenue",
    CITY: "Cornwells Heights",
    STATE: "PA",
    ZIP: "19020",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -118.59873200028153,
    Y: 34.25711799999573,
    OBJECTID: 58,
    STNCODE: "CWT",
    STNNAME: "Chatsworth, California",
    ADDRESS1: "10040 Old Depot Plaza Road",
    ADDRESS2: "",
    CITY: "Chatsworth",
    STATE: "CA",
    ZIP: "91311",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -78.7796780006392,
    Y: 35.787708000224086,
    OBJECTID: 59,
    STNCODE: "CYN",
    STNNAME: "Cary, North Carolina",
    ADDRESS1: "211 North Academy Street",
    ADDRESS2: "",
    CITY: "Cary",
    STATE: "NC",
    ZIP: "27511",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -96.80740400039429,
    Y: 32.775542999210074,
    OBJECTID: 60,
    STNCODE: "DAL",
    STNNAME: "Dallas, Texas",
    ADDRESS1: "400 South Houston St.",
    ADDRESS2: "Union Station",
    CITY: "Dallas",
    STATE: "TX",
    ZIP: "75202-4840",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -69.53089692605226,
    Y: 44.03234869883346,
    OBJECTID: 61,
    STNCODE: "DAM",
    STNNAME: "Damariscotta, Maine",
    ADDRESS1: "167 Main St.",
    ADDRESS2: "Waltz Pharmacy",
    CITY: "Damariscotta",
    STATE: "ME",
    ZIP: "04543-4649",
    STNTYPE: "BUS",
    STFIPS: 23,
  },
  {
    X: -79.38431500013712,
    Y: 36.58369799986286,
    OBJECTID: 62,
    STNCODE: "DAN",
    STNNAME: "Danville, Virginia",
    ADDRESS1: "677 Craghead St.",
    ADDRESS2: "",
    CITY: "Danville",
    STATE: "VA",
    ZIP: "24541-1503",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -121.737068000188,
    Y: 38.54411300051464,
    OBJECTID: 63,
    STNCODE: "DAV",
    STNNAME: "Davis, California",
    ADDRESS1: "840 Second Street",
    ADDRESS2: "Amtrak Passenger Station",
    CITY: "Davis",
    STATE: "CA",
    ZIP: "95616-4624",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -121.89789876461629,
    Y: 37.69920121616326,
    OBJECTID: 64,
    STNCODE: "DBP",
    STNNAME: "Dublin-Pleasanton, California",
    ADDRESS1: "5801 Owens Drive",
    ADDRESS2: "BART Station, north side, East curb near par. str.",
    CITY: "Pleasanton",
    STATE: "CA",
    ZIP: "94588-3900",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -82.18482199993531,
    Y: 28.364188999722614,
    OBJECTID: 65,
    STNCODE: "DDE",
    STNNAME: "Dade City, Florida",
    ADDRESS1: "14218 US Highway 98",
    ADDRESS2: "Hwy98/301 Truck Route",
    CITY: "Dade City",
    STATE: "FL",
    ZIP: "33525",
    STNTYPE: "OTHER",
    STFIPS: 12,
  },
  {
    X: -100.01657899982092,
    Y: 37.75259799949811,
    OBJECTID: 66,
    STNCODE: "DDG",
    STNNAME: "Dodge City, Kansas",
    ADDRESS1: "Central Ave & Wyatt Earp St.",
    ADDRESS2: "",
    CITY: "Dodge City",
    STATE: "KS",
    ZIP: "67801",
    STNTYPE: "RAIL",
    STFIPS: 20,
  },
  {
    X: -104.99177771037301,
    Y: 39.75045974941793,
    OBJECTID: 67,
    STNCODE: "DEB",
    STNNAME: "Denver (Bus Station), Colorado",
    ADDRESS1: "1055 19th Street",
    ADDRESS2: "Greyhound Station",
    CITY: "Denver",
    STATE: "CO",
    ZIP: "80202",
    STNTYPE: "BUS",
    STFIPS: 8,
  },
  {
    X: -107.76083399998907,
    Y: 32.27108400052623,
    OBJECTID: 68,
    STNCODE: "DEM",
    STNNAME: "Deming, New Mexico",
    ADDRESS1: "400 East Railroad Avenue",
    ADDRESS2: "",
    CITY: "Deming",
    STATE: "NM",
    ZIP: "88030",
    STNTYPE: "RAIL",
    STFIPS: 35,
  },
  {
    X: -104.99961100054719,
    Y: 39.75322300004149,
    OBJECTID: 69,
    STNCODE: "DEN",
    STNNAME: "Denver, Colorado",
    ADDRESS1: "1701 Wynkoop Street",
    ADDRESS2: "Union Station",
    CITY: "Denver",
    STATE: "CO",
    ZIP: "80202",
    STNTYPE: "RAIL",
    STFIPS: 8,
  },
  {
    X: -83.20118000045665,
    Y: 42.313049000211265,
    OBJECTID: 70,
    STNCODE: "DER",
    STNNAME: "Dearborn, Michigan",
    ADDRESS1: "16121 Michigan Ave.",
    ADDRESS2: "",
    CITY: "Dearborn",
    STATE: "MI",
    ZIP: "48126",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -83.07209800042233,
    Y: 42.36788199995436,
    OBJECTID: 71,
    STNCODE: "DET",
    STNNAME: "Detroit, Michigan",
    ADDRESS1: "11 West Baltimore Ave.",
    ADDRESS2: "",
    CITY: "Detroit",
    STATE: "MI",
    ZIP: "48202",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -80.12146000027877,
    Y: 26.31779499923988,
    OBJECTID: 72,
    STNCODE: "DFB",
    STNNAME: "Deerfield Beach, Florida",
    ADDRESS1: "1300 W. Hillsboro Blvd",
    ADDRESS2: "",
    CITY: "Deerfield Beach",
    STATE: "FL",
    ZIP: "33442",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -105.37964661599847,
    Y: 42.748523634358264,
    OBJECTID: 73,
    STNCODE: "DGS",
    STNNAME: "Douglas, Wyoming",
    ADDRESS1: "628 East Richards St.",
    ADDRESS2: "Plains Motel & Gift Shop",
    CITY: "Douglas",
    STATE: "WY",
    ZIP: "82633-2834",
    STNTYPE: "BUS",
    STFIPS: 56,
  },
  {
    X: -70.93582944477299,
    Y: 43.13897623916216,
    OBJECTID: 74,
    STNCODE: "DHM",
    STNNAME: "Durham, New Hampshire",
    ADDRESS1: "3 Depot Road",
    ADDRESS2: "University of New Hampshire campus",
    CITY: "Durham",
    STATE: "NH",
    ZIP: "03824-1909",
    STNTYPE: "RAIL",
    STFIPS: 33,
  },
  {
    X: -79.37175799933215,
    Y: 34.41828499935326,
    OBJECTID: 75,
    STNCODE: "DIL",
    STNNAME: "Dillon, South Carolina",
    ADDRESS1: "100 North Railroad Avenue",
    ADDRESS2: "",
    CITY: "Dillon",
    STATE: "SC",
    ZIP: "29536",
    STNTYPE: "RAIL",
    STFIPS: 45,
  },
  {
    X: -80.09252899981345,
    Y: 26.45517900081029,
    OBJECTID: 76,
    STNCODE: "DLB",
    STNNAME: "Delray Beach, Florida",
    ADDRESS1: "345 South Congress Ave",
    ADDRESS2: "",
    CITY: "Delray Beach",
    STATE: "FL",
    ZIP: "33444",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -81.3524549999982,
    Y: 29.01683399988923,
    OBJECTID: 77,
    STNCODE: "DLD",
    STNNAME: "Deland, Florida",
    ADDRESS1: "2491 Old New York Ave",
    ADDRESS2: "",
    CITY: "Deland",
    STATE: "FL",
    ZIP: "32720-2808",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -95.84558100026294,
    Y: 46.81948899951777,
    OBJECTID: 78,
    STNCODE: "DLK",
    STNNAME: "Detroit Lakes, Minnesota",
    ADDRESS1: "116 Pioneer Street",
    ADDRESS2: "",
    CITY: "Detroit Lakes",
    STATE: "MN",
    ZIP: "56501",
    STNTYPE: "RAIL",
    STFIPS: 27,
  },
  {
    X: -78.90722700012594,
    Y: 35.99703600011139,
    OBJECTID: 79,
    STNCODE: "DNC",
    STNNAME: "Durham, North Carolina",
    ADDRESS1: "400 W. Chapel Hill Street",
    ADDRESS2: "",
    CITY: "Durham",
    STATE: "NC",
    ZIP: "27701",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -81.14315000027227,
    Y: 33.32614499979195,
    OBJECTID: 80,
    STNCODE: "DNK",
    STNNAME: "Denmark, South Carolina",
    ADDRESS1: "200 West Baruch Street",
    ADDRESS2: "",
    CITY: "Denmark",
    STATE: "SC",
    ZIP: "29042",
    STNTYPE: "RAIL",
    STFIPS: 45,
  },
  {
    X: -86.10873400037377,
    Y: 41.98120100072566,
    OBJECTID: 81,
    STNCODE: "DOA",
    STNNAME: "Dowagiac, Michigan",
    ADDRESS1: "200 Depot Drive",
    ADDRESS2: "",
    CITY: "Dowagiac",
    STATE: "MI",
    ZIP: "49047-1779",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -70.87664799990523,
    Y: 43.19865600017431,
    OBJECTID: 82,
    STNCODE: "DOV",
    STNNAME: "Dover, New Hampshire",
    ADDRESS1: "33 Chestnut St.",
    ADDRESS2: "",
    CITY: "Dover",
    STATE: "NH",
    ZIP: "03820-3327",
    STNTYPE: "RAIL",
    STFIPS: 33,
  },
  {
    X: -75.70812199923085,
    Y: 40.002537000282416,
    OBJECTID: 83,
    STNCODE: "DOW",
    STNNAME: "Downingtown, Pennsylvania",
    ADDRESS1: "West Lancaster Ave. and Stuart Ave.",
    ADDRESS2: "",
    CITY: "Downingtown",
    STATE: "PA",
    ZIP: "19335",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -89.24015799989172,
    Y: 38.01135299984111,
    OBJECTID: 84,
    STNCODE: "DQN",
    STNNAME: "Du Quoin, Illinois",
    ADDRESS1: "20 North Chestnut St.",
    ADDRESS2: "",
    CITY: "Du Quoin",
    STATE: "IL",
    ZIP: "62832-1602",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -83.98243700056707,
    Y: 42.90977900020073,
    OBJECTID: 85,
    STNCODE: "DRD",
    STNNAME: "Durand, Michigan",
    ADDRESS1: "200 South Railroad St.",
    ADDRESS2: "",
    CITY: "Durand",
    STATE: "MI",
    ZIP: "48429-1713",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -100.90146599985599,
    Y: 29.363080999688464,
    OBJECTID: 86,
    STNCODE: "DRT",
    STNNAME: "Del Rio, Texas",
    ADDRESS1: "100 North Main Street",
    ADDRESS2: "",
    CITY: "Del Rio",
    STATE: "TX",
    ZIP: "78840",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -79.33101700013441,
    Y: 42.48533199957217,
    OBJECTID: 87,
    STNCODE: "DUK",
    STNNAME: "Dunkirk, New York",
    ADDRESS1: "411 Central Ave.",
    ADDRESS2: "P&G Foods",
    CITY: "Dunkirk",
    STATE: "NY",
    ZIP: "14048",
    STNTYPE: "BUS",
    STFIPS: 36,
  },
  {
    X: -92.12400800026899,
    Y: 46.76660199958269,
    OBJECTID: 88,
    STNCODE: "DUL",
    STNNAME: "Duluth (Greyhound Station), Minnesota",
    ADDRESS1: "4426 Grand Ave.",
    ADDRESS2: "Greyhound Terminal",
    CITY: "Duluth",
    STATE: "MN",
    ZIP: "55806",
    STNTYPE: "BUS",
    STFIPS: 27,
  },
  {
    X: -122.26997400039977,
    Y: 41.21117399958047,
    OBJECTID: 89,
    STNCODE: "DUN",
    STNNAME: "Dunsmuir (Amtrak Station), California",
    ADDRESS1: "5750 Sacramento Avenue",
    ADDRESS2: "Amtrak Passenger Station",
    CITY: "Dunsmuir",
    STATE: "CA",
    ZIP: "96025-2024",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -92.07677002881377,
    Y: 46.81044513823258,
    OBJECTID: 90,
    STNCODE: "DUU",
    STNNAME: "Duluth (University of Minnesota), Minnesota",
    ADDRESS1: "175 Kirby Student Union",
    ADDRESS2: "",
    CITY: "Duluth",
    STATE: "MN",
    ZIP: "55812",
    STNTYPE: "BUS",
    STFIPS: 27,
  },
  {
    X: -87.63611600015327,
    Y: 40.11942700015601,
    OBJECTID: 91,
    STNCODE: "DVI",
    STNNAME: "Danville, Illinois",
    ADDRESS1: "379 Lynch Road",
    ADDRESS2: "BP Amoco Station",
    CITY: "Danville",
    STATE: "IL",
    ZIP: "61834-9378",
    STNTYPE: "BUS",
    STFIPS: 17,
  },
  {
    X: -98.86137399951042,
    Y: 48.11064500006677,
    OBJECTID: 92,
    STNCODE: "DVL",
    STNNAME: "Devils Lake, North Dakota",
    ADDRESS1: "Railroad Ave. and Third St.",
    ADDRESS2: "",
    CITY: "Devils Lake",
    STATE: "ND",
    ZIP: "58301",
    STNTYPE: "RAIL",
    STFIPS: 38,
  },
  {
    X: -90.57742299987149,
    Y: 41.51973699996262,
    OBJECTID: 93,
    STNCODE: "DVP",
    STNNAME: "Davenport, Iowa",
    ADDRESS1: "304 West River Drive",
    ADDRESS2: "",
    CITY: "Davenport",
    STATE: "IA",
    ZIP: "52801",
    STNTYPE: "BUS",
    STFIPS: 19,
  },
  {
    X: -75.52529358822846,
    Y: 39.14995003736436,
    OBJECTID: 94,
    STNCODE: "DVR",
    STNNAME: "Dover, Delaware",
    ADDRESS1: "716 South Governors Ave",
    ADDRESS2: "City Cab",
    CITY: "Dover",
    STATE: "DE",
    ZIP: "19901-4633",
    STNTYPE: "BUS",
    STFIPS: 10,
  },
  {
    X: -88.42832200065976,
    Y: 41.092049000061365,
    OBJECTID: 95,
    STNCODE: "DWT",
    STNNAME: "Dwight, Illinois",
    ADDRESS1: "119 West Main St.",
    ADDRESS2: "",
    CITY: "Dwight",
    STATE: "IL",
    ZIP: "60420-1321",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -81.00911699944993,
    Y: 29.228230999860784,
    OBJECTID: 96,
    STNCODE: "DYA",
    STNNAME: "Daytona Beach, Florida",
    ADDRESS1: "100 North Atlantic Ave",
    ADDRESS2: "Hilton Daytona Beach Ocean Walk Village",
    CITY: "Daytona Beach",
    STATE: "FL",
    ZIP: "32118-4273",
    STNTYPE: "BUS",
    STFIPS: 12,
  },
  {
    X: -87.5181879991768,
    Y: 41.498528000367,
    OBJECTID: 97,
    STNCODE: "DYE",
    STNNAME: "Dyer, Indiana",
    ADDRESS1: "913 Sheffield Avenue",
    ADDRESS2: "(near Sheffield and Matteson)",
    CITY: "Dyer",
    STATE: "IN",
    ZIP: "46311",
    STNTYPE: "RAIL",
    STFIPS: 18,
  },
  {
    X: -122.38307199987287,
    Y: 47.81129500006426,
    OBJECTID: 98,
    STNCODE: "EDM",
    STNNAME: "Edmonds, Washington",
    ADDRESS1: "211 Railroad Ave.",
    ADDRESS2: "",
    CITY: "Edmonds",
    STATE: "WA",
    ZIP: "98020-4132",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -88.54571499944763,
    Y: 39.119156000449095,
    OBJECTID: 99,
    STNCODE: "EFG",
    STNNAME: "Effingham, Illinois",
    ADDRESS1: "401 West National Ave.",
    ADDRESS2: "",
    CITY: "Effingham",
    STATE: "IL",
    ZIP: "62401-3772",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -74.64933002306208,
    Y: 39.52705999542252,
    OBJECTID: 100,
    STNCODE: "EGH",
    STNNAME: "Egg Harbor City, New Jersey",
    ADDRESS1: "South Philadelphia Ave & Atlantic Ave",
    ADDRESS2: "New Jersey Transit",
    CITY: "Egg Harbor City",
    STATE: "NJ",
    ZIP: "08215",
    STNTYPE: "OTHER",
    STFIPS: 34,
  },
  {
    X: -124.16889100241781,
    Y: 40.8006298810642,
    OBJECTID: 101,
    STNCODE: "EKA",
    STNNAME: "Eureka, California",
    ADDRESS1: "Sixth and C Sts.",
    ADDRESS2: "Bus stop behind Denny's",
    CITY: "Eureka",
    STATE: "CA",
    ZIP: "95501",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -121.48253556506427,
    Y: 38.42457980951065,
    OBJECTID: 102,
    STNCODE: "EKG",
    STNNAME: "Elk Grove, California",
    ADDRESS1: "Harbor Point Drive at Renwick Avenue",
    ADDRESS2: "Across from McDonald's",
    CITY: "Elk Grove",
    STATE: "CA",
    ZIP: "95758",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -85.97105400044171,
    Y: 41.680720999874325,
    OBJECTID: 103,
    STNCODE: "EKH",
    STNNAME: "Elkhart, Indiana",
    ADDRESS1: "131 Tyler Avenue",
    ADDRESS2: "",
    CITY: "Elkhart",
    STATE: "IN",
    ZIP: "46515",
    STNTYPE: "RAIL",
    STFIPS: 18,
  },
  {
    X: -106.49012552237491,
    Y: 31.757270971578123,
    OBJECTID: 104,
    STNCODE: "ELB",
    STNNAME: "El Paso (Bus Station), Texas",
    ADDRESS1: "200 W. San Antonio Ave.",
    ADDRESS2: "",
    CITY: "El Paso",
    STATE: "TX",
    ZIP: "79901-1048",
    STNTYPE: "BUS",
    STFIPS: 48,
  },
  {
    X: -115.7533949997794,
    Y: 40.83687599942789,
    OBJECTID: 105,
    STNCODE: "ELK",
    STNNAME: "Elko, Nevada",
    ADDRESS1: "12th and Silver Sts.",
    ADDRESS2: "",
    CITY: "Elko",
    STATE: "NV",
    ZIP: "89801",
    STNTYPE: "RAIL",
    STFIPS: 32,
  },
  {
    X: -106.49488800008112,
    Y: 31.757725000608332,
    OBJECTID: 106,
    STNCODE: "ELP",
    STNNAME: "El Paso, Texas",
    ADDRESS1: "700 San Francisco St.",
    ADDRESS2: "",
    CITY: "El Paso",
    STATE: "TX",
    ZIP: "79901",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -123.54656089207145,
    Y: 45.85776053971716,
    OBJECTID: 107,
    STNCODE: "ELS",
    STNNAME: "Elsie, Oregon",
    ADDRESS1: "44573 Highway 26",
    ADDRESS2: "Baker's General Store/Hardware",
    CITY: "Elsie",
    STATE: "OR",
    ZIP: "97138",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -76.6145780001745,
    Y: 40.14740000050966,
    OBJECTID: 108,
    STNCODE: "ELT",
    STNNAME: "Elizabethtown, Pennsylvania",
    ADDRESS1: "South Wilson Avenue at West High Street",
    ADDRESS2: "",
    CITY: "Elizabethtown",
    STATE: "PA",
    ZIP: "17022",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -82.09700800001917,
    Y: 41.37005199950022,
    OBJECTID: 109,
    STNCODE: "ELY",
    STNNAME: "Elyria, Ohio",
    ADDRESS1: "410 East River Road",
    ADDRESS2: "",
    CITY: "Elyria",
    STATE: "OH",
    ZIP: "44035",
    STNTYPE: "RAIL",
    STFIPS: 39,
  },
  {
    X: -122.29068000018185,
    Y: 37.84067900003589,
    OBJECTID: 110,
    STNCODE: "EMY",
    STNNAME: "Emeryville, California",
    ADDRESS1: "5885 Horton Street",
    ADDRESS2: "",
    CITY: "Emeryville",
    STATE: "CA",
    ZIP: "94608-2037",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -119.5486449997669,
    Y: 47.32059500005926,
    OBJECTID: 111,
    STNCODE: "EPH",
    STNNAME: "Ephrata, Washington",
    ADDRESS1: "24 Alder St NW",
    ADDRESS2: "Bus leaves from 90 Alder St NW",
    CITY: "Ephrata",
    STATE: "WA",
    ZIP: "88823-2421",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -119.75289200006574,
    Y: 37.67854300005945,
    OBJECTID: 112,
    STNCODE: "EPL",
    STNNAME: "El Portal, California",
    ADDRESS1: "11136 Highway 140",
    ADDRESS2: "Yosemite View Lodge",
    CITY: "El Portal",
    STATE: "CA",
    ZIP: "95318-0169",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -80.08103900054942,
    Y: 42.12112799995731,
    OBJECTID: 113,
    STNCODE: "ERI",
    STNNAME: "Erie, Pennsylvania",
    ADDRESS1: "125 West 14th Street",
    ADDRESS2: "",
    CITY: "Erie",
    STATE: "PA",
    ZIP: "16501",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -113.60948199969448,
    Y: 48.28086100033494,
    OBJECTID: 114,
    STNCODE: "ESM",
    STNNAME: "Essex, Montana",
    ADDRESS1: "290 Izaak Walton Inn Rd",
    ADDRESS2: "Izaak Walton Inn",
    CITY: "Essex",
    STATE: "MT",
    ZIP: "59916-9710",
    STNTYPE: "RAIL",
    STFIPS: 30,
  },
  {
    X: -73.11045099941407,
    Y: 44.492572999444405,
    OBJECTID: 115,
    STNCODE: "ESX",
    STNNAME: "Essex Junction, Vermont",
    ADDRESS1: "29 Railroad Ave.",
    ADDRESS2: "",
    CITY: "Essex Jct.",
    STATE: "VT",
    ZIP: "05452",
    STNTYPE: "RAIL",
    STFIPS: 50,
  },
  {
    X: -123.09184300005438,
    Y: 44.05538599946436,
    OBJECTID: 116,
    STNCODE: "EUG",
    STNNAME: "Eugene, Oregon",
    ADDRESS1: "433 Willamette Street",
    ADDRESS2: "",
    CITY: "Eugene",
    STATE: "OR",
    ZIP: "97401-2613",
    STNTYPE: "RAIL",
    STFIPS: 41,
  },
  {
    X: -122.21562200035498,
    Y: 47.9792820000643,
    OBJECTID: 117,
    STNCODE: "EVR",
    STNNAME: "Everett, Washington",
    ADDRESS1: "3201 Smith Ave.",
    ADDRESS2: "",
    CITY: "Everett",
    STATE: "WA",
    ZIP: "98201",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -74.19059638651396,
    Y: 40.70513408626914,
    OBJECTID: 118,
    STNCODE: "EWR",
    STNNAME: "Newark Liberty International Airport, New Jersey",
    ADDRESS1: "Newark Liberty International Airport",
    ADDRESS2: "AirTrain from main airport terminal",
    CITY: "Newark",
    STATE: "NJ",
    ZIP: "07114-3401",
    STNTYPE: "RAIL",
    STFIPS: 34,
  },
  {
    X: -70.95782200028503,
    Y: 42.98160300017838,
    OBJECTID: 119,
    STNCODE: "EXR",
    STNNAME: "Exeter, New Hampshire",
    ADDRESS1: "60 Lincoln Street",
    ADDRESS2: "Lincoln Street at Railroad Avenue",
    CITY: "Exeter",
    STATE: "NH",
    ZIP: "03833",
    STNTYPE: "RAIL",
    STFIPS: 33,
  },
  {
    X: -75.62202053511959,
    Y: 40.01910902616066,
    OBJECTID: 120,
    STNCODE: "EXT",
    STNNAME: "Exton, Pennsylvania",
    ADDRESS1: "425 Walkertown Road",
    ADDRESS2: "US 30/Route 100 (Pottstown Pike) interchange",
    CITY: "Exton",
    STATE: "PA",
    ZIP: "19341",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -96.78461499988231,
    Y: 46.88107700050324,
    OBJECTID: 121,
    STNCODE: "FAR",
    STNNAME: "Fargo, North Dakota",
    ADDRESS1: "420 4th Street North",
    ADDRESS2: "",
    CITY: "Fargo",
    STATE: "ND",
    ZIP: "58102",
    STNTYPE: "RAIL",
    STFIPS: 38,
  },
  {
    X: -78.88506300055701,
    Y: 35.054904999765995,
    OBJECTID: 122,
    STNCODE: "FAY",
    STNNAME: "Fayetteville, North Carolina",
    ADDRESS1: "472 Hay Street",
    ADDRESS2: "",
    CITY: "Fayetteville",
    STATE: "NC",
    ZIP: "28301-5563",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -77.45693200021162,
    Y: 38.29855700000559,
    OBJECTID: 123,
    STNCODE: "FBG",
    STNNAME: "Fredericksburg, Virginia",
    ADDRESS1: "200 Lafayette Blvd.",
    ADDRESS2: "",
    CITY: "Fredericksburg",
    STATE: "VA",
    ZIP: "22401-6067",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -105.06591799971591,
    Y: 40.58378199933986,
    OBJECTID: 124,
    STNCODE: "FCC",
    STNNAME: "Fort Collins, Colorado",
    ADDRESS1: "250 North Mason St.",
    ADDRESS2: "Greyhound Station",
    CITY: "Fort Collins",
    STATE: "CO",
    ZIP: "80524-4407",
    STNTYPE: "BUS",
    STFIPS: 8,
  },
  {
    X: -88.45018799997621,
    Y: 43.75251800000575,
    OBJECTID: 125,
    STNCODE: "FDL",
    STNNAME: "Fond du Lac, Wisconsin",
    ADDRESS1: "976 South Main St.",
    ADDRESS2: "Mobile Station",
    CITY: "Fond du Lac",
    STATE: "WI",
    ZIP: "54935-6101",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -79.34017899996087,
    Y: 42.44512599986507,
    OBJECTID: 126,
    STNCODE: "FDN",
    STNNAME: "Fredonia, New York",
    ADDRESS1: "1 State University of New York",
    ADDRESS2: "William Center Student Union",
    CITY: "Fredonia",
    STATE: "NY",
    ZIP: "14063",
    STNTYPE: "BUS",
    STFIPS: 36,
  },
  {
    X: -73.58046000032869,
    Y: 43.269515999763655,
    OBJECTID: 127,
    STNCODE: "FED",
    STNNAME: "Fort Edward-Glens Falls, New York",
    ADDRESS1: "70 East St.",
    ADDRESS2: "East and Rogers Sts.",
    CITY: "Fort Edward",
    STATE: "NY",
    ZIP: "12828",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -111.6576940542372,
    Y: 35.19457224781104,
    OBJECTID: 128,
    STNCODE: "FGG",
    STNNAME: "Flagstaff (Greyhound), Arizona",
    ADDRESS1: "399 S. Malpais Ln.",
    ADDRESS2: "Greyhound Bus Terminal",
    CITY: "Flagstaff",
    STATE: "AZ",
    ZIP: "86001-6218",
    STNTYPE: "BUS",
    STFIPS: 4,
  },
  {
    X: -97.7643129996452,
    Y: 31.139959000007877,
    OBJECTID: 129,
    STNCODE: "FHD",
    STNNAME: "Fort Hood, Texas",
    ADDRESS1: "Hood Road & Old Ironsides Ave.",
    ADDRESS2: "Copeland Soldier's Service Center--Bldg. 18010",
    CITY: "Fort Hood",
    STATE: "TX",
    ZIP: "76544",
    STNTYPE: "BUS",
    STFIPS: 48,
  },
  {
    X: -73.26204699986909,
    Y: 43.59057599998249,
    OBJECTID: 130,
    STNCODE: "FHV",
    STNNAME: "Fair Haven, Vermont",
    ADDRESS1: "Depot and Water Sts.",
    ADDRESS2: "",
    CITY: "Fair Haven",
    STATE: "VT",
    ZIP: "05743",
    STNTYPE: "RAIL",
    STFIPS: 50,
  },
  {
    X: -118.916610999498,
    Y: 34.39613000019938,
    OBJECTID: 131,
    STNCODE: "FIL",
    STNNAME: "Fillmore, California",
    ADDRESS1: "718 West Ventura St.",
    ADDRESS2: "International House of Pancakes",
    CITY: "Fillmore",
    STATE: "CA",
    ZIP: "93015-1835",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -111.65066499988978,
    Y: 35.198013,
    OBJECTID: 132,
    STNCODE: "FLG",
    STNNAME: "Flagstaff, Arizona",
    ADDRESS1: "1 East Route 66",
    ADDRESS2: "",
    CITY: "Flagstaff",
    STATE: "AZ",
    ZIP: "86001-5530",
    STNTYPE: "RAIL",
    STFIPS: 4,
  },
  {
    X: -83.65483900011975,
    Y: 43.013633999709384,
    OBJECTID: 133,
    STNCODE: "FLN",
    STNNAME: "Flint, Michigan",
    ADDRESS1: "1407 South Dort Highway",
    ADDRESS2: "",
    CITY: "Flint",
    STATE: "MI",
    ZIP: "48503-2878",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -79.75709499953456,
    Y: 34.19881800045039,
    OBJECTID: 134,
    STNCODE: "FLO",
    STNNAME: "Florence, South Carolina",
    ADDRESS1: "805 East Day Street",
    ADDRESS2: "",
    CITY: "Florence",
    STATE: "SC",
    ZIP: "29506",
    STNTYPE: "RAIL",
    STFIPS: 45,
  },
  {
    X: -91.3333589996181,
    Y: 40.623394000432825,
    OBJECTID: 135,
    STNCODE: "FMD",
    STNNAME: "Fort Madison, Iowa",
    ADDRESS1: "1601 20th Street",
    ADDRESS2: "",
    CITY: "Fort Madison",
    STATE: "IA",
    ZIP: "52627",
    STNTYPE: "RAIL",
    STFIPS: 19,
  },
  {
    X: -103.8026500000974,
    Y: 40.24732999977971,
    OBJECTID: 136,
    STNCODE: "FMG",
    STNNAME: "Fort Morgan, Colorado",
    ADDRESS1: "South Ensign St and Main St",
    ADDRESS2: "",
    CITY: "Fort Morgan",
    STATE: "CO",
    ZIP: "80701",
    STNTYPE: "RAIL",
    STFIPS: 8,
  },
  {
    X: -122.0063779998448,
    Y: 37.558196999991594,
    OBJECTID: 137,
    STNCODE: "FMT",
    STNNAME: "Fremont (Trains, Capitol Buses), California",
    ADDRESS1: "37260 Fremont Blvd.",
    ADDRESS2: "",
    CITY: "Fremont",
    STATE: "CA",
    ZIP: "94536",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -119.78224899949169,
    Y: 36.73862799938274,
    OBJECTID: 138,
    STNCODE: "FNO",
    STNNAME: "Fresno, California",
    ADDRESS1: "2650 Tulare St.",
    ADDRESS2: "Santa Fe Station",
    CITY: "Fresno",
    STATE: "CA",
    ZIP: "93721-1325",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -71.97193899998484,
    Y: 41.45766099985531,
    OBJECTID: 139,
    STNCODE: "FOX",
    STNNAME: "Foxwoods Casino, Connecticut",
    ADDRESS1: "39 Norwich Westerley Rd.",
    ADDRESS2: "Foxwoods Resort Casino",
    CITY: "Ledyard",
    STATE: "CT",
    ZIP: "06339-1128",
    STNTYPE: "BUS",
    STFIPS: 9,
  },
  {
    X: -71.41786199923183,
    Y: 42.276668999774586,
    OBJECTID: 140,
    STNCODE: "FRA",
    STNNAME: "Framingham, Massachusetts",
    ADDRESS1: "417 Waverly St.",
    ADDRESS2: "Intersection Route 126 at Route 135",
    CITY: "Framingham",
    STATE: "MA",
    ZIP: "01702-6948",
    STNTYPE: "RAIL",
    STFIPS: 25,
  },
  {
    X: -124.10739626022917,
    Y: 43.96793016264695,
    OBJECTID: 141,
    STNCODE: "FRO",
    STNNAME: "Florence, Oregon",
    ADDRESS1: "290 US Highway 101",
    ADDRESS2: "2nd Street and US 101, east side",
    CITY: "Florence",
    STATE: "OR",
    ZIP: "97439",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -121.92243999970617,
    Y: 37.5399320003616,
    OBJECTID: 142,
    STNCODE: "FRT",
    STNNAME: "Fremont (San Joaquin Buses), California",
    ADDRESS1: "999 Upper Mission Blvd",
    ADDRESS2: "off I-680",
    CITY: "Fremont",
    STATE: "CA",
    ZIP: "94538",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -106.09628299956074,
    Y: 39.58710499989587,
    OBJECTID: 143,
    STNCODE: "FSC",
    STNNAME: "Frisco, Colorado",
    ADDRESS1: "1010 Meadow Drive",
    ADDRESS2: "Frisco Transfer Center",
    CITY: "Frisco",
    STATE: "CO",
    ZIP: "80443",
    STNTYPE: "BUS",
    STFIPS: 8,
  },
  {
    X: -124.15189400010797,
    Y: 40.5974959995408,
    OBJECTID: 144,
    STNCODE: "FTA",
    STNNAME: "Fortuna, California",
    ADDRESS1: "719 South Fortuna Blvd",
    ADDRESS2: "Pepper's Restaurant",
    CITY: "Fortuna",
    STATE: "CA",
    ZIP: "95540",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -73.39063999983608,
    Y: 43.8529930001269,
    OBJECTID: 145,
    STNCODE: "FTC",
    STNNAME: "Ticonderoga, New York",
    ADDRESS1: "NYS Hwy 74 and Sandy Redoubt",
    ADDRESS2: "near Lake Champlain Ferry",
    CITY: "Ticonderoga",
    STATE: "NY",
    ZIP: "12883",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -80.17018900002228,
    Y: 26.119614000785532,
    OBJECTID: 146,
    STNCODE: "FTL",
    STNNAME: "Fort Lauderdale, Florida",
    ADDRESS1: "200 S.W. 21 Terrace",
    ADDRESS2: "",
    CITY: "Fort Lauderdale",
    STATE: "FL",
    ZIP: "33312",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -81.8849029997736,
    Y: 26.682349999752716,
    OBJECTID: 147,
    STNCODE: "FTM",
    STNNAME: "Fort Myers, Florida",
    ADDRESS1: "6050 Plaza Drive",
    ADDRESS2: "Fort Myers Travel Plaza, I-75 exit 139",
    CITY: "Fort Myers",
    STATE: "FL",
    ZIP: "33906-4419",
    STNTYPE: "BUS",
    STFIPS: 12,
  },
  {
    X: -88.88800800036887,
    Y: 36.522521999890444,
    OBJECTID: 148,
    STNCODE: "FTN",
    STNNAME: "Fulton, Kentucky",
    ADDRESS1: "21 Newton Rd.",
    ADDRESS2: "",
    CITY: "Fulton",
    STATE: "KY",
    ZIP: "42041",
    STNTYPE: "RAIL",
    STFIPS: 21,
  },
  {
    X: -97.32386799960847,
    Y: 32.74937400020997,
    OBJECTID: 149,
    STNCODE: "FTW",
    STNNAME: "Fort Worth, Texas",
    ADDRESS1: "1001 Jones Street",
    ADDRESS2: "",
    CITY: "Fort Worth",
    STATE: "TX",
    ZIP: "76102",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -117.92283599988144,
    Y: 33.86894600035771,
    OBJECTID: 150,
    STNCODE: "FUL",
    STNNAME: "Fullerton, California",
    ADDRESS1: "120 East Santa Fe Avenue",
    ADDRESS2: "Fullerton Transportation Center",
    CITY: "Fullerton",
    STATE: "CA",
    ZIP: "92832",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -121.94641099986774,
    Y: 37.3785100000365,
    OBJECTID: 151,
    STNCODE: "GAC",
    STNNAME: "Santa Clara (Great America), California",
    ADDRESS1: "5099 Stars & Stripes Dr.",
    ADDRESS2: "Under Tasman Dr. overpass",
    CITY: "Santa Clara",
    STATE: "CA",
    ZIP: "95054",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -81.16397899943127,
    Y: 35.26835600002943,
    OBJECTID: 152,
    STNCODE: "GAS",
    STNNAME: "Gastonia, North Carolina",
    ADDRESS1: "350 Hancock Street",
    ADDRESS2: "",
    CITY: "Gastonia",
    STATE: "NC",
    ZIP: "28054",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -90.36410499944611,
    Y: 40.944050000007564,
    OBJECTID: 153,
    STNCODE: "GBB",
    STNNAME: "Galesburg, Illinois",
    ADDRESS1: "225 South Seminary Street",
    ADDRESS2: "Amtrak Union Station",
    CITY: "Galesburg",
    STATE: "IL",
    ZIP: "61401",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -123.793899999985,
    Y: 40.101063000457145,
    OBJECTID: 155,
    STNCODE: "GBV",
    STNNAME: "Garberville, California",
    ADDRESS1: "924 Redwood Drive",
    ADDRESS2: "Waterwheel Restaurant",
    CITY: "Garberville",
    STATE: "CA",
    ZIP: "95542",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -112.1387953733078,
    Y: 36.05502922471902,
    OBJECTID: 156,
    STNCODE: "GCB",
    STNNAME: "Grand Canyon (Buses), Arizona",
    ADDRESS1: "Maswik Lodge",
    ADDRESS2: "",
    CITY: "Grand Canyon National Park",
    STATE: "AZ",
    ZIP: "86023",
    STNTYPE: "BUS",
    STFIPS: 4,
  },
  {
    X: -100.87279499968946,
    Y: 37.9647249998589,
    OBJECTID: 157,
    STNCODE: "GCK",
    STNNAME: "Garden City, Kansas",
    ADDRESS1: "100 North 7th Street",
    ADDRESS2: "1 block south of 7th & Fulton (Bus Highway 50)",
    CITY: "Garden City",
    STATE: "KS",
    ZIP: "67846-5547",
    STNTYPE: "RAIL",
    STFIPS: 20,
  },
  {
    X: -112.1349410004268,
    Y: 36.05671699948999,
    OBJECTID: 158,
    STNCODE: "GCN",
    STNNAME: "Grand Canyon (Railway), Arizona",
    ADDRESS1: "Grand Canyon Railway Station",
    ADDRESS2: "downhill from Bright Angel Lodge",
    CITY: "Grand Canyon National Park",
    STATE: "AZ",
    ZIP: "86023",
    STNTYPE: "OTHER",
    STFIPS: 4,
  },
  {
    X: -118.25795700011543,
    Y: 34.12363799949412,
    OBJECTID: 159,
    STNCODE: "GDL",
    STNNAME: "Glendale, California",
    ADDRESS1: "400 West Cerritos Avenue",
    ADDRESS2: "Glendale Transportation Center",
    CITY: "Glendale",
    STATE: "CA",
    ZIP: "91204",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -97.11043499927575,
    Y: 47.91885399951252,
    OBJECTID: 160,
    STNCODE: "GFK",
    STNNAME: "Grand Forks, North Dakota",
    ADDRESS1: "5555 DeMers Avenue",
    ADDRESS2: "",
    CITY: "Grand Forks",
    STATE: "ND",
    ZIP: "58201",
    STNTYPE: "RAIL",
    STFIPS: 38,
  },
  {
    X: -83.24184399970079,
    Y: 42.30490100038094,
    OBJECTID: 161,
    STNCODE: "GFV",
    STNNAME: "Greenfield Village, Michigan",
    ADDRESS1: "20900 Oakwood Blvd.",
    ADDRESS2: "Group travel only - not a regular stop",
    CITY: "Dearborn",
    STATE: "MI",
    ZIP: "48216",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -106.63481100002758,
    Y: 48.1945150006668,
    OBJECTID: 162,
    STNCODE: "GGW",
    STNNAME: "Glasgow, Montana",
    ADDRESS1: "424 1st Avenue South",
    ADDRESS2: "",
    CITY: "Glasgow",
    STATE: "MT",
    ZIP: "59230-2396",
    STNTYPE: "RAIL",
    STFIPS: 30,
  },
  {
    X: -123.91558990824763,
    Y: 46.05870257556347,
    OBJECTID: 163,
    STNCODE: "GHT",
    STNNAME: "Gearhart, Oregon",
    ADDRESS1: "4320 Highway 101, North",
    ADDRESS2: "Gearhart Builders Supply Store",
    CITY: "Gearhart",
    STATE: "OR",
    ZIP: "97301",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -108.5699230002462,
    Y: 39.064819000196735,
    OBJECTID: 164,
    STNCODE: "GJT",
    STNNAME: "Grand Junction, Colorado",
    ADDRESS1: "339 South 1st Street",
    ADDRESS2: "",
    CITY: "Grand Junction",
    STATE: "CO",
    ZIP: "81501-2207",
    STNTYPE: "RAIL",
    STFIPS: 8,
  },
  {
    X: -97.14026599987596,
    Y: 33.62442399986776,
    OBJECTID: 165,
    STNCODE: "GLE",
    STNNAME: "Gainesville, Texas",
    ADDRESS1: "605 East California Street",
    ADDRESS2: "",
    CITY: "Gainesville",
    STATE: "TX",
    ZIP: "76240",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -87.99476600085023,
    Y: 40.76207699985372,
    OBJECTID: 166,
    STNCODE: "GLM",
    STNNAME: "Gilman, Illinois",
    ADDRESS1: "US Hwy 24 & West Wenona St.",
    ADDRESS2: "",
    CITY: "Gilman",
    STATE: "IL",
    ZIP: "60983",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -87.80534399982571,
    Y: 42.07419600034518,
    OBJECTID: 167,
    STNCODE: "GLN",
    STNNAME: "Glenview, Illinois",
    ADDRESS1: "1116 Depot St.",
    ADDRESS2: "",
    CITY: "Glenview",
    STATE: "IL",
    ZIP: "60025",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -108.73967699989362,
    Y: 35.52924699994912,
    OBJECTID: 168,
    STNCODE: "GLP",
    STNNAME: "Gallup, New Mexico",
    ADDRESS1: "201 East Highway 66",
    ADDRESS2: "(Amtrak shares space with Indian Museum)",
    CITY: "Gallup",
    STATE: "NM",
    ZIP: "87301",
    STNTYPE: "RAIL",
    STFIPS: 35,
  },
  {
    X: -94.78607200002273,
    Y: 29.29120800014914,
    OBJECTID: 169,
    STNCODE: "GLS",
    STNNAME: "Galveston (Texas Eagle Bus), Texas",
    ADDRESS1: "25th St. and Strand St.",
    ADDRESS2: "The Railroad Museum",
    CITY: "Galveston",
    STATE: "TX",
    ZIP: "77550",
    STNTYPE: "BUS",
    STFIPS: 48,
  },
  {
    X: -121.5675049994561,
    Y: 37.00598100052281,
    OBJECTID: 171,
    STNCODE: "GLY",
    STNNAME: "Gilroy, California",
    ADDRESS1: "7250 Monterey Street",
    ADDRESS2: "Caltrain Station",
    CITY: "Gilroy",
    STATE: "CA",
    ZIP: "95020",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -79.5472790005254,
    Y: 40.30485199942029,
    OBJECTID: 173,
    STNCODE: "GNB",
    STNNAME: "Greensburg, Pennsylvania",
    ADDRESS1: "Harrison Ave. and Seton Hill Dr.",
    ADDRESS2: "",
    CITY: "Greensburg",
    STATE: "PA",
    ZIP: "15601",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -82.32322177676355,
    Y: 29.652079811933845,
    OBJECTID: 174,
    STNCODE: "GNF",
    STNNAME: "Gainesville, Florida",
    ADDRESS1: "201 East University Ave.",
    ADDRESS2: "",
    CITY: "Gainesville",
    STATE: "FL",
    ZIP: "32601-5457",
    STNTYPE: "BUS",
    STFIPS: 12,
  },
  {
    X: -83.82668299992048,
    Y: 34.283717999985754,
    OBJECTID: 175,
    STNCODE: "GNS",
    STNNAME: "Gainesville, Georgia",
    ADDRESS1: "116 Industrial Boulevard",
    ADDRESS2: "",
    CITY: "Gainesville",
    STATE: "GA",
    ZIP: "30501",
    STNTYPE: "RAIL",
    STFIPS: 13,
  },
  {
    X: -113.21855899999781,
    Y: 48.44396600003091,
    OBJECTID: 176,
    STNCODE: "GPK",
    STNNAME: "East Glacier Park, Montana",
    ADDRESS1: "400 Highway 49 North",
    ADDRESS2: "",
    CITY: "East Glacier Park",
    STATE: "MT",
    ZIP: "59434",
    STNTYPE: "RAIL",
    STFIPS: 30,
  },
  {
    X: -105.9348369999276,
    Y: 40.08391600022327,
    OBJECTID: 177,
    STNCODE: "GRA",
    STNNAME: "Granby, Colorado",
    ADDRESS1: "438 Railroad Avenue",
    ADDRESS2: "",
    CITY: "Granby",
    STATE: "CO",
    ZIP: "80446",
    STNTYPE: "RAIL",
    STFIPS: 8,
  },
  {
    X: -110.16459700055111,
    Y: 38.99244300084388,
    OBJECTID: 178,
    STNCODE: "GRI",
    STNNAME: "Green River, Utah",
    ADDRESS1: "250 South Broadway",
    ADDRESS2: "@ RR Tracks and Airport Rd.",
    CITY: "Green River",
    STATE: "UT",
    ZIP: "84525",
    STNTYPE: "RAIL",
    STFIPS: 49,
  },
  {
    X: -79.83135200019461,
    Y: 36.061202999518855,
    OBJECTID: 179,
    STNCODE: "GRO",
    STNNAME: "Greensboro, North Carolina",
    ADDRESS1: "236 East Washington Street",
    ADDRESS2: "Galyon Transportation Center",
    CITY: "Greensboro",
    STATE: "NC",
    ZIP: "27401-2704",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -85.67899300022674,
    Y: 42.95637099942212,
    OBJECTID: 180,
    STNCODE: "GRR",
    STNNAME: "Grand Rapids, Michigan",
    ADDRESS1: "431 Wealthy St. SW",
    ADDRESS2: "near Market and Wealthy Sts. SW",
    CITY: "Grand Rapids",
    STATE: "MI",
    ZIP: "49503-4061",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -121.05795300063045,
    Y: 39.219382999925585,
    OBJECTID: 181,
    STNCODE: "GRS",
    STNNAME: "Grass Valley, California",
    ADDRESS1: "125 E. Main Street",
    ADDRESS2: "City Hall",
    CITY: "Grass Valley",
    STATE: "CA",
    ZIP: "95945",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -82.41418500013759,
    Y: 34.856560000044,
    OBJECTID: 182,
    STNCODE: "GRV",
    STNNAME: "Greenville, South Carolina",
    ADDRESS1: "1120 West Washington Street",
    ADDRESS2: "near Downtown Greenville",
    CITY: "Greenville",
    STATE: "SC",
    ZIP: "29601",
    STNTYPE: "RAIL",
    STFIPS: 45,
  },
  {
    X: -107.32267800028944,
    Y: 39.54811899979205,
    OBJECTID: 183,
    STNCODE: "GSC",
    STNNAME: "Glenwood Springs, Colorado",
    ADDRESS1: "413 7th Street",
    ADDRESS2: "",
    CITY: "Glenwood Springs",
    STATE: "CO",
    ZIP: "81601",
    STNTYPE: "RAIL",
    STFIPS: 8,
  },
  {
    X: -119.42146282564886,
    Y: 36.3415853550801,
    OBJECTID: 184,
    STNCODE: "GSN",
    STNNAME: "Goshen Junction, California",
    ADDRESS1: "30435 Road 68",
    ADDRESS2: "Greyhound Bus Stop",
    CITY: "Visalia",
    STATE: "CA",
    ZIP: "93227-9585",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -119.84117099984172,
    Y: 34.437557000455286,
    OBJECTID: 185,
    STNCODE: "GTA",
    STNNAME: "Goleta, California",
    ADDRESS1: "25 South La Patera Lane",
    ADDRESS2: "",
    CITY: "Goleta",
    STATE: "CA",
    ZIP: "93117",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -120.57294500051131,
    Y: 34.96260499982094,
    OBJECTID: 186,
    STNCODE: "GUA",
    STNNAME: "Guadalupe, California",
    ADDRESS1: "330 Guadalupe Street",
    ADDRESS2: "Highway-1",
    CITY: "Guadalupe",
    STATE: "CA",
    ZIP: "93434",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -120.62810500004571,
    Y: 35.122066000545544,
    OBJECTID: 188,
    STNCODE: "GVB",
    STNNAME: "Grover Beach, California",
    ADDRESS1: "180 West Grand Avenue",
    ADDRESS2: "",
    CITY: "Grover Beach",
    STATE: "CA",
    ZIP: "93433-1968",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -116.12893699974273,
    Y: 45.92650600025178,
    OBJECTID: 189,
    STNCODE: "GVI",
    STNNAME: "Grangeville, Idaho",
    ADDRESS1: "901 West Main (Highway 95)",
    ADDRESS2: "ZIP TRIP",
    CITY: "Grangeville",
    STATE: "ID",
    ZIP: "83530",
    STNTYPE: "BUS",
    STFIPS: 16,
  },
  {
    X: -90.17608600016871,
    Y: 33.51773800020857,
    OBJECTID: 190,
    STNCODE: "GWD",
    STNNAME: "Greenwood, Mississippi",
    ADDRESS1: "Carrolton Ave. and East Gibbs Street",
    ADDRESS2: "506 Carrolton Ave.?",
    CITY: "Greenwood",
    STATE: "MS",
    ZIP: "38930",
    STNTYPE: "RAIL",
    STFIPS: 28,
  },
  {
    X: -79.69845600054396,
    Y: 34.88307200047251,
    OBJECTID: 191,
    STNCODE: "HAM",
    STNNAME: "Hamlet, North Carolina",
    ADDRESS1: "West Main St. and North Bridges St.",
    ADDRESS2: "",
    CITY: "Hamlet",
    STATE: "NC",
    ZIP: "28345",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -76.87819699999153,
    Y: 40.26156199958666,
    OBJECTID: 192,
    STNCODE: "HAR",
    STNNAME: "Harrisburg, Pennsylvania",
    ADDRESS1: "4th and Chestnut Streets",
    ADDRESS2: "",
    CITY: "Harrisburg",
    STATE: "PA",
    ZIP: "17101",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -98.387329000433,
    Y: 40.58413299933852,
    OBJECTID: 193,
    STNCODE: "HAS",
    STNNAME: "Hastings, Nebraska",
    ADDRESS1: "501 West First St.",
    ADDRESS2: "",
    CITY: "Hastings",
    STATE: "NE",
    ZIP: "68901",
    STNTYPE: "RAIL",
    STFIPS: 31,
  },
  {
    X: -109.67812300027623,
    Y: 48.554416999744774,
    OBJECTID: 194,
    STNCODE: "HAV",
    STNNAME: "Havre, Montana",
    ADDRESS1: "235 Main Street",
    ADDRESS2: "",
    CITY: "Havre",
    STATE: "MT",
    ZIP: "59501-3599",
    STNTYPE: "RAIL",
    STFIPS: 30,
  },
  {
    X: -122.09778600002386,
    Y: 37.66685899994292,
    OBJECTID: 195,
    STNCODE: "HAY",
    STNNAME: "Hayward, California",
    ADDRESS1: "22555 Meekland Avenue",
    ADDRESS2: "Amtrak Rail & Thruway Bus Station",
    CITY: "Hayward",
    STATE: "CA",
    ZIP: "94541",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -90.39427900057535,
    Y: 31.862897999742927,
    OBJECTID: 196,
    STNCODE: "HAZ",
    STNNAME: "Hazlehurst, Mississippi",
    ADDRESS1: "North Ragsdale Ave and East Conway St.",
    ADDRESS2: "",
    CITY: "Hazlehurst",
    STATE: "MS",
    ZIP: "39083",
    STNTYPE: "RAIL",
    STFIPS: 28,
  },
  {
    X: -89.28618600008377,
    Y: 31.326719000581477,
    OBJECTID: 197,
    STNCODE: "HBG",
    STNNAME: "Hattiesburg, Mississippi",
    ADDRESS1: "308 Newman St.",
    ADDRESS2: "308 Newman St.",
    CITY: "Hattiesburg",
    STATE: "MS",
    ZIP: "39401",
    STNTYPE: "RAIL",
    STFIPS: 28,
  },
  {
    X: -122.86949899977901,
    Y: 38.6106679994287,
    OBJECTID: 198,
    STNCODE: "HEA",
    STNNAME: "Healdsburg (Singletree Inn), California",
    ADDRESS1: "165 Healdsburg Ave.",
    ADDRESS2: "",
    CITY: "Healdsburg",
    STATE: "CA",
    ZIP: "95448-4000",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -91.43260199958257,
    Y: 38.707293999218734,
    OBJECTID: 199,
    STNCODE: "HEM",
    STNNAME: "Hermann, Missouri",
    ADDRESS1: "Wharf & Gutenberg Sts.",
    ADDRESS2: "",
    CITY: "Herman",
    STATE: "MO",
    ZIP: "65041",
    STNTYPE: "RAIL",
    STFIPS: 29,
  },
  {
    X: -110.85257699972874,
    Y: 39.68819799973795,
    OBJECTID: 200,
    STNCODE: "HER",
    STNNAME: "Helper, Utah",
    ADDRESS1: "1 Depot Street",
    ADDRESS2: "",
    CITY: "Helper",
    STATE: "UT",
    ZIP: "84526",
    STNTYPE: "RAIL",
    STFIPS: 49,
  },
  {
    X: -117.00584509947174,
    Y: 33.747380230912995,
    OBJECTID: 201,
    STNCODE: "HET",
    STNNAME: "Hemet (West Florida Ave), California",
    ADDRESS1: "3246 West Florida Avenue",
    ADDRESS2: "Coco's Restaurant",
    CITY: "Hemet",
    STATE: "CA",
    ZIP: "92545-3622",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -72.68212099958441,
    Y: 41.7677990000239,
    OBJECTID: 202,
    STNCODE: "HFD",
    STNNAME: "Hartford, Connecticut",
    ADDRESS1: "One Union Place",
    ADDRESS2: "",
    CITY: "Hartford",
    STATE: "CT",
    ZIP: "06103",
    STNTYPE: "RAIL",
    STFIPS: 9,
  },
  {
    X: -77.73355900004776,
    Y: 39.32504299993457,
    OBJECTID: 203,
    STNCODE: "HFY",
    STNNAME: "Harpers Ferry, West Virginia",
    ADDRESS1: "Potomac St. & Shenandoah St.",
    ADDRESS2: "station 1/4 mi (400 m) north",
    CITY: "Harpers Ferry",
    STATE: "WV",
    ZIP: "25425",
    STNTYPE: "RAIL",
    STFIPS: 54,
  },
  {
    X: -78.01183300029271,
    Y: 40.48349400064768,
    OBJECTID: 204,
    STNCODE: "HGD",
    STNNAME: "Huntingdon, Pennsylvania",
    ADDRESS1: "Fourth and Allegheny Sts.",
    ADDRESS2: "",
    CITY: "Huntingdon",
    STATE: "PA",
    ZIP: "16652",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -97.69390100003108,
    Y: 26.193434000179025,
    OBJECTID: 205,
    STNCODE: "HGN",
    STNNAME: "Harlingen, Texas",
    ADDRESS1: "215 E. Monroe Ave.",
    ADDRESS2: "",
    CITY: "Harlingen",
    STATE: "TX",
    ZIP: "78550-5519",
    STNTYPE: "BUS",
    STFIPS: 48,
  },
  {
    X: -71.08594599930836,
    Y: 42.77270799957455,
    OBJECTID: 206,
    STNCODE: "HHL",
    STNNAME: "Haverhill, Massachusetts",
    ADDRESS1: "Washington Street at Railroad Square",
    ADDRESS2: "",
    CITY: "Haverhill",
    STATE: "MA",
    ZIP: "01832-5418",
    STNTYPE: "RAIL",
    STFIPS: 25,
  },
  {
    X: -80.88863400025889,
    Y: 37.677071000526325,
    OBJECTID: 207,
    STNCODE: "HIN",
    STNNAME: "Hinton, West Virginia",
    ADDRESS1: "Front St. and Fifth Ave.",
    ADDRESS2: "",
    CITY: "Hinton",
    STATE: "WV",
    ZIP: "25951",
    STNTYPE: "RAIL",
    STFIPS: 54,
  },
  {
    X: -99.37074300068889,
    Y: 40.43619200016076,
    OBJECTID: 208,
    STNCODE: "HLD",
    STNNAME: "Holdrege, Nebraska",
    ADDRESS1: "100 West Ave.",
    ADDRESS2: "",
    CITY: "Holdrege",
    STATE: "NE",
    ZIP: "68949",
    STNTYPE: "RAIL",
    STFIPS: 31,
  },
  {
    X: -90.46359299991695,
    Y: 30.511697999263333,
    OBJECTID: 209,
    STNCODE: "HMD",
    STNNAME: "Hammond, Louisiana",
    ADDRESS1: "404 N.E. Railroad Ave.",
    ADDRESS2: "",
    CITY: "Hammond",
    STATE: "LA",
    ZIP: "70401",
    STNTYPE: "RAIL",
    STFIPS: 22,
  },
  {
    X: -87.50874300068887,
    Y: 41.69308099968845,
    OBJECTID: 210,
    STNCODE: "HMI",
    STNNAME: "Hammond-Whiting, Indiana",
    ADDRESS1: "1135 South Calumet Ave.",
    ADDRESS2: "",
    CITY: "Hammond",
    STATE: "IN",
    ZIP: "46320-1044",
    STNTYPE: "RAIL",
    STFIPS: 18,
  },
  {
    X: -117.00547799980978,
    Y: 33.7471730001339,
    OBJECTID: 211,
    STNCODE: "HMT",
    STNNAME: "Hemet (Devonshire Ave), California",
    ADDRESS1: "308 East Devonshire Avenue",
    ADDRESS2: "Simpson Senior Center",
    CITY: "Hemet",
    STATE: "CA",
    ZIP: "92543-2906",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -87.66850999933695,
    Y: 41.5623510000986,
    OBJECTID: 212,
    STNCODE: "HMW",
    STNNAME: "Homewood, Illinois",
    ADDRESS1: "18015 Park Ave.",
    ADDRESS2: "",
    CITY: "Homewood",
    STATE: "IL",
    ZIP: "60430",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -119.65077999999698,
    Y: 36.3262140005757,
    OBJECTID: 213,
    STNCODE: "HNF",
    STNNAME: "Hanford, California",
    ADDRESS1: "200 Santa Fe Avenue #A",
    ADDRESS2: "",
    CITY: "Hanford",
    STATE: "CA",
    ZIP: "93230-4554",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -80.16854100046675,
    Y: 26.01068700030487,
    OBJECTID: 214,
    STNCODE: "HOL",
    STNNAME: "Hollywood, Florida",
    ADDRESS1: "3001 Hollywood Blvd",
    ADDRESS2: "",
    CITY: "Hollywood",
    STATE: "FL",
    ZIP: "33021",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -86.09777799965491,
    Y: 42.789314000041145,
    OBJECTID: 215,
    STNCODE: "HOM",
    STNNAME: "Holland, Michigan",
    ADDRESS1: "171 Lincoln Ave.",
    ADDRESS2: "",
    CITY: "Holland",
    STATE: "MI",
    ZIP: "49423",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -121.52261399953642,
    Y: 45.70120999964183,
    OBJECTID: 216,
    STNCODE: "HOO",
    STNNAME: "Hood River, Oregon",
    ADDRESS1: "600 E. Marina Way",
    ADDRESS2: "Greyhound Station",
    CITY: "Hood River",
    STATE: "OR",
    ZIP: "97031",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -95.36697400034979,
    Y: 29.767189000372127,
    OBJECTID: 217,
    STNCODE: "HOS",
    STNNAME: "Houston, Texas",
    ADDRESS1: "902 Washington Ave.",
    ADDRESS2: "",
    CITY: "Houston",
    STATE: "TX",
    ZIP: "77002",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -80.00583599943178,
    Y: 35.95750799929476,
    OBJECTID: 218,
    STNCODE: "HPT",
    STNNAME: "High Point, North Carolina",
    ADDRESS1: "100 West High St",
    ADDRESS2: "",
    CITY: "High Point",
    STATE: "NC",
    ZIP: "27260",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -74.80049000880683,
    Y: 39.63304001918158,
    OBJECTID: 219,
    STNCODE: "HTN",
    STNNAME: "Hammonton, New Jersey",
    ADDRESS1: "Egg Harbor Rd & Line St.",
    ADDRESS2: "New Jersey Transit Station",
    CITY: "Hammonton",
    STATE: "NJ",
    ZIP: "08037",
    STNTYPE: "OTHER",
    STFIPS: 34,
  },
  {
    X: -73.79843899985991,
    Y: 42.2530820002342,
    OBJECTID: 220,
    STNCODE: "HUD",
    STNNAME: "Hudson, New York",
    ADDRESS1: "69 South Front St.",
    ADDRESS2: "",
    CITY: "Hudson",
    STATE: "NY",
    ZIP: "12534",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -119.95948800077059,
    Y: 35.98417699976875,
    OBJECTID: 221,
    STNCODE: "KTC",
    STNNAME: "Kettleman City, California",
    ADDRESS1: "3300 Hubert Way",
    ADDRESS2: "I-5 & Hwy 41 (Carl's Jr Restaurant)",
    CITY: "Kettleman City",
    STATE: "CA",
    ZIP: "93239",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -79.82906299985751,
    Y: 33.66437899969111,
    OBJECTID: 222,
    STNCODE: "KTR",
    STNNAME: "Kingstree, South Carolina",
    ADDRESS1: "101 East Main St.",
    ADDRESS2: "",
    CITY: "Kingstree",
    STATE: "SC",
    ZIP: "29556-3425",
    STNTYPE: "RAIL",
    STFIPS: 45,
  },
  {
    X: -90.4075930003167,
    Y: 38.58088300005045,
    OBJECTID: 223,
    STNCODE: "KWD",
    STNNAME: "Kirkwood, Missouri",
    ADDRESS1: "110 West Argonne Dr.",
    ADDRESS2: "",
    CITY: "Kirkwood",
    STATE: "MO",
    ZIP: "63122-4202",
    STNTYPE: "RAIL",
    STFIPS: 29,
  },
  {
    X: -79.38522299974159,
    Y: 40.31833999999105,
    OBJECTID: 224,
    STNCODE: "LAB",
    STNNAME: "Latrobe, Pennsylvania",
    ADDRESS1: "329 McKinley Ave",
    ADDRESS2: "",
    CITY: "Latrobe",
    STATE: "PA",
    ZIP: "15650",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -118.07801800023049,
    Y: 45.325919999608345,
    OBJECTID: 225,
    STNCODE: "LAE",
    STNNAME: "La Grande, Oregon",
    ADDRESS1: "63276 Oregon Highway 203",
    ADDRESS2: "Flying J Plaza",
    CITY: "La Grande",
    STATE: "OR",
    ZIP: "97850",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -86.89503499926576,
    Y: 40.42108899975756,
    OBJECTID: 226,
    STNCODE: "LAF",
    STNNAME: "Lafayette, Indiana",
    ADDRESS1: "200 North 2nd St.",
    ADDRESS2: "",
    CITY: "Lafayette",
    STATE: "IN",
    ZIP: "47901-1238",
    STNTYPE: "RAIL",
    STFIPS: 18,
  },
  {
    X: -87.86971999987804,
    Y: 41.81590299972373,
    OBJECTID: 227,
    STNCODE: "LAG",
    STNNAME: "La Grange, Illinois",
    ADDRESS1: "25 West Burlington St.",
    ADDRESS2: "",
    CITY: "La Grange",
    STATE: "IL",
    ZIP: "60525",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -103.54249599999036,
    Y: 37.98806799983839,
    OBJECTID: 228,
    STNCODE: "LAJ",
    STNNAME: "La Junta, Colorado",
    ADDRESS1: "1 West First St.",
    ADDRESS2: "",
    CITY: "La Junta",
    STATE: "CO",
    ZIP: "81050",
    STNTYPE: "RAIL",
    STFIPS: 8,
  },
  {
    X: -81.95161400048568,
    Y: 28.04565400083152,
    OBJECTID: 229,
    STNCODE: "LAK",
    STNNAME: "Lakeland, Florida",
    ADDRESS1: "600 East Main Street",
    ADDRESS2: "",
    CITY: "Lakeland",
    STATE: "FL",
    ZIP: "33801-5036",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -92.48530599987197,
    Y: 40.031405999687195,
    OBJECTID: 230,
    STNCODE: "LAP",
    STNNAME: "La Plata, Missouri",
    ADDRESS1: "535 N. Owensby St.",
    ADDRESS2: "R.R. #1",
    CITY: "La Plata",
    STATE: "MO",
    ZIP: "63549",
    STNTYPE: "RAIL",
    STFIPS: 29,
  },
  {
    X: -115.14891390495274,
    Y: 36.09785689388059,
    OBJECTID: 231,
    STNCODE: "LAS",
    STNNAME: "Las Vegas International Airport, Nevada",
    ADDRESS1: "5757 Wayne Newton Blvd",
    ADDRESS2: "McCarran International Airport",
    CITY: "Las Vegas",
    STATE: "NV",
    ZIP: "89111-5000",
    STNTYPE: "BUS",
    STFIPS: 32,
  },
  {
    X: -89.12783800032344,
    Y: 31.692390000398234,
    OBJECTID: 232,
    STNCODE: "LAU",
    STNNAME: "Laurel, Mississippi",
    ADDRESS1: "230 North Maple Street",
    ADDRESS2: "",
    CITY: "Laurel",
    STATE: "MS",
    ZIP: "39440",
    STNTYPE: "RAIL",
    STFIPS: 28,
  },
  {
    X: -118.23653399964434,
    Y: 34.05629700030636,
    OBJECTID: 233,
    STNCODE: "LAX",
    STNNAME: "Los Angeles, California",
    ADDRESS1: "800 North Alameda Street",
    ADDRESS2: "Los Angeles Union Passenger Terminal",
    CITY: "Los Angeles",
    STATE: "CA",
    ZIP: "90012-2902",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -118.18855999964421,
    Y: 33.7741779999148,
    OBJECTID: 234,
    STNCODE: "LBC",
    STNNAME: "Long Beach, California",
    ADDRESS1: "601 North Long Beach Blvd.",
    ADDRESS2: "Denny's Restaurant",
    CITY: "Long Beach",
    STATE: "CA",
    ZIP: "90802-1323",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -118.265327000041,
    Y: 34.230685999659215,
    OBJECTID: 236,
    STNCODE: "LCA",
    STNNAME: "La Crescenta, California",
    ADDRESS1: "Honolulu & Lowell Avenue",
    ADDRESS2: "Near I-210",
    CITY: "La Crescenta",
    STATE: "CA",
    ZIP: "91214",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -93.21499599976556,
    Y: 30.238084999922876,
    OBJECTID: 237,
    STNCODE: "LCH",
    STNNAME: "Lake Charles, Louisiana",
    ADDRESS1: "100 Ryan Street",
    ADDRESS2: "",
    CITY: "Lake Charles",
    STATE: "LA",
    ZIP: "70601-2152",
    STNTYPE: "RAIL",
    STFIPS: 22,
  },
  {
    X: -89.3633039995799,
    Y: 40.147537000532225,
    OBJECTID: 238,
    STNCODE: "LCN",
    STNNAME: "Lincoln, Illinois",
    ADDRESS1: "Broadway and North Chicago Sts.",
    ADDRESS2: "",
    CITY: "Lincoln",
    STATE: "IL",
    ZIP: "62656",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -106.77425167197703,
    Y: 32.30096328033119,
    OBJECTID: 239,
    STNCODE: "LCR",
    STNNAME: "Las Cruces, New Mexico",
    ADDRESS1: "304 Wyatt Drive",
    ADDRESS2: "",
    CITY: "Las Cruces",
    STATE: "NM",
    ZIP: "88005",
    STNTYPE: "BUS",
    STFIPS: 35,
  },
  {
    X: -118.13617699956882,
    Y: 34.695511000732154,
    OBJECTID: 240,
    STNCODE: "LCS",
    STNNAME: "Lancaster, California",
    ADDRESS1: "44812 Sierra Highway",
    ADDRESS2: "Metrolink Station",
    CITY: "Lancaster",
    STATE: "CA",
    ZIP: "93534-3218",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -69.00879930104685,
    Y: 44.28207136450192,
    OBJECTID: 241,
    STNCODE: "LCV",
    STNNAME: "Lincolnville, Maine",
    ADDRESS1: "2512 Atlantic Highway",
    ADDRESS2: "US Post Office",
    CITY: "Lincolnville",
    STATE: "ME",
    ZIP: "04849",
    STNTYPE: "BUS",
    STFIPS: 23,
  },
  {
    X: -108.70632200045992,
    Y: 32.35058999952889,
    OBJECTID: 242,
    STNCODE: "LDB",
    STNNAME: "Lordsburg, New Mexico",
    ADDRESS1: "Center St. and S.P. Blvd.",
    ADDRESS2: "",
    CITY: "Lordsburg",
    STATE: "NM",
    ZIP: "88045",
    STNTYPE: "RAIL",
    STFIPS: 35,
  },
  {
    X: -75.00187699952386,
    Y: 39.83505600023426,
    OBJECTID: 243,
    STNCODE: "LDW",
    STNNAME: "Lindenwold, New Jersey",
    ADDRESS1: "Station Ave & White Horse Rd West",
    ADDRESS2: "NJ Transit/PATCO station",
    CITY: "Somerdale",
    STATE: "NJ",
    ZIP: "08083",
    STNTYPE: "OTHER",
    STFIPS: 34,
  },
  {
    X: -94.37764699990908,
    Y: 38.91294499951215,
    OBJECTID: 245,
    STNCODE: "LEE",
    STNNAME: "Lees Summit, Missouri",
    ADDRESS1: "217 SW Main St.",
    ADDRESS2: "",
    CITY: "Lees Summit",
    STATE: "MO",
    ZIP: "64063",
    STNTYPE: "RAIL",
    STFIPS: 29,
  },
  {
    X: -123.71117399998008,
    Y: 39.85039900001391,
    OBJECTID: 246,
    STNCODE: "LEG",
    STNNAME: "Leggett, California",
    ADDRESS1: "69501 Highway 101 North",
    ADDRESS2: "Price's Peg House",
    CITY: "Leggett",
    STATE: "CA",
    ZIP: "95585-8911",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -120.66032400015246,
    Y: 47.596499999875164,
    OBJECTID: 247,
    STNCODE: "LEV",
    STNNAME: "Leavenworth, Washington",
    ADDRESS1: "Hwy 2 and 12th St.",
    ADDRESS2: "Link Transit Park & Ride",
    CITY: "Leavenworth",
    STATE: "WA",
    ZIP: "98826",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -77.57921600061792,
    Y: 40.58858499959808,
    OBJECTID: 248,
    STNCODE: "LEW",
    STNNAME: "Lewistown, Pennsylvania",
    ADDRESS1: "150 Helen Street",
    ADDRESS2: "",
    CITY: "Lewistown",
    STATE: "PA",
    ZIP: "17044",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -80.2499906583422,
    Y: 35.82148176447191,
    OBJECTID: 249,
    STNCODE: "LEX",
    STNNAME: "Lexington, North Carolina (Special Stop)",
    ADDRESS1: "Center St. and railroad tracks",
    ADDRESS2: "Lexington Barbecue Festival",
    CITY: "Lexington",
    STATE: "NC",
    ZIP: "27292",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -92.0145949998593,
    Y: 30.22734500017168,
    OBJECTID: 250,
    STNCODE: "LFT",
    STNNAME: "Lafayette, Louisiana",
    ADDRESS1: "133 East Grant St.",
    ADDRESS2: "100 Lee Street",
    CITY: "Lafayette",
    STATE: "LA",
    ZIP: "70501",
    STNTYPE: "RAIL",
    STFIPS: 22,
  },
  {
    X: -105.10146300031715,
    Y: 40.1693500001025,
    OBJECTID: 252,
    STNCODE: "LGM",
    STNNAME: "Longmont, Colorado",
    ADDRESS1: "623 Main St.",
    ADDRESS2: "Martha Martin Business Center",
    CITY: "Longmont",
    STATE: "CO",
    ZIP: "80501-4994",
    STNTYPE: "BUS",
    STFIPS: 8,
  },
  {
    X: -115.54862200040498,
    Y: 48.39514899982652,
    OBJECTID: 253,
    STNCODE: "LIB",
    STNNAME: "Libby, Montana",
    ADDRESS1: "100 Mineral Avenue",
    ADDRESS2: "",
    CITY: "Libby",
    STATE: "MT",
    ZIP: "59923-1933",
    STNTYPE: "RAIL",
    STFIPS: 30,
  },
  {
    X: -121.73662600048948,
    Y: 37.70398299961579,
    OBJECTID: 254,
    STNCODE: "LIV",
    STNNAME: "Livermore, California",
    ADDRESS1: "2500 Railroad Avenue",
    ADDRESS2: "(Near 1st Street)",
    CITY: "Livermore",
    STATE: "CA",
    ZIP: "94550-3011",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -81.95188386275004,
    Y: 28.046777659661302,
    OBJECTID: 255,
    STNCODE: "LKL",
    STNNAME: "Lakeland, Florida",
    ADDRESS1: "600 East Main Street",
    ADDRESS2: "",
    CITY: "Lakeland",
    STATE: "FL",
    ZIP: "33801-5036",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -119.79754599984796,
    Y: 36.28665500012818,
    OBJECTID: 256,
    STNCODE: "LMC",
    STNNAME: "Lemoore, California",
    ADDRESS1: "300 E Street",
    ADDRESS2: "Chamber of Commerce",
    CITY: "Lemoore",
    STATE: "CA",
    ZIP: "93245-3663",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -119.9063402046367,
    Y: 36.37851497978255,
    OBJECTID: 257,
    STNCODE: "LMN",
    STNNAME: "Lemoore (Naval Air Station), California",
    ADDRESS1: "25th Ave and Highway 198",
    ADDRESS2: "",
    CITY: "Lemoore",
    STATE: "CA",
    ZIP: "93245",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -102.6182939999681,
    Y: 38.089500000025055,
    OBJECTID: 259,
    STNCODE: "LMR",
    STNNAME: "Lamar, Colorado",
    ADDRESS1: "Main & Beach Streets",
    ADDRESS2: "",
    CITY: "Lamar",
    STATE: "CO",
    ZIP: "81052",
    STNTYPE: "RAIL",
    STFIPS: 8,
  },
  {
    X: -105.88475799998167,
    Y: 35.477485999779105,
    OBJECTID: 260,
    STNCODE: "LMY",
    STNNAME: "Lamy, New Mexico",
    ADDRESS1: "Santa Fe County Road 33",
    ADDRESS2: "152 Old Lamy Trail",
    CITY: "Lamy",
    STATE: "NM",
    ZIP: "87540",
    STNTYPE: "RAIL",
    STFIPS: 35,
  },
  {
    X: -76.30758700033977,
    Y: 40.053805999347446,
    OBJECTID: 261,
    STNCODE: "LNC",
    STNNAME: "Lancaster, Pennsylvania",
    ADDRESS1: "53 McGovern Avenue",
    ADDRESS2: "",
    CITY: "Lancaster",
    STATE: "PA",
    ZIP: "17602",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -96.71081500051184,
    Y: 40.81467100066618,
    OBJECTID: 262,
    STNCODE: "LNK",
    STNNAME: "Lincoln, Nebraska",
    ADDRESS1: "201 North 7th St.",
    ADDRESS2: "",
    CITY: "Lincoln",
    STATE: "NE",
    ZIP: "68508",
    STNTYPE: "RAIL",
    STFIPS: 31,
  },
  {
    X: -71.67631791294127,
    Y: 44.03756098864875,
    OBJECTID: 263,
    STNCODE: "LNN",
    STNNAME: "Lincoln, New Hampshire",
    ADDRESS1: "Main and Franklin Sts.",
    ADDRESS2: "Munce's Konvenience Store/Shell Station",
    CITY: "Lincoln",
    STATE: "NH",
    ZIP: "03251",
    STNTYPE: "BUS",
    STFIPS: 33,
  },
  {
    X: -84.49354600014777,
    Y: 42.719081999734556,
    OBJECTID: 264,
    STNCODE: "LNS",
    STNNAME: "East Lansing, Michigan",
    ADDRESS1: "1240 South Harrison Road",
    ADDRESS2: "",
    CITY: "East Lansing",
    STATE: "MI",
    ZIP: "48823-5223",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -114.5738529995163,
    Y: 35.15706600029574,
    OBJECTID: 265,
    STNCODE: "LNV",
    STNNAME: "Laughlin, Nevada",
    ADDRESS1: "2121 S. Casino Dr.",
    ADDRESS2: "Tropicana Express Hotel & Casino",
    CITY: "Laughlin",
    STATE: "NV",
    ZIP: "89029-1519",
    STNTYPE: "BUS",
    STFIPS: 32,
  },
  {
    X: -121.27159399976324,
    Y: 38.13353999937152,
    OBJECTID: 266,
    STNCODE: "LOD",
    STNNAME: "Lodi, California",
    ADDRESS1: "24 South Sacramento Street",
    ADDRESS2: "",
    CITY: "Lodi",
    STATE: "CA",
    ZIP: "95240",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -120.45683299964321,
    Y: 34.64387900021575,
    OBJECTID: 267,
    STNCODE: "LOM",
    STNNAME: "Lompoc, California",
    ADDRESS1: "111 South I Street",
    ADDRESS2: "Lompoc Visitor's Center",
    CITY: "Lompoc",
    STATE: "CA",
    ZIP: "93436",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -77.22137500035592,
    Y: 38.70596299989256,
    OBJECTID: 268,
    STNCODE: "LOR",
    STNNAME: "Lorton (Auto Train), Virginia",
    ADDRESS1: "8006 Lorton Road",
    ADDRESS2: "",
    CITY: "Lorton",
    STATE: "VA",
    ZIP: "22079",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -73.98454299985951,
    Y: 44.28216900029918,
    OBJECTID: 269,
    STNCODE: "LPD",
    STNNAME: "Lake Placid, New York",
    ADDRESS1: "1 Mirror Lake Drive",
    ADDRESS2: "Hilton Hotel",
    CITY: "Lake Placid",
    STATE: "NY",
    ZIP: "12946-1105",
    STNTYPE: "BUS",
    STFIPS: 36,
  },
  {
    X: -83.30564900040099,
    Y: 43.049628999478784,
    OBJECTID: 270,
    STNCODE: "LPE",
    STNNAME: "Lapeer, Michigan",
    ADDRESS1: "73 Howard St.",
    ADDRESS2: "",
    CITY: "Lapeer",
    STATE: "MI",
    ZIP: "48446-2515",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -121.49914600008782,
    Y: 43.674640999682424,
    OBJECTID: 271,
    STNCODE: "LPN",
    STNNAME: "La Pine, Oregon",
    ADDRESS1: "16515 Reed Road",
    ADDRESS2: "Shell Station",
    CITY: "La Pine",
    STATE: "OR",
    ZIP: "97739",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -120.60251599991341,
    Y: 34.68446000012898,
    OBJECTID: 272,
    STNCODE: "LPS",
    STNNAME: "Lompoc-Surf, California",
    ADDRESS1: "Ocean Ave and Park Rd",
    ADDRESS2: "",
    CITY: "Surf",
    STATE: "CA",
    ZIP: "93437",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -95.23171999987807,
    Y: 38.972217999860845,
    OBJECTID: 273,
    STNCODE: "LRC",
    STNNAME: "Lawrence, Kansas",
    ADDRESS1: "413 East 7th Street",
    ADDRESS2: "",
    CITY: "Lawrence",
    STATE: "KS",
    ZIP: "66044",
    STNTYPE: "RAIL",
    STFIPS: 20,
  },
  {
    X: -92.28637700019834,
    Y: 34.750350999898785,
    OBJECTID: 274,
    STNCODE: "LRK",
    STNNAME: "Little Rock, Arkansas",
    ADDRESS1: "1400 West Markham Street",
    ADDRESS2: "",
    CITY: "Little Rock",
    STATE: "AR",
    ZIP: "72201",
    STNTYPE: "RAIL",
    STFIPS: 5,
  },
  {
    X: -91.2467048319624,
    Y: 43.833214339869926,
    OBJECTID: 275,
    STNCODE: "LSE",
    STNNAME: "LaCrosse, Wisconsin",
    ADDRESS1: "St. Andrew and Caledonia Streets",
    ADDRESS2: "601 St. Andrew Street",
    CITY: "La Crosse",
    STATE: "WI",
    ZIP: "54601",
    STNTYPE: "RAIL",
    STFIPS: 55,
  },
  {
    X: -105.21214299979954,
    Y: 35.59330000039478,
    OBJECTID: 276,
    STNCODE: "LSV",
    STNNAME: "Las Vegas, New Mexico",
    ADDRESS1: "Railroad & Lincoln Streets",
    ADDRESS2: "",
    CITY: "Las Vegas",
    STATE: "NM",
    ZIP: "87701",
    STNTYPE: "RAIL",
    STFIPS: 35,
  },
  {
    X: -71.76908410254924,
    Y: 44.292538624158226,
    OBJECTID: 277,
    STNCODE: "LTL",
    STNNAME: "Littleton, New Hampshire",
    ADDRESS1: "336 Cottage St.",
    ADDRESS2: "Irving Gas Station",
    CITY: "Littleton",
    STATE: "NH",
    ZIP: "03561-4118",
    STNTYPE: "BUS",
    STFIPS: 33,
  },
  {
    X: -117.99193505855607,
    Y: 34.52158708577542,
    OBJECTID: 278,
    STNCODE: "LTR",
    STNNAME: "Littlerock, California",
    ADDRESS1: "7715 Pearblossom Hwy",
    ADDRESS2: "Come & Save Market",
    CITY: "Littlerock",
    STATE: "CA",
    ZIP: "93543-3038",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -123.47941600084772,
    Y: 39.68565400023198,
    OBJECTID: 279,
    STNCODE: "LTV",
    STNNAME: "Laytonville, California",
    ADDRESS1: "44900 Highway 101",
    ADDRESS2: "Park N Takit Market",
    CITY: "Laytonville",
    STATE: "CA",
    ZIP: "95454",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -85.76339700027131,
    Y: 38.25200299983862,
    OBJECTID: 280,
    STNCODE: "LVL",
    STNNAME: "Louisville, Kentucky",
    ADDRESS1: "720 West Muhammad Ali Blvd.",
    ADDRESS2: "Greyhound Station",
    CITY: "Louisville",
    STATE: "KY",
    ZIP: "40203-1917",
    STNTYPE: "BUS",
    STFIPS: 21,
  },
  {
    X: -76.1630099998116,
    Y: 39.509460000378795,
    OBJECTID: 281,
    STNCODE: "ABE",
    STNNAME: "Aberdeen, Maryland",
    ADDRESS1: "18 East Bel Air Ave.",
    ADDRESS2: "",
    CITY: "Aberdeen",
    STATE: "MD",
    ZIP: "21001-3701",
    STNTYPE: "RAIL",
    STFIPS: 24,
  },
  {
    X: -74.50753799987876,
    Y: 39.42869600002041,
    OBJECTID: 282,
    STNCODE: "ABN",
    STNNAME: "Absecon, New Jersey",
    ADDRESS1: "Shore Road and Ohio Ave",
    ADDRESS2: "",
    CITY: "Absecon",
    STATE: "NJ",
    ZIP: "08201",
    STNTYPE: "OTHER",
    STFIPS: 34,
  },
  {
    X: -106.64698000002693,
    Y: 35.08293500005027,
    OBJECTID: 283,
    STNCODE: "ABQ",
    STNNAME: "Albuquerque, New Mexico",
    ADDRESS1: "320 First Street SW",
    ADDRESS2: "",
    CITY: "Albuquerque",
    STATE: "NM",
    ZIP: "87102",
    STNTYPE: "RAIL",
    STFIPS: 35,
  },
  {
    X: -121.81513200014166,
    Y: 38.01808500002278,
    OBJECTID: 284,
    STNCODE: "ACA",
    STNNAME: "Antioch-Pittsburg, California",
    ADDRESS1: "100 I Street",
    ADDRESS2: "",
    CITY: "Antioch",
    STATE: "CA",
    ZIP: "94509-1122",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -74.43986500066922,
    Y: 39.36300300038823,
    OBJECTID: 285,
    STNCODE: "ACY",
    STNNAME: "Atlantic City, New Jersey",
    ADDRESS1: "1 Atlantic City Expressway",
    ADDRESS2: "New Jersey Transit Station",
    CITY: "Atlantic City",
    STATE: "NJ",
    ZIP: "08401-4106",
    STNTYPE: "OTHER",
    STFIPS: 34,
  },
  {
    X: -97.12541200016364,
    Y: 34.17191299988508,
    OBJECTID: 287,
    STNCODE: "ADM",
    STNNAME: "Ardmore, Oklahoma",
    ADDRESS1: "251 East Main St.",
    ADDRESS2: "",
    CITY: "Ardmore",
    STATE: "OK",
    ZIP: "73401-7016",
    STNTYPE: "RAIL",
    STFIPS: 40,
  },
  {
    X: -122.69702100041883,
    Y: 42.18811800004573,
    OBJECTID: 288,
    STNCODE: "AHL",
    STNNAME: "Ashland, Oregon",
    ADDRESS1: "585 Siskiyou Blvd",
    ADDRESS2: "Safeway Market",
    CITY: "Ashland",
    STATE: "OR",
    ZIP: "97520",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -82.63947300037864,
    Y: 38.48092999971976,
    OBJECTID: 289,
    STNCODE: "AKY",
    STNNAME: "Ashland, Kentucky",
    ADDRESS1: "99 15th Street",
    ADDRESS2: "",
    CITY: "Ashland",
    STATE: "KY",
    ZIP: "41101",
    STNTYPE: "RAIL",
    STFIPS: 21,
  },
  {
    X: -73.74125699971074,
    Y: 42.64164700000907,
    OBJECTID: 290,
    STNCODE: "ALB",
    STNNAME: "Albany/Rensselaer, New York",
    ADDRESS1: "525 East St.",
    ADDRESS2: "",
    CITY: "Rensselaer",
    STATE: "NY",
    ZIP: "12144-2310",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -81.09581000073092,
    Y: 40.9217869994705,
    OBJECTID: 291,
    STNCODE: "ALC",
    STNNAME: "Alliance, Ohio",
    ADDRESS1: "820 East Main Street",
    ADDRESS2: "",
    CITY: "Alliance",
    STATE: "OH",
    ZIP: "44601",
    STNTYPE: "RAIL",
    STFIPS: 39,
  },
  {
    X: -80.6446460001128,
    Y: 37.724239000229716,
    OBJECTID: 292,
    STNCODE: "ALD",
    STNNAME: "Alderson, West Virginia",
    ADDRESS1: "1 C&O Plaza on Railroad Plaza",
    ADDRESS2: "",
    CITY: "Alderson",
    STATE: "WV",
    ZIP: "24910",
    STNTYPE: "RAIL",
    STFIPS: 54,
  },
  {
    X: -84.75632499989877,
    Y: 42.247374999656586,
    OBJECTID: 293,
    STNCODE: "ALI",
    STNNAME: "Albion, Michigan",
    ADDRESS1: "300 North Eaton St.",
    ADDRESS2: "",
    CITY: "Albion",
    STATE: "MI",
    ZIP: "49224",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -90.13494899979645,
    Y: 38.904490999959705,
    OBJECTID: 294,
    STNCODE: "ALN",
    STNNAME: "Alton, Illinois",
    ADDRESS1: "3400 College Ave.",
    ADDRESS2: "",
    CITY: "Alton",
    STATE: "IL",
    ZIP: "62002-5000",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -103.6610410006416,
    Y: 30.357159000687375,
    OBJECTID: 295,
    STNCODE: "ALP",
    STNNAME: "Alpine, Texas",
    ADDRESS1: "102 West Holland Ave.",
    ADDRESS2: "",
    CITY: "Alpine",
    STATE: "TX",
    ZIP: "79830",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -78.40099300052651,
    Y: 40.51478200008927,
    OBJECTID: 296,
    STNCODE: "ALT",
    STNNAME: "Altoona, Pennsylvania",
    ADDRESS1: "1231 11th Avenue",
    ADDRESS2: "",
    CITY: "Altoona",
    STATE: "PA",
    ZIP: "16601",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -77.06264500006665,
    Y: 38.80624400006059,
    OBJECTID: 297,
    STNCODE: "ALX",
    STNNAME: "Alexandria, Virginia",
    ADDRESS1: "110 Callahan Drive",
    ADDRESS2: "",
    CITY: "Alexandria",
    STATE: "VA",
    ZIP: "22301-2752",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -123.09964799935562,
    Y: 44.63075600008938,
    OBJECTID: 298,
    STNCODE: "ALY",
    STNNAME: "Albany, Oregon",
    ADDRESS1: "110 10th Ave SW",
    ADDRESS2: "",
    CITY: "Albany",
    STATE: "OR",
    ZIP: "97321-2457",
    STNTYPE: "RAIL",
    STFIPS: 41,
  },
  {
    X: -72.51192500023853,
    Y: 42.37485899974308,
    OBJECTID: 299,
    STNCODE: "AMM",
    STNNAME: "Amherst, Massachusetts",
    ADDRESS1: "13 Railroad St.",
    ADDRESS2: "",
    CITY: "Amherst",
    STATE: "MA",
    ZIP: "01002-2318",
    STNTYPE: "RAIL",
    STFIPS: 25,
  },
  {
    X: -74.20952599952523,
    Y: 42.94747899945634,
    OBJECTID: 300,
    STNCODE: "AMS",
    STNNAME: "Amsterdam, New York",
    ADDRESS1: "Railroad St. & West Main Ave.",
    ADDRESS2: "Route 5 West",
    CITY: "Amsterdam",
    STATE: "NY",
    ZIP: "12010",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -117.88481900039653,
    Y: 33.804259999499436,
    OBJECTID: 301,
    STNCODE: "ANA",
    STNNAME: "Anaheim, California",
    ADDRESS1: "2150 East Katella Avenue",
    ADDRESS2: "",
    CITY: "Anaheim",
    STATE: "CA",
    ZIP: "92806",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -88.40564700000903,
    Y: 44.26594200022316,
    OBJECTID: 302,
    STNCODE: "APP",
    STNNAME: "Appleton, Wisconsin",
    ADDRESS1: "100 East Washington St.",
    ADDRESS2: "Appleton Transit Center",
    CITY: "Appleton",
    STATE: "WI",
    ZIP: "54911-5448",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -83.74402600039957,
    Y: 42.288051999500226,
    OBJECTID: 303,
    STNCODE: "ARB",
    STNNAME: "Ann Arbor, Michigan",
    ADDRESS1: "325 Depot Street",
    ADDRESS2: "",
    CITY: "Ann Arbor",
    STATE: "MI",
    ZIP: "48104",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -124.08393899958514,
    Y: 40.86757300039369,
    OBJECTID: 304,
    STNCODE: "ARC",
    STNNAME: "Arcata (Transit Center), California",
    ADDRESS1: "925 E Street",
    ADDRESS2: "Transit Center",
    CITY: "Arcata",
    STATE: "CA",
    ZIP: "95521-6239",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -75.2894440002404,
    Y: 40.007262999687725,
    OBJECTID: 305,
    STNCODE: "ARD",
    STNNAME: "Ardmore, Pennsylvania",
    ADDRESS1: "Station Road and Lancaster Ave.",
    ADDRESS2: "",
    CITY: "Ardmore",
    STATE: "PA",
    ZIP: "19003",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -93.05244400039027,
    Y: 34.114376000452125,
    OBJECTID: 307,
    STNCODE: "ARK",
    STNNAME: "Arkadelphia, Arkansas",
    ADDRESS1: "798 South 5th St.",
    ADDRESS2: "",
    CITY: "Arkadelphia",
    STATE: "AR",
    ZIP: "71923-6237",
    STNTYPE: "RAIL",
    STFIPS: 5,
  },
  {
    X: -121.08203099943103,
    Y: 38.9041820000993,
    OBJECTID: 308,
    STNCODE: "ARN",
    STNNAME: "Auburn, California",
    ADDRESS1: "277 Nevada St. at Fulweiler St.",
    ADDRESS2: "",
    CITY: "Auburn",
    STATE: "CA",
    ZIP: "95603",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -123.8335530371429,
    Y: 46.18996473278622,
    OBJECTID: 309,
    STNCODE: "ART",
    STNNAME: "Astoria, Oregon (Buses-Transit Center)",
    ADDRESS1: "900 Marine Drive",
    ADDRESS2: "Astoria Intermodal Terminal",
    CITY: "Astoria",
    STATE: "OR",
    ZIP: "97103",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -77.48167399995509,
    Y: 37.75923499979547,
    OBJECTID: 310,
    STNCODE: "ASD",
    STNNAME: "Ashland, Virginia",
    ADDRESS1: "112 North Railroad Avenue",
    ADDRESS2: "",
    CITY: "Ashland",
    STATE: "VA",
    ZIP: "23005",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -120.66551079328843,
    Y: 35.48639537914346,
    OBJECTID: 311,
    STNCODE: "ATA",
    STNNAME: "Atascadero, California",
    ADDRESS1: "6910 El Camino Real",
    ADDRESS2: "Denny's Restaurant",
    CITY: "Atascadero",
    STATE: "CA",
    ZIP: "93422",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -84.39178500007768,
    Y: 33.79956399967887,
    OBJECTID: 312,
    STNCODE: "ATL",
    STNNAME: "Atlanta, Georgia",
    ADDRESS1: "1688 Peachtree Street, NW",
    ADDRESS2: "intersection of Deering Road",
    CITY: "Atlanta",
    STATE: "GA",
    ZIP: "30309",
    STNTYPE: "RAIL",
    STFIPS: 13,
  },
  {
    X: -85.83188599933936,
    Y: 33.64899799995777,
    OBJECTID: 313,
    STNCODE: "ATN",
    STNNAME: "Anniston, Alabama",
    ADDRESS1: "126 West 4th St",
    ADDRESS2: "",
    CITY: "Anniston",
    STATE: "AL",
    ZIP: "36201",
    STNTYPE: "RAIL",
    STFIPS: 1,
  },
  {
    X: -74.89346906614446,
    Y: 39.77452952211979,
    OBJECTID: 314,
    STNCODE: "ATO",
    STNNAME: "Atco, New Jersey",
    ADDRESS1: "Cooper Rd and Raritan Ave",
    ADDRESS2: "New Jersey Transit station",
    CITY: "Atco",
    STATE: "NJ",
    ZIP: "08004",
    STNTYPE: "OTHER",
    STFIPS: 34,
  },
  {
    X: -97.75556900020916,
    Y: 30.269092999942018,
    OBJECTID: 316,
    STNCODE: "AUS",
    STNNAME: "Austin, Texas",
    ADDRESS1: "250 North Lamar Blvd.",
    ADDRESS2: "",
    CITY: "Austin",
    STATE: "TX",
    ZIP: "78703",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -117.81132499984881,
    Y: 44.78205499943874,
    OBJECTID: 317,
    STNCODE: "BAK",
    STNNAME: "Baker City, Oregon",
    ADDRESS1: "515 Campbell Street",
    ADDRESS2: "Baker Truck Corral",
    CITY: "Baker City",
    STATE: "OR",
    ZIP: "97814",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -76.61747700076296,
    Y: 39.30812100018409,
    OBJECTID: 318,
    STNCODE: "BAL",
    STNNAME: "Baltimore (Penn Station), Maryland",
    ADDRESS1: "1515 North Charles Street",
    ADDRESS2: "Penn Station",
    CITY: "Baltimore",
    STATE: "MD",
    ZIP: "21201-5893",
    STNTYPE: "RAIL",
    STFIPS: 24,
  },
  {
    X: -86.11187000020033,
    Y: 42.31418600048357,
    OBJECTID: 319,
    STNCODE: "BAM",
    STNNAME: "Bangor, Michigan",
    ADDRESS1: "541 Railroad St.",
    ADDRESS2: "",
    CITY: "Bangor",
    STATE: "MI",
    ZIP: "49013-1464",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -68.81315624786254,
    Y: 44.81842780619837,
    OBJECTID: 320,
    STNCODE: "BAN",
    STNNAME: "Bangor, Maine",
    ADDRESS1: "1039 Union St.",
    ADDRESS2: "Bangor Transportation Center",
    CITY: "Bangor",
    STATE: "ME",
    ZIP: "04401-3011",
    STNTYPE: "BUS",
    STFIPS: 23,
  },
  {
    X: -117.02535199989484,
    Y: 34.90479999972024,
    OBJECTID: 321,
    STNCODE: "BAR",
    STNNAME: "Barstow (Amtrak), California",
    ADDRESS1: "685 North First Avenue",
    ADDRESS2: "",
    CITY: "Barstow",
    STATE: "CA",
    ZIP: "92311",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -69.82087743014927,
    Y: 43.913471143278684,
    OBJECTID: 323,
    STNCODE: "BAT",
    STNNAME: "Bath, Maine",
    ADDRESS1: "10 State Rd",
    ADDRESS2: "Mail It 4 U - Suite 9, Coastal Plaza",
    CITY: "Bath",
    STATE: "ME",
    ZIP: "04530-6018",
    STNTYPE: "BUS",
    STFIPS: 23,
  },
  {
    X: -71.07635499948361,
    Y: 42.34730499982595,
    OBJECTID: 324,
    STNCODE: "BBY",
    STNNAME: "Boston (Back Bay), Massachusetts",
    ADDRESS1: "145 Dartmouth St.",
    ADDRESS2: "",
    CITY: "Boston",
    STATE: "MA",
    ZIP: "02116-5162",
    STNTYPE: "RAIL",
    STFIPS: 25,
  },
  {
    X: -82.47067299975907,
    Y: 27.490395999575753,
    OBJECTID: 325,
    STNCODE: "BDT",
    STNNAME: "Bradenton, Florida",
    ADDRESS1: "1115 Manatee Avenue West",
    ADDRESS2: "Manatee County Courthouse",
    CITY: "Bradenton",
    STATE: "FL",
    ZIP: "34205-7803",
    STNTYPE: "BUS",
    STFIPS: 12,
  },
  {
    X: -122.50988800063067,
    Y: 48.72048600032872,
    OBJECTID: 327,
    STNCODE: "BEL",
    STNNAME: "Bellingham, Washington",
    ADDRESS1: "401 Harris Avenue",
    ADDRESS2: "",
    CITY: "Bellingham",
    STATE: "WA",
    ZIP: "98225",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -110.29398300021523,
    Y: 31.96816799975346,
    OBJECTID: 328,
    STNCODE: "BEN",
    STNNAME: "Benson, Arizona",
    ADDRESS1: "105 E. 4th Street",
    ADDRESS2: "",
    CITY: "Benson",
    STATE: "AZ",
    ZIP: "85602-6611",
    STNTYPE: "RAIL",
    STFIPS: 4,
  },
  {
    X: -72.76572399956291,
    Y: 41.63552500027862,
    OBJECTID: 329,
    STNCODE: "BER",
    STNNAME: "Berlin, Connecticut",
    ADDRESS1: "51 Depot Road",
    ADDRESS2: "",
    CITY: "Kensington",
    STATE: "CT",
    ZIP: "06037",
    STNTYPE: "RAIL",
    STFIPS: 9,
  },
  {
    X: -88.98913364110462,
    Y: 42.49005782630769,
    OBJECTID: 330,
    STNCODE: "BET",
    STNNAME: "South Beloit, Illinois",
    ADDRESS1: "15766 Manchester Road",
    ADDRESS2: "McDonald?s/BP Amoco Travel Plaza",
    CITY: "South Beloit",
    STATE: "IL",
    ZIP: "61080-9723",
    STNTYPE: "BUS",
    STFIPS: 17,
  },
  {
    X: -119.02246100017499,
    Y: 35.37138000078647,
    OBJECTID: 332,
    STNCODE: "BFD",
    STNNAME: "Bakersfield, California",
    ADDRESS1: "601 Truxtun Ave",
    ADDRESS2: "Off Truxtun Ave and S Street",
    CITY: "Bakersfield",
    STATE: "CA",
    ZIP: "93301-5319",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -69.02155000592796,
    Y: 44.42352001573619,
    OBJECTID: 333,
    STNCODE: "BFT",
    STNNAME: "Belfast, Maine",
    ADDRESS1: "Belmont Ave & US Hwy 1",
    ADDRESS2: "Big Apple Conv Store/CITGO Station",
    CITY: "Belfast",
    STATE: "ME",
    ZIP: "04915",
    STNTYPE: "BUS",
    STFIPS: 23,
  },
  {
    X: -78.87506100066463,
    Y: 42.87848300039019,
    OBJECTID: 334,
    STNCODE: "BFX",
    STNNAME: "Buffalo (Exchange St), New York",
    ADDRESS1: "75 Exchange Street",
    ADDRESS2: "",
    CITY: "Buffalo",
    STATE: "NY",
    ZIP: "14203",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -85.48204800031493,
    Y: 43.698317999775895,
    OBJECTID: 335,
    STNCODE: "BGP",
    STNNAME: "Big Rapids, Michigan",
    ADDRESS1: "14342 Northland Dr.",
    ADDRESS2: "Ferris State Fitness Center",
    CITY: "Big Rapids",
    STATE: "MI",
    ZIP: "49307-2373",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -86.80702999953479,
    Y: 33.51239400018301,
    OBJECTID: 336,
    STNCODE: "BHM",
    STNNAME: "Birmingham, Alabama",
    ADDRESS1: "1819 Morris Ave.",
    ADDRESS2: "",
    CITY: "Birmingham",
    STATE: "AL",
    ZIP: "35203-3109",
    STNTYPE: "RAIL",
    STFIPS: 1,
  },
  {
    X: -71.18725738422086,
    Y: 44.45913183416684,
    OBJECTID: 337,
    STNCODE: "BIN",
    STNNAME: "Berlin, New Hampshire",
    ADDRESS1: "318 Glen Ave",
    ADDRESS2: "Irving Mainway",
    CITY: "Berlin",
    STATE: "NH",
    ZIP: "03570-1900",
    STNTYPE: "BUS",
    STFIPS: 33,
  },
  {
    X: -122.29999499986934,
    Y: 37.86760300057807,
    OBJECTID: 339,
    STNCODE: "BKY",
    STNNAME: "Berkeley, California",
    ADDRESS1: "University Ave. and Third St.",
    ADDRESS2: "Underneath Overpass",
    CITY: "Berkeley",
    STATE: "CA",
    ZIP: "94710",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -105.2811809999032,
    Y: 40.05839499962957,
    OBJECTID: 340,
    STNCODE: "BLD",
    STNNAME: "Boulder, Colorado",
    ADDRESS1: "30th & Diagonal Highway",
    ADDRESS2: "BP/Amoco Gas Station",
    CITY: "Boulder",
    STATE: "CO",
    ZIP: "80302",
    STNTYPE: "BUS",
    STFIPS: 8,
  },
  {
    X: -72.44544999961772,
    Y: 43.13582600036966,
    OBJECTID: 341,
    STNCODE: "BLF",
    STNNAME: "Bellows Falls, Vermont",
    ADDRESS1: "54 Depot St",
    ADDRESS2: "",
    CITY: "Bellows Falls",
    STATE: "VT",
    ZIP: "05101-1356",
    STNTYPE: "RAIL",
    STFIPS: 50,
  },
  {
    X: -83.19529699985662,
    Y: 42.545723000216356,
    OBJECTID: 342,
    STNCODE: "BMM",
    STNNAME: "Birmingham, Michigan",
    ADDRESS1: "449 South Eton St.",
    ADDRESS2: "",
    CITY: "Birmingham",
    STATE: "MI",
    ZIP: "48009-6573",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -94.12296299934292,
    Y: 30.076906000011945,
    OBJECTID: 343,
    STNCODE: "BMT",
    STNNAME: "Beaumont, Texas",
    ADDRESS1: "2555 W. Cedar Street",
    ADDRESS2: "",
    CITY: "Beaumont",
    STATE: "TX",
    ZIP: "77704",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -79.43628700014489,
    Y: 36.09417700026842,
    OBJECTID: 344,
    STNCODE: "BNC",
    STNNAME: "Burlington, North Carolina",
    ADDRESS1: "101 North Main Street",
    ADDRESS2: "",
    CITY: "Burlington",
    STATE: "NC",
    ZIP: "27217",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -121.46909300004188,
    Y: 45.715384999518164,
    OBJECTID: 345,
    STNCODE: "BNG",
    STNNAME: "Bingen-White Salmon, Washington",
    ADDRESS1: "Hwy 14 and Walnut St.",
    ADDRESS2: "",
    CITY: "Bingen",
    STATE: "WA",
    ZIP: "98605",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -88.98403899970003,
    Y: 40.50834700011404,
    OBJECTID: 346,
    STNCODE: "BNL",
    STNNAME: "Bloomington-Normal, Illinois",
    ADDRESS1: "100 East Parkinson St.",
    ADDRESS2: "",
    CITY: "Normal",
    STATE: "IL",
    ZIP: "61761-3015",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -119.05339099929517,
    Y: 43.59040100000618,
    OBJECTID: 347,
    STNCODE: "BNS",
    STNNAME: "Burns, Oregon",
    ADDRESS1: "63 N. Buena Vista",
    ADDRESS2: "Figaro's Italian Kitchen",
    CITY: "Burns",
    STATE: "OR",
    ZIP: "97720",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -116.20610799988424,
    Y: 43.61946900049401,
    OBJECTID: 348,
    STNCODE: "BOI",
    STNNAME: "Boise, Idaho",
    ADDRESS1: "1212 West Bannock St.",
    ADDRESS2: "Greyhound Station",
    CITY: "Boise",
    STATE: "ID",
    ZIP: "83702-5619",
    STNTYPE: "BUS",
    STFIPS: 16,
  },
  {
    X: -71.06214499979188,
    Y: 42.36538900010231,
    OBJECTID: 349,
    STNCODE: "BON",
    STNNAME: "Boston (North Station), Massachusetts",
    ADDRESS1: "100 Legends Way",
    ADDRESS2: "126 Causeway Street",
    CITY: "Boston",
    STATE: "MA",
    ZIP: "02114-1300",
    STNTYPE: "RAIL",
    STFIPS: 25,
  },
  {
    X: -71.05529799970287,
    Y: 42.35152400013254,
    OBJECTID: 350,
    STNCODE: "BOS",
    STNNAME: "Boston (South Station), Massachusetts",
    ADDRESS1: "2 South Station",
    ADDRESS2: "Summer St & Atlantic Ave.",
    CITY: "Boston",
    STATE: "MA",
    ZIP: "02110",
    STNTYPE: "RAIL",
    STFIPS: 25,
  },
  {
    X: -72.55035399983717,
    Y: 42.838696000220295,
    OBJECTID: 351,
    STNCODE: "BRA",
    STNNAME: "Brattleboro, Vermont",
    ADDRESS1: "10 Vernon Rd",
    ADDRESS2: "",
    CITY: "Brattleboro",
    STATE: "VT",
    ZIP: "05301-3389",
    STNTYPE: "RAIL",
    STFIPS: 50,
  },
  {
    X: -90.44212299997645,
    Y: 31.57875799968201,
    OBJECTID: 352,
    STNCODE: "BRH",
    STNNAME: "Brookhaven, Mississippi",
    ADDRESS1: "East Monticello St. and South Railroad Ave.",
    ADDRESS2: "",
    CITY: "Brookhaven",
    STATE: "MS",
    ZIP: "39601",
    STNTYPE: "RAIL",
    STFIPS: 28,
  },
  {
    X: -69.93503178498884,
    Y: 43.90717296615952,
    OBJECTID: 353,
    STNCODE: "BRK",
    STNNAME: "Brunswick, Maine",
    ADDRESS1: "101 Bath Rd.",
    ADDRESS2: "Mobil Mart/Puffin Shop",
    CITY: "Brunswick",
    STATE: "ME",
    ZIP: "04011-2214",
    STNTYPE: "BUS",
    STFIPS: 23,
  },
  {
    X: -91.1019820000692,
    Y: 40.80594300016935,
    OBJECTID: 354,
    STNCODE: "BRL",
    STNNAME: "Burlington, Iowa",
    ADDRESS1: "300 South Main Street",
    ADDRESS2: "",
    CITY: "Burlington",
    STATE: "IA",
    ZIP: "52601",
    STNTYPE: "RAIL",
    STFIPS: 19,
  },
  {
    X: -113.01084100061166,
    Y: 48.533295000563896,
    OBJECTID: 355,
    STNCODE: "BRO",
    STNNAME: "Browning, Montana",
    ADDRESS1: "Heart Butte Rd and Depot Rd.",
    ADDRESS2: "",
    CITY: "Browning",
    STATE: "MT",
    ZIP: "59417",
    STNTYPE: "RAIL",
    STFIPS: 30,
  },
  {
    X: -73.187401000156,
    Y: 41.17674600012788,
    OBJECTID: 356,
    STNCODE: "BRP",
    STNNAME: "Bridgeport, Connecticut",
    ADDRESS1: "525 Water St.",
    ADDRESS2: "Metro North Station",
    CITY: "Bridgeport",
    STATE: "CT",
    ZIP: "06604-4315",
    STNTYPE: "RAIL",
    STFIPS: 9,
  },
  {
    X: -97.49945100006357,
    Y: 25.89988499969303,
    OBJECTID: 357,
    STNCODE: "BSV",
    STNNAME: "Brownsville, Texas",
    ADDRESS1: "1134 E. St. Charles Street",
    ADDRESS2: "",
    CITY: "Brownsville",
    STATE: "TX",
    ZIP: "78520-5042",
    STNTYPE: "BUS",
    STFIPS: 48,
  },
  {
    X: -85.18569199988588,
    Y: 42.316975000495916,
    OBJECTID: 358,
    STNCODE: "BTL",
    STNNAME: "Battle Creek, Michigan",
    ADDRESS1: "104 Capital Ave. S.W.",
    ADDRESS2: "",
    CITY: "Battle Creek",
    STATE: "MI",
    ZIP: "49017-3535",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -91.17659800019749,
    Y: 30.449656999870683,
    OBJECTID: 359,
    STNCODE: "BTR",
    STNNAME: "Baton Rouge, Louisiana",
    ADDRESS1: "1253 Florida St.",
    ADDRESS2: "",
    CITY: "Baton Rouge",
    STATE: "LA",
    ZIP: "70802",
    STNTYPE: "BUS",
    STFIPS: 22,
  },
  {
    X: -78.72660800035891,
    Y: 42.906917999566076,
    OBJECTID: 360,
    STNCODE: "BUF",
    STNNAME: "Buffalo (Depew), New York",
    ADDRESS1: "55 Dick Road",
    ADDRESS2: "",
    CITY: "Depew",
    STATE: "NY",
    ZIP: "14043",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -120.19338200037896,
    Y: 34.61133999974123,
    OBJECTID: 361,
    STNCODE: "BUL",
    STNNAME: "Buellton, California",
    ADDRESS1: "238 E Highway 246",
    ADDRESS2: "Burger King Restaurant",
    CITY: "Buellton",
    STATE: "CA",
    ZIP: "93427",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -118.3559109999926,
    Y: 34.193831999846964,
    OBJECTID: 362,
    STNCODE: "BUR",
    STNNAME: "Burbank (Airport), California",
    ADDRESS1: "3750 Empire Avenue",
    ADDRESS2: "",
    CITY: "Burbank",
    STATE: "CA",
    ZIP: "91505",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -76.69339799991775,
    Y: 39.189551999325374,
    OBJECTID: 364,
    STNCODE: "BWI",
    STNNAME: "BWI Rail Station at Thurgood Marshall Airport, Mar",
    ADDRESS1: "7 Amtrak Way",
    ADDRESS2: "BWI Thurgood Marshall Airport",
    CITY: "BWI Airport",
    STATE: "MD",
    ZIP: "21240-0642",
    STNTYPE: "RAIL",
    STFIPS: 24,
  },
  {
    X: -119.78369975883675,
    Y: 48.10283390965725,
    OBJECTID: 365,
    STNCODE: "BWW",
    STNNAME: "Brewster, Washington",
    ADDRESS1: "405 Highway 97",
    ADDRESS2: "Triangle Texaco",
    CITY: "Brewster",
    STATE: "WA",
    ZIP: "98812",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -85.02664899955164,
    Y: 45.204841999958376,
    OBJECTID: 366,
    STNCODE: "BYC",
    STNNAME: "Boyne City, Michigan",
    ADDRESS1: "1000 East Division St.",
    ADDRESS2: "McDonalds's Restaurant",
    CITY: "Boyne City",
    STATE: "MI",
    ZIP: "49712-9609",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -84.55275000001245,
    Y: 41.48034700011402,
    OBJECTID: 368,
    STNCODE: "BYN",
    STNNAME: "Bryan, Ohio",
    ADDRESS1: "Page and Lynn Street",
    ADDRESS2: "",
    CITY: "Bryan",
    STATE: "OH",
    ZIP: "43506",
    STNTYPE: "RAIL",
    STFIPS: 39,
  },
  {
    X: -80.62615999928448,
    Y: 34.247349000056374,
    OBJECTID: 369,
    STNCODE: "CAM",
    STNNAME: "Camden, South Carolina",
    ADDRESS1: "1060 West Dekalb Street",
    ADDRESS2: "",
    CITY: "Camden",
    STATE: "SC",
    ZIP: "29020",
    STNTYPE: "RAIL",
    STFIPS: 45,
  },
  {
    X: -106.32566113265511,
    Y: 42.8561329167008,
    OBJECTID: 370,
    STNCODE: "CAS",
    STNNAME: "Casper, Wyoming",
    ADDRESS1: "123 West E St.",
    ADDRESS2: "Parkway Plaza Hotel",
    CITY: "Casper",
    STATE: "WY",
    ZIP: "82601-1818",
    STNTYPE: "BUS",
    STFIPS: 56,
  },
  {
    X: -71.12674214403467,
    Y: 43.9783790680396,
    OBJECTID: 371,
    STNCODE: "CAY",
    STNNAME: "Conway, New Hampshire",
    ADDRESS1: "392 West Main St.",
    ADDRESS2: "First Stop Market & Deli",
    CITY: "Conway",
    STATE: "NH",
    ZIP: "03818",
    STNTYPE: "BUS",
    STFIPS: 33,
  },
  {
    X: -123.96221212558908,
    Y: 45.88980436807719,
    OBJECTID: 372,
    STNCODE: "CBO",
    STNNAME: "Cannon Beach, Oregon",
    ADDRESS1: "1170 South Hemlock Street",
    ADDRESS2: "Family Market",
    CITY: "Cannon Beach",
    STATE: "OR",
    ZIP: "97110",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -97.38166000000894,
    Y: 32.34833499986041,
    OBJECTID: 373,
    STNCODE: "CBR",
    STNNAME: "Cleburne, Texas",
    ADDRESS1: "206 North Border St.",
    ADDRESS2: "Cleburne Intermodal Depot",
    CITY: "Cleburne",
    STATE: "TX",
    ZIP: "76031-4236",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -89.01248199924481,
    Y: 43.34066799932879,
    OBJECTID: 374,
    STNCODE: "CBS",
    STNNAME: "Columbus, Wisconsin",
    ADDRESS1: "359 North Ludington Street",
    ADDRESS2: "",
    CITY: "Columbus",
    STATE: "WI",
    ZIP: "53925",
    STNTYPE: "RAIL",
    STFIPS: 55,
  },
  {
    X: -124.21198999973865,
    Y: 43.3666460003127,
    OBJECTID: 375,
    STNCODE: "CBY",
    STNNAME: "Coos Bay, Oregon",
    ADDRESS1: "275 N. Broadway",
    ADDRESS2: "Porter Stages Lines Bus Station",
    CITY: "Coos Bay",
    STATE: "OR",
    ZIP: "97420",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -89.21637000007541,
    Y: 37.724087000414784,
    OBJECTID: 376,
    STNCODE: "CDL",
    STNNAME: "Carbondale, Illinois",
    ADDRESS1: "401 South Illinois St.",
    ADDRESS2: "",
    CITY: "Carbondale",
    STATE: "IL",
    ZIP: "62901",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -69.10786959160833,
    Y: 44.19196853242187,
    OBJECTID: 377,
    STNCODE: "CDN",
    STNNAME: "Camden/Rockport, Maine",
    ADDRESS1: "234 Park St.",
    ADDRESS2: "Maritime Farms",
    CITY: "Rockport",
    STATE: "ME",
    ZIP: "04856-5508",
    STNTYPE: "BUS",
    STFIPS: 23,
  },
  {
    X: -89.13619199976097,
    Y: 38.52777099963197,
    OBJECTID: 378,
    STNCODE: "CEN",
    STNNAME: "Centralia, Illinois",
    ADDRESS1: "108 East Broadway",
    ADDRESS2: "",
    CITY: "Centralia",
    STATE: "IL",
    ZIP: "62801-3272",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -117.3636549993787,
    Y: 46.875927000430806,
    OBJECTID: 379,
    STNCODE: "CFX",
    STNNAME: "Colfax, Washington",
    ADDRESS1: "610 South Main St.",
    ADDRESS2: "Ace Hardware",
    CITY: "Colfax",
    STATE: "WA",
    ZIP: "99111",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -87.63916799970337,
    Y: 41.87873100033545,
    OBJECTID: 380,
    STNCODE: "CHI",
    STNNAME: "Chicago (Union Station), Illinois",
    ADDRESS1: "225 South Canal Street",
    ADDRESS2: "",
    CITY: "Chicago",
    STATE: "IL",
    ZIP: "60606",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -88.24092899967354,
    Y: 40.11619599954582,
    OBJECTID: 381,
    STNCODE: "CHM",
    STNNAME: "Champaign-Urbana, Illlinois",
    ADDRESS1: "45 East University Ave.",
    ADDRESS2: "2nd floor",
    CITY: "Champaign",
    STATE: "IL",
    ZIP: "61820-4046",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -79.99890099978126,
    Y: 32.87553399949451,
    OBJECTID: 382,
    STNCODE: "CHS",
    STNNAME: "Charleston, South Carolina",
    ADDRESS1: "4565 Gaynor Avenue",
    ADDRESS2: "",
    CITY: "North Charleston",
    STATE: "SC",
    ZIP: "29405",
    STNTYPE: "RAIL",
    STFIPS: 45,
  },
  {
    X: -81.64672099937457,
    Y: 38.35198999993861,
    OBJECTID: 383,
    STNCODE: "CHW",
    STNNAME: "Charleston, West Virginia",
    ADDRESS1: "350 MacCorkle Avenue - Southeast",
    ADDRESS2: "",
    CITY: "Charleston",
    STATE: "WV",
    ZIP: "25314",
    STNTYPE: "RAIL",
    STFIPS: 54,
  },
  {
    X: -104.80518299979559,
    Y: 41.121581999509715,
    OBJECTID: 384,
    STNCODE: "CHY",
    STNNAME: "Cheyenne, Wyoming",
    ADDRESS1: "222 Deming Drive",
    ADDRESS2: "Union Bus Station",
    CITY: "Cheyenne",
    STATE: "WY",
    ZIP: "82007",
    STNTYPE: "BUS",
    STFIPS: 56,
  },
  {
    X: -121.84471899938228,
    Y: 39.723309000110305,
    OBJECTID: 385,
    STNCODE: "CIC",
    STNNAME: "Chico, California",
    ADDRESS1: "West 5th and Orange Streets",
    ADDRESS2: "",
    CITY: "Chico",
    STATE: "CA",
    ZIP: "95926",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -84.53652999935997,
    Y: 39.10237900019075,
    OBJECTID: 386,
    STNCODE: "CIN",
    STNNAME: "Cincinnati, Ohio",
    ADDRESS1: "1301 Western Ave.",
    ADDRESS2: "Cincinnati Union Terminal",
    CITY: "Cincinnati",
    STATE: "OH",
    ZIP: "45203-1130",
    STNTYPE: "RAIL",
    STFIPS: 39,
  },
  {
    X: -72.37930299973362,
    Y: 43.3687860000739,
    OBJECTID: 388,
    STNCODE: "CLA",
    STNNAME: "Claremont, New Hampshire",
    ADDRESS1: "Plains Rd. and Maple Ave.",
    ADDRESS2: "",
    CITY: "Claremont",
    STATE: "NH",
    ZIP: "03743",
    STNTYPE: "RAIL",
    STFIPS: 33,
  },
  {
    X: -81.04057300034367,
    Y: 33.99371699944004,
    OBJECTID: 389,
    STNCODE: "CLB",
    STNNAME: "Columbia, South Carolina",
    ADDRESS1: "850 Pulaski Street",
    ADDRESS2: "",
    CITY: "Columbia",
    STATE: "SC",
    ZIP: "29201",
    STNTYPE: "RAIL",
    STFIPS: 45,
  },
  {
    X: -85.40669299938236,
    Y: 44.268393999983175,
    OBJECTID: 390,
    STNCODE: "CLC",
    STNNAME: "Cadillac, Michigan",
    ADDRESS1: "1202 North Mitchell St.",
    ADDRESS2: "Cadillac/ Wexford Transit",
    CITY: "Cadillac",
    STATE: "MI",
    ZIP: "49601-1261",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -81.69817399973027,
    Y: 41.50441699944503,
    OBJECTID: 391,
    STNCODE: "CLE",
    STNNAME: "Cleveland, Ohio",
    ADDRESS1: "200 Cleveland Memorial Shoreway",
    ADDRESS2: "",
    CITY: "Cleveland",
    STATE: "OH",
    ZIP: "44114",
    STNTYPE: "RAIL",
    STFIPS: 39,
  },
  {
    X: -79.83649399989815,
    Y: 37.81177099973189,
    OBJECTID: 392,
    STNCODE: "CLF",
    STNNAME: "Clifton Forge, Virginia",
    ADDRESS1: "400 Ridgeway Street",
    ADDRESS2: "",
    CITY: "Clifton Forge",
    STATE: "VA",
    ZIP: "24422",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -117.71550799959448,
    Y: 34.09452799976742,
    OBJECTID: 393,
    STNCODE: "CLM",
    STNNAME: "Claremont, California",
    ADDRESS1: "200 West First St.",
    ADDRESS2: "Metrolink Station",
    CITY: "Claremont",
    STATE: "CA",
    ZIP: "91711",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -77.99304199978843,
    Y: 38.47292300009644,
    OBJECTID: 394,
    STNCODE: "CLP",
    STNNAME: "Culpeper, Virginia",
    ADDRESS1: "109 South Commerce Street",
    ADDRESS2: "",
    CITY: "Culpeper",
    STATE: "VA",
    ZIP: "22701",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -80.82363899954015,
    Y: 35.2411459997881,
    OBJECTID: 395,
    STNCODE: "CLT",
    STNNAME: "Charlotte, North Carolina",
    ADDRESS1: "1914 North Tryon St.",
    ADDRESS2: "",
    CITY: "Charlotte",
    STATE: "NC",
    ZIP: "28206",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -123.0120769998536,
    Y: 38.79989599960078,
    OBJECTID: 396,
    STNCODE: "CLV",
    STNNAME: "Cloverdale, California",
    ADDRESS1: "Citrus Fair Road and Asti Road",
    ADDRESS2: "Cloverdale Depot Park-N-Ride Lot",
    CITY: "Cloverdale",
    STATE: "CA",
    ZIP: "95425",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -119.03311200031851,
    Y: 34.21646900054401,
    OBJECTID: 397,
    STNCODE: "CML",
    STNNAME: "Camarillo, California (Trains)",
    ADDRESS1: "30 Lewis Road",
    ADDRESS2: "",
    CITY: "Camarillo",
    STATE: "CA",
    ZIP: "93010",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -121.78066300059697,
    Y: 43.21690399991974,
    OBJECTID: 398,
    STNCODE: "CMO",
    STNNAME: "Chemult, Oregon",
    ADDRESS1: "Palmer/Kranz Street and Depot Street",
    ADDRESS2: "Off Highway 97, center of town",
    CITY: "Chemult",
    STATE: "OR",
    ZIP: "97731",
    STNTYPE: "RAIL",
    STFIPS: 41,
  },
  {
    X: -122.19692999991952,
    Y: 39.928477999759934,
    OBJECTID: 399,
    STNCODE: "CNG",
    STNNAME: "Corning, California",
    ADDRESS1: "1081 Solano Street",
    ADDRESS2: "Intermodal Terminal at 3rd Street",
    CITY: "Corning",
    STATE: "CA",
    ZIP: "96021-3235",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -115.14860499952107,
    Y: 36.16681299992007,
    OBJECTID: 400,
    STNCODE: "LVS",
    STNNAME: "Las Vegas (Downtown), Nevada",
    ADDRESS1: "200 South Main St.",
    ADDRESS2: "Greyhound Station",
    CITY: "Las Vegas",
    STATE: "NV",
    ZIP: "89101-6357",
    STNTYPE: "BUS",
    STFIPS: 32,
  },
  {
    X: -94.72526600002584,
    Y: 32.49587200019272,
    OBJECTID: 401,
    STNCODE: "LVW",
    STNNAME: "Longview, Texas",
    ADDRESS1: "905 Pacific Ave.",
    ADDRESS2: "",
    CITY: "Longview",
    STATE: "TX",
    ZIP: "75602",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -117.0053208037121,
    Y: 46.426986119413925,
    OBJECTID: 402,
    STNCODE: "LWN",
    STNNAME: "Lewiston, Idaho",
    ADDRESS1: "1920 Highway 128",
    ADDRESS2: "Shell Dyna Mart",
    CITY: "Lewiston",
    STATE: "ID",
    ZIP: "83501-1617",
    STNTYPE: "BUS",
    STFIPS: 16,
  },
  {
    X: -79.15746299971761,
    Y: 37.40702399925823,
    OBJECTID: 403,
    STNCODE: "LYH",
    STNNAME: "Lynchburg, Virginia",
    ADDRESS1: "825 Kemper St",
    ADDRESS2: "",
    CITY: "Lynchburg",
    STATE: "VA",
    ZIP: "24501-1397",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -90.67227899987591,
    Y: 40.4611320000418,
    OBJECTID: 404,
    STNCODE: "MAC",
    STNNAME: "Macomb, Illinois",
    ADDRESS1: "120 East Calhoun Street",
    ADDRESS2: "Travel Center",
    CITY: "Macomb",
    STATE: "IL",
    ZIP: "61455-7321",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -84.72528100001807,
    Y: 45.78168099997822,
    OBJECTID: 405,
    STNCODE: "MAK",
    STNNAME: "Mackinaw City, Michigan",
    ADDRESS1: "102 South Huron Ave.",
    ADDRESS2: "Village Hall",
    CITY: "Mackinaw City",
    STATE: "MI",
    ZIP: "49701",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -107.87244400009052,
    Y: 48.359881999454785,
    OBJECTID: 406,
    STNCODE: "MAL",
    STNNAME: "Malta, Montana",
    ADDRESS1: "51 South 1st Street East",
    ADDRESS2: "",
    CITY: "Malta",
    STATE: "MT",
    ZIP: "59538-1732",
    STNTYPE: "RAIL",
    STFIPS: 30,
  },
  {
    X: -88.37552600042454,
    Y: 39.48242199997537,
    OBJECTID: 407,
    STNCODE: "MAT",
    STNNAME: "Mattoon, Illinois",
    ADDRESS1: "1718 Broadway Ave.",
    ADDRESS2: "",
    CITY: "Mattoon",
    STATE: "IL",
    ZIP: "61938-3920",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -83.77107200027257,
    Y: 38.65162300040117,
    OBJECTID: 408,
    STNCODE: "MAY",
    STNNAME: "Maysville,  Kentucky",
    ADDRESS1: "West Front St & Rosemary Clooney St",
    ADDRESS2: "",
    CITY: "Maysville",
    STATE: "KY",
    ZIP: "41056",
    STNTYPE: "RAIL",
    STFIPS: 21,
  },
  {
    X: -116.08953900042451,
    Y: 44.92166100005517,
    OBJECTID: 409,
    STNCODE: "MCA",
    STNNAME: "McCall, Idaho",
    ADDRESS1: "147 North 3rd St.",
    ADDRESS2: "Jim's Grocery",
    CITY: "McCall",
    STATE: "ID",
    ZIP: "83638-4408",
    STNTYPE: "BUS",
    STFIPS: 16,
  },
  {
    X: -90.45294200067275,
    Y: 31.249292000325624,
    OBJECTID: 410,
    STNCODE: "MCB",
    STNNAME: "McComb, Mississippi",
    ADDRESS1: "114 Northeast Railroad Ave.",
    ADDRESS2: "",
    CITY: "McComb",
    STATE: "MS",
    ZIP: "39648",
    STNTYPE: "RAIL",
    STFIPS: 28,
  },
  {
    X: -120.4758909998697,
    Y: 37.30704099934269,
    OBJECTID: 411,
    STNCODE: "MCD",
    STNNAME: "Merced, California",
    ADDRESS1: "324 West 24th St",
    ADDRESS2: "",
    CITY: "Merced",
    STATE: "CA",
    ZIP: "95340",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -97.40172599995492,
    Y: 31.437921999900425,
    OBJECTID: 412,
    STNCODE: "MCG",
    STNNAME: "McGregor, Texas",
    ADDRESS1: "1 Amtrak Blvd.",
    ADDRESS2: "",
    CITY: "McGregor",
    STATE: "TX",
    ZIP: "76657",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -86.90521999950334,
    Y: 41.72135899971812,
    OBJECTID: 413,
    STNCODE: "MCI",
    STNNAME: "Michigan City, Indiana",
    ADDRESS1: "100 Washington St.",
    ADDRESS2: "",
    CITY: "Michigan City",
    STATE: "IN",
    ZIP: "46360-3246",
    STNTYPE: "RAIL",
    STFIPS: 18,
  },
  {
    X: -100.62534300077886,
    Y: 40.197563000731975,
    OBJECTID: 414,
    STNCODE: "MCK",
    STNNAME: "McCook, Nebraska",
    ADDRESS1: "101 Norris Ave.",
    ADDRESS2: "",
    CITY: "McCook",
    STATE: "NE",
    ZIP: "69001-3779",
    STNTYPE: "RAIL",
    STFIPS: 31,
  },
  {
    X: -72.80121600041804,
    Y: 41.53899800055734,
    OBJECTID: 415,
    STNCODE: "MDN",
    STNNAME: "Meriden, Connecticut",
    ADDRESS1: "60 State Street",
    ADDRESS2: "",
    CITY: "Meriden",
    STATE: "CT",
    ZIP: "06450",
    STNTYPE: "RAIL",
    STFIPS: 9,
  },
  {
    X: -119.9320679998383,
    Y: 37.559455999594775,
    OBJECTID: 417,
    STNCODE: "MDP",
    STNNAME: "Midpines, California",
    ADDRESS1: "6979 Highway 140",
    ADDRESS2: "Yosemite Bug Youth Hostel",
    CITY: "Midpines",
    STATE: "CA",
    ZIP: "95345",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -120.0189439996658,
    Y: 36.97451799930627,
    OBJECTID: 418,
    STNCODE: "MDR",
    STNNAME: "Madera, California",
    ADDRESS1: "Avenue 15 1/2 at 29th Road",
    ADDRESS2: "",
    CITY: "Madera",
    STATE: "CA",
    ZIP: "93637",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -89.11728699939545,
    Y: 41.5500409998923,
    OBJECTID: 419,
    STNCODE: "MDT",
    STNNAME: "Mendota, Illinois",
    ADDRESS1: "783 Main Street",
    ADDRESS2: "",
    CITY: "Mendota",
    STATE: "IL",
    ZIP: "61342",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -88.69616700020686,
    Y: 32.36382300003146,
    OBJECTID: 420,
    STNCODE: "MEI",
    STNNAME: "Meridian, Mississippi",
    ADDRESS1: "1901 Front Street",
    ADDRESS2: "",
    CITY: "Meridian",
    STATE: "MS",
    ZIP: "39301",
    STNTYPE: "RAIL",
    STFIPS: 28,
  },
  {
    X: -90.05887599992741,
    Y: 35.132431000090605,
    OBJECTID: 421,
    STNCODE: "MEM",
    STNNAME: "Memphis, Tennessee",
    ADDRESS1: "Central Station",
    ADDRESS2: "545 S. Main St",
    CITY: "Memphis",
    STATE: "TN",
    ZIP: "38103",
    STNTYPE: "RAIL",
    STFIPS: 47,
  },
  {
    X: -98.23641199981392,
    Y: 26.20309300044164,
    OBJECTID: 422,
    STNCODE: "MEN",
    STNNAME: "McAllen, Texas",
    ADDRESS1: "1501 West US Hwy 83 Business",
    ADDRESS2: "",
    CITY: "McAllen",
    STATE: "TX",
    ZIP: "78501-5120",
    STNTYPE: "BUS",
    STFIPS: 48,
  },
  {
    X: -74.32785800024647,
    Y: 40.5677530003008,
    OBJECTID: 423,
    STNCODE: "MET",
    STNNAME: "Metropark (Iselin), New Jersey",
    ADDRESS1: "100 Middlesex-Essex Turnpike",
    ADDRESS2: "",
    CITY: "Iselin",
    STATE: "NJ",
    ZIP: "08830-2707",
    STNTYPE: "RAIL",
    STFIPS: 34,
  },
  {
    X: -121.96857500033599,
    Y: 47.85922200059491,
    OBJECTID: 424,
    STNCODE: "MEW",
    STNNAME: "Monroe, Washington",
    ADDRESS1: "118 North Lewis St., Suite 112",
    ADDRESS2: "Behind Chamber of Commerce",
    CITY: "Monroe",
    STATE: "WA",
    ZIP: "98272",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -122.87179335378022,
    Y: 42.324461653282754,
    OBJECTID: 425,
    STNCODE: "MFR",
    STNNAME: "Medford, Oregon",
    ADDRESS1: "200 South Front Street",
    ADDRESS2: "Rogue Valley Transportation District (RVTD)",
    CITY: "Medford",
    STATE: "OR",
    ZIP: "97501",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -94.36684399995062,
    Y: 32.55135000000257,
    OBJECTID: 426,
    STNCODE: "MHL",
    STNNAME: "Marshall, Texas",
    ADDRESS1: "800 North Washington Street - suite 2",
    ADDRESS2: "",
    CITY: "Marshall",
    STATE: "TX",
    ZIP: "75670-5330",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -71.46557121723782,
    Y: 42.9870080650702,
    OBJECTID: 427,
    STNCODE: "MHT",
    STNNAME: "Manchester, New Hampshire",
    ADDRESS1: "119 Canal St.",
    ADDRESS2: "Manchester Transportation Center",
    CITY: "Manchester",
    STATE: "NH",
    ZIP: "03101-2333",
    STNTYPE: "BUS",
    STFIPS: 33,
  },
  {
    X: -80.25807200042243,
    Y: 25.849847999885355,
    OBJECTID: 428,
    STNCODE: "MIA",
    STNNAME: "Miami, Florida",
    ADDRESS1: "8303 NW 37th Ave",
    ADDRESS2: "",
    CITY: "Miami",
    STATE: "FL",
    ZIP: "33147",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -76.73161299954023,
    Y: 40.19294700010403,
    OBJECTID: 429,
    STNCODE: "MID",
    STNNAME: "Middletown, Pennsylvania",
    ADDRESS1: "Union Street and Mill Street",
    ADDRESS2: "",
    CITY: "Middletown",
    STATE: "PA",
    ZIP: "17057",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -95.49013499983033,
    Y: 32.66187999976222,
    OBJECTID: 430,
    STNCODE: "MIN",
    STNNAME: "Mineola, Texas",
    ADDRESS1: "115 East Front St.",
    ADDRESS2: "",
    CITY: "Mineola",
    STATE: "TX",
    ZIP: "75773-2453",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -76.50291400028084,
    Y: 40.108916999320115,
    OBJECTID: 431,
    STNCODE: "MJY",
    STNNAME: "Mount Joy, Pennsylvania",
    ADDRESS1: "East Henry St. and North Market St.",
    ADDRESS2: "",
    CITY: "Mount Joy",
    STATE: "PA",
    ZIP: "17552",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -87.92447571638115,
    Y: 42.941746535474294,
    OBJECTID: 432,
    STNCODE: "MKA",
    STNNAME: "Milwaukee (General Mitchell Intl Airport), Wiscons",
    ADDRESS1: "5601 South 6th Street",
    ADDRESS2: "(South 6th St & Airport Spur Freeway)",
    CITY: "Milwaukee",
    STATE: "WI",
    ZIP: "53221",
    STNTYPE: "RAIL",
    STFIPS: 55,
  },
  {
    X: -87.91648099969836,
    Y: 43.03401600073789,
    OBJECTID: 433,
    STNCODE: "MKE",
    STNNAME: "Milwaukee, Wisconsin",
    ADDRESS1: "433 West St. Paul Ave.",
    ADDRESS2: "",
    CITY: "Milwaukee",
    STATE: "WI",
    ZIP: "53203",
    STNTYPE: "RAIL",
    STFIPS: 55,
  },
  {
    X: -124.11094699950439,
    Y: 40.97550600000193,
    OBJECTID: 434,
    STNCODE: "MKV",
    STNNAME: "McKinleyville (Arcata Airport), California",
    ADDRESS1: "3561 Boeing Ave",
    ADDRESS2: "Arcata Airport Terminal",
    CITY: "McKinleyville",
    STATE: "CA",
    ZIP: "95519-9358",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -90.50573699996255,
    Y: 41.45472699945151,
    OBJECTID: 435,
    STNCODE: "MLI",
    STNNAME: "Moline, Illinois",
    ADDRESS1: "1200 River Drive",
    ADDRESS2: "Centre Station",
    CITY: "Moline",
    STATE: "IL",
    ZIP: "61265-1302",
    STNTYPE: "BUS",
    STFIPS: 17,
  },
  {
    X: -119.24521599961867,
    Y: 47.101944000115566,
    OBJECTID: 436,
    STNCODE: "MLK",
    STNNAME: "Moses Lake, Washington",
    ADDRESS1: "1819 East Kittleson Road",
    ADDRESS2: "Union 76 - Food Mart",
    CITY: "Moses Lake",
    STATE: "WA",
    ZIP: "98837",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -81.32407399971527,
    Y: 38.18070199969759,
    OBJECTID: 438,
    STNCODE: "MNG",
    STNNAME: "Montgomery, West Virginia",
    ADDRESS1: "Third Avenue and Washington Street",
    ADDRESS2: "",
    CITY: "Montgomery",
    STATE: "WV",
    ZIP: "25136",
    STNTYPE: "RAIL",
    STFIPS: 54,
  },
  {
    X: -123.16059978575146,
    Y: 45.659744348323045,
    OBJECTID: 439,
    STNCODE: "MNI",
    STNNAME: "Manning, Oregon",
    ADDRESS1: "47000 Highway 26",
    ADDRESS2: "East of Dairy Queen",
    CITY: "Manning",
    STATE: "OR",
    ZIP: "97106",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -117.00161000040117,
    Y: 46.73004199983848,
    OBJECTID: 440,
    STNCODE: "MOC",
    STNNAME: "Moscow, Idaho",
    ADDRESS1: "120 West 6th St.",
    ADDRESS2: "Royal Motor Inn",
    CITY: "Moscow",
    STATE: "ID",
    ZIP: "83843-2318",
    STNTYPE: "BUS",
    STFIPS: 16,
  },
  {
    X: -120.91159799994773,
    Y: 37.66813999966132,
    OBJECTID: 441,
    STNCODE: "MOD",
    STNNAME: "Modesto, California",
    ADDRESS1: "1700 Held Drive",
    ADDRESS2: "",
    CITY: "Modesto",
    STATE: "CA",
    ZIP: "95355-8301",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -88.10299181701868,
    Y: 30.668932225541823,
    OBJECTID: 443,
    STNCODE: "MOG",
    STNNAME: "Mobile (Greyhound), Alabama",
    ADDRESS1: "2545 Government Blvd.",
    ADDRESS2: "",
    CITY: "Mobile",
    STATE: "AL",
    ZIP: "36606-1631",
    STNTYPE: "BUS",
    STFIPS: 1,
  },
  {
    X: -118.17244700032876,
    Y: 35.052287999591556,
    OBJECTID: 444,
    STNCODE: "MOJ",
    STNNAME: "Mojave, California",
    ADDRESS1: "15900 Sierra Highway",
    ADDRESS2: "Carl's Jr. Restaurant",
    CITY: "Mojave",
    STATE: "CA",
    ZIP: "93501-1516",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -101.2979050003155,
    Y: 48.235733000277776,
    OBJECTID: 445,
    STNCODE: "MOT",
    STNNAME: "Minot, North Dakota",
    ADDRESS1: "400 1st Ave. S.W.",
    ADDRESS2: "",
    CITY: "Minot",
    STATE: "ND",
    ZIP: "58701",
    STNTYPE: "RAIL",
    STFIPS: 38,
  },
  {
    X: -117.29046844826024,
    Y: 33.91683818813192,
    OBJECTID: 446,
    STNCODE: "MOV",
    STNNAME: "Moreno Valley, California",
    ADDRESS1: "2650 East Alessandro Blvd.",
    ADDRESS2: "RTA Bus Stop at Curb",
    CITY: "Riverside",
    STATE: "CA",
    ZIP: "92508-2306",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -118.87695299988098,
    Y: 34.28519399970338,
    OBJECTID: 447,
    STNCODE: "MPK",
    STNNAME: "Moorpark, California",
    ADDRESS1: "300 High Street",
    ADDRESS2: "Amtrak / Metrolink Station",
    CITY: "Moorpark",
    STATE: "CA",
    ZIP: "93021",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -120.7987979998278,
    Y: 37.530312000098775,
    OBJECTID: 448,
    STNCODE: "TRK",
    STNNAME: "Turlock-Denair, California",
    ADDRESS1: "3800 Santa Fe Avenue",
    ADDRESS2: "Corner of Elm Street",
    CITY: "Denair",
    STATE: "CA",
    ZIP: "95316",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -120.18257100005155,
    Y: 39.32791500017714,
    OBJECTID: 449,
    STNCODE: "TRU",
    STNNAME: "Truckee, California",
    ADDRESS1: "10065 Donner Pass Road",
    ADDRESS2: "",
    CITY: "Truckee",
    STATE: "CA",
    ZIP: "96161-0329",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -85.62842103600195,
    Y: 44.764372664267114,
    OBJECTID: 450,
    STNCODE: "TRV",
    STNNAME: "Traverse City, Michigan",
    ADDRESS1: "107 Hall Street",
    ADDRESS2: "",
    CITY: "Traverse City",
    STATE: "MI",
    ZIP: "49684-2215",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -112.12273552392526,
    Y: 36.035344263027355,
    OBJECTID: 451,
    STNCODE: "TSY",
    STNNAME: "Tusayan(Grand Canyon Village), Arizona",
    ADDRESS1: "Arizona Hwy 64",
    ADDRESS2: "Grand Canyon Village/IMAX Theatre",
    CITY: "Tusayan",
    STATE: "AZ",
    ZIP: "86023",
    STNTYPE: "BUS",
    STFIPS: 4,
  },
  {
    X: -122.24258061580275,
    Y: 47.461120724741704,
    OBJECTID: 452,
    STNCODE: "TUK",
    STNNAME: "Tukwila, Washington",
    ADDRESS1: "7301 South 158th St.",
    ADDRESS2: "Sounder Commuter Rail Station",
    CITY: "Tukwila",
    STATE: "WA",
    ZIP: "98188",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -73.4474559992949,
    Y: 44.696990999535046,
    OBJECTID: 618,
    STNCODE: "PLB",
    STNNAME: "Plattsburgh, New York",
    ADDRESS1: "Bridge and Dock Sts.",
    ADDRESS2: "",
    CITY: "Plattsburgh",
    STATE: "NY",
    ZIP: "12901",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -88.53835837154156,
    Y: 41.661990362765096,
    OBJECTID: 619,
    STNCODE: "PLO",
    STNNAME: "Plano, Illinois",
    ADDRESS1: "101 West Main Street",
    ADDRESS2: "",
    CITY: "Plano",
    STATE: "IL",
    ZIP: "60545",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -118.12789900003878,
    Y: 34.579143999795804,
    OBJECTID: 620,
    STNCODE: "PMD",
    STNNAME: "Palmdale (Amtrak Thruway), California",
    ADDRESS1: "39000 Clock Tower Plaza Drive - Bus Bay 2E",
    ADDRESS2: "Palmdale Transportation Center-San Joaquin Buses",
    CITY: "Palmdale",
    STATE: "CA",
    ZIP: "93550-4513",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -71.68733074811547,
    Y: 43.75859785950365,
    OBJECTID: 622,
    STNCODE: "PMO",
    STNNAME: "Plymouth, New Hampshire",
    ADDRESS1: "83 Main St.",
    ADDRESS2: "Chase Street Market",
    CITY: "Plymouth",
    STATE: "NH",
    ZIP: "03264-1548",
    STNTYPE: "BUS",
    STFIPS: 33,
  },
  {
    X: -83.29201411805707,
    Y: 42.633720205523105,
    OBJECTID: 624,
    STNCODE: "PNT",
    STNNAME: "Pontiac, Michigan",
    ADDRESS1: "51000 Woodward Avenue",
    ADDRESS2: "",
    CITY: "Pontiac",
    STATE: "MI",
    ZIP: "48342",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -89.46913900046445,
    Y: 43.54661199964414,
    OBJECTID: 625,
    STNCODE: "POG",
    STNNAME: "Portage, Wisconsin",
    ADDRESS1: "400 West Oneida Street",
    ADDRESS2: "",
    CITY: "Portage",
    STATE: "WI",
    ZIP: "53901",
    STNTYPE: "RAIL",
    STFIPS: 55,
  },
  {
    X: -73.4619290003231,
    Y: 44.03306599989605,
    OBJECTID: 626,
    STNCODE: "POH",
    STNNAME: "Port Henry, New York",
    ADDRESS1: "20 Park Place",
    ADDRESS2: "Senior Citizen Center",
    CITY: "Port Henry",
    STATE: "NY",
    ZIP: "12974-1324",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -88.63649699953686,
    Y: 40.879439999956105,
    OBJECTID: 627,
    STNCODE: "PON",
    STNNAME: "Pontiac, Illinois",
    ADDRESS1: "721 West Washington St.",
    ADDRESS2: "",
    CITY: "Pontiac",
    STATE: "IL",
    ZIP: "61764",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -70.2904930001518,
    Y: 43.6520130002998,
    OBJECTID: 628,
    STNCODE: "POR",
    STNNAME: "Portland, Maine",
    ADDRESS1: "100 Thompson's Point Road",
    ADDRESS2: "Portland Transportation Center",
    CITY: "Portland",
    STATE: "ME",
    ZIP: "04102-2630",
    STNTYPE: "RAIL",
    STFIPS: 23,
  },
  {
    X: -117.7506329997131,
    Y: 34.059395000179165,
    OBJECTID: 629,
    STNCODE: "POS",
    STNNAME: "Pomona (Sunset Ltd), California",
    ADDRESS1: "100 West Commercial Street",
    ADDRESS2: "",
    CITY: "Pomona",
    STATE: "CA",
    ZIP: "91768",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -73.93901100005758,
    Y: 41.705672999409444,
    OBJECTID: 630,
    STNCODE: "POU",
    STNNAME: "Poughkeepsie, New York",
    ADDRESS1: "41 Main St.",
    ADDRESS2: "Amtrak/Metro-North Station",
    CITY: "Poughkeepsie",
    STATE: "NY",
    ZIP: "12601-2909",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -120.6869349997504,
    Y: 35.62292499958909,
    OBJECTID: 631,
    STNCODE: "PRB",
    STNNAME: "Paso Robles, California",
    ADDRESS1: "800 Pine Street",
    ADDRESS2: "Paso Robles Intermodal Station",
    CITY: "Paso Robles",
    STATE: "CA",
    ZIP: "93446-2856",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -81.05422200024509,
    Y: 37.858707000427785,
    OBJECTID: 632,
    STNCODE: "PRC",
    STNNAME: "Prince, West Virginia (Beckley)",
    ADDRESS1: "Hwy 41 and County Road 25",
    ADDRESS2: "near Depot Rd",
    CITY: "Prince",
    STATE: "WV",
    ZIP: "25907",
    STNTYPE: "RAIL",
    STFIPS: 54,
  },
  {
    X: -117.21663699959782,
    Y: 33.79139299968722,
    OBJECTID: 633,
    STNCODE: "PRI",
    STNNAME: "Perris, California",
    ADDRESS1: "1688-J North Perris Blvd",
    ADDRESS2: "International House of Pancakes",
    CITY: "Perris",
    STATE: "CA",
    ZIP: "92571-4702",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -73.44427500009112,
    Y: 44.5780409999922,
    OBJECTID: 634,
    STNCODE: "PRK",
    STNNAME: "Port Kent, New York",
    ADDRESS1: "Hwy 373 & Back Rd",
    ADDRESS2: "near Burlington-Fort Kent ferry dock",
    CITY: "Port Kent",
    STATE: "NY",
    ZIP: "12975",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -111.66272000002795,
    Y: 40.225868000208095,
    OBJECTID: 635,
    STNCODE: "PRO",
    STNNAME: "Provo, Utah",
    ADDRESS1: "300 West 600 South",
    ADDRESS2: "",
    CITY: "Provo",
    STATE: "UT",
    ZIP: "84601-4542",
    STNTYPE: "RAIL",
    STFIPS: 49,
  },
  {
    X: -119.08424400026036,
    Y: 46.23359699930211,
    OBJECTID: 636,
    STNCODE: "PSC",
    STNNAME: "Pasco, Washington",
    ADDRESS1: "535 North 1st Avenue",
    ADDRESS2: "Pasco Intermodal Train Station",
    CITY: "Pasco",
    STATE: "WA",
    ZIP: "99301-5378",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -84.963706999978,
    Y: 45.37390900030016,
    OBJECTID: 637,
    STNCODE: "PSK",
    STNNAME: "Petoskey, Michigan",
    ADDRESS1: "301 West Mitchell St.",
    ADDRESS2: "The Book Stop",
    CITY: "Petosky",
    STATE: "MI",
    ZIP: "49770-2327",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -116.5450129992505,
    Y: 33.89594299976966,
    OBJECTID: 638,
    STNCODE: "PSN",
    STNNAME: "Palm Springs (Train), California",
    ADDRESS1: "Indian Ave. and Palm Springs Station Rd.",
    ADDRESS2: "0.6 mi/0.965 km south of I-10",
    CITY: "North Palm Springs",
    STATE: "CA",
    ZIP: "92258",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -116.54491400008101,
    Y: 33.826698000012755,
    OBJECTID: 639,
    STNCODE: "PSP",
    STNNAME: "Palm Springs (Buses), California",
    ADDRESS1: "3400 East Tahquitz Canyon Way",
    ADDRESS2: "Sunline Bus Stop/Palm Springs Airport",
    CITY: "Palm Springs",
    STATE: "CA",
    ZIP: "92262-6970",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -84.78458399995162,
    Y: 45.550639999736234,
    OBJECTID: 640,
    STNCODE: "PST",
    STNNAME: "Pellston, Michigan",
    ADDRESS1: "110 North US Highway 131",
    ADDRESS2: "General Store/Amoco Station",
    CITY: "Pellston",
    STATE: "MI",
    ZIP: "49769-9333",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -77.42897000036521,
    Y: 37.24161900051649,
    OBJECTID: 641,
    STNCODE: "PTB",
    STNNAME: "Petersburg, Virginia",
    ADDRESS1: "3516 South Street",
    ADDRESS2: "Ettrick Station",
    CITY: "Petersburg",
    STATE: "VA",
    ZIP: "23803-1642",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -122.63048599972905,
    Y: 38.24300799961952,
    OBJECTID: 642,
    STNCODE: "PTC",
    STNNAME: "Petaluma, California",
    ADDRESS1: "100 Fairgrounds Drive",
    ADDRESS2: "Regional Library",
    CITY: "Petaluma",
    STATE: "CA",
    ZIP: "94952",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -119.90366000820279,
    Y: 48.0523548427019,
    OBJECTID: 643,
    STNCODE: "PTE",
    STNNAME: "Pateros, Washington",
    ADDRESS1: "245 Lakeshore Drive",
    ADDRESS2: "Super Stop Convenience Store",
    CITY: "Pateros",
    STATE: "WA",
    ZIP: "98846",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -82.44181100067709,
    Y: 42.960788999912495,
    OBJECTID: 644,
    STNCODE: "PTH",
    STNNAME: "Port Huron, Michigan",
    ADDRESS1: "2223 16th Street",
    ADDRESS2: "",
    CITY: "Port Huron",
    STATE: "MI",
    ZIP: "48060",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -104.61505900057239,
    Y: 38.307827000315854,
    OBJECTID: 645,
    STNCODE: "PUB",
    STNNAME: "Pueblo, Colorado",
    ADDRESS1: "1080 Chinook Lane",
    ADDRESS2: "",
    CITY: "Pueblo",
    STATE: "CO",
    ZIP: "81001",
    STNTYPE: "BUS",
    STFIPS: 8,
  },
  {
    X: -117.17374400008549,
    Y: 46.73877000033531,
    OBJECTID: 646,
    STNCODE: "PUL",
    STNNAME: "Pullman, Washington",
    ADDRESS1: "1002 Northwest Nye St.",
    ADDRESS2: "Northwestern Stage Lines Depot",
    CITY: "Pullman",
    STATE: "WA",
    ZIP: "99163-3429",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -97.35633899964506,
    Y: 35.011974000299915,
    OBJECTID: 647,
    STNCODE: "PUR",
    STNNAME: "Purcell, Oklahoma",
    ADDRESS1: "East Main St and North Santa Fe Ave.",
    ADDRESS2: "",
    CITY: "Purcell",
    STATE: "OK",
    ZIP: "73080",
    STNTYPE: "RAIL",
    STFIPS: 40,
  },
  {
    X: -71.41599299937741,
    Y: 41.82563000042421,
    OBJECTID: 648,
    STNCODE: "PVD",
    STNNAME: "Providence, Rhode Island",
    ADDRESS1: "100 Gaspee Street",
    ADDRESS2: "",
    CITY: "Providence",
    STATE: "RI",
    ZIP: "02903",
    STNTYPE: "RAIL",
    STFIPS: 44,
  },
  {
    X: -97.21900200024209,
    Y: 34.741467000301895,
    OBJECTID: 649,
    STNCODE: "PVL",
    STNNAME: "Pauls Valley, Oklahoma",
    ADDRESS1: "East Paul Ave. and South Santa Fe St.",
    ADDRESS2: "1 Santa Fe Plaza",
    CITY: "Pauls Valley",
    STATE: "OK",
    ZIP: "73075",
    STNTYPE: "RAIL",
    STFIPS: 40,
  },
  {
    X: -112.11127499994126,
    Y: 33.55594299936996,
    OBJECTID: 650,
    STNCODE: "PXN",
    STNNAME: "Phoenix (Metro Center Transit Station), Arizona",
    ADDRESS1: "9617 North Metro Parkway West",
    ADDRESS2: "North Phoenix",
    CITY: "Phoenix",
    STATE: "AZ",
    ZIP: "85023",
    STNTYPE: "BUS",
    STFIPS: 4,
  },
  {
    X: -77.29304500042639,
    Y: 38.522011000207556,
    OBJECTID: 651,
    STNCODE: "QAN",
    STNNAME: "Quantico, Virginia",
    ADDRESS1: "550 Railroad Avenue",
    ADDRESS2: "at Potomac Ave. inside Marine Corp base",
    CITY: "Quantico",
    STATE: "VA",
    ZIP: "22134-3444",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -91.36634800016003,
    Y: 39.9574429999945,
    OBJECTID: 652,
    STNCODE: "QCY",
    STNNAME: "Quincy, Illinois",
    ADDRESS1: "North 30th St. and Wisman Lane",
    ADDRESS2: "",
    CITY: "Quincy",
    STATE: "IL",
    ZIP: "62301",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -119.85018199989935,
    Y: 47.23968899944782,
    OBJECTID: 653,
    STNCODE: "QUC",
    STNNAME: "Quincy, Washington",
    ADDRESS1: "102 B St NE",
    ADDRESS2: "Kissel's Variety Store",
    CITY: "Quincy",
    STATE: "WA",
    ZIP: "98848-1117",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -104.43752300088573,
    Y: 36.90074900046608,
    OBJECTID: 654,
    STNCODE: "RAT",
    STNNAME: "Raton, New Mexico",
    ADDRESS1: "201 South First Street",
    ADDRESS2: "(At Cook Ave)",
    CITY: "Raton",
    STATE: "NM",
    ZIP: "87740-3903",
    STNTYPE: "RAIL",
    STFIPS: 35,
  },
  {
    X: -122.21096799977335,
    Y: 40.186008000269055,
    OBJECTID: 656,
    STNCODE: "RBF",
    STNNAME: "Red Bluff, California",
    ADDRESS1: "228 S. Main Street",
    ADDRESS2: "Amtrak Thruway Bus Stop at Taco Bell",
    CITY: "Red Bluff",
    STATE: "CA",
    ZIP: "96080-3802",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -88.97989700024635,
    Y: 42.26813900031465,
    OBJECTID: 657,
    STNCODE: "RCK",
    STNNAME: "Rockford, Illinois",
    ADDRESS1: "7559 Walton St.",
    ADDRESS2: "Van Galder Bus Station",
    CITY: "Rockford",
    STATE: "IL",
    ZIP: "61108-4606",
    STNTYPE: "BUS",
    STFIPS: 17,
  },
  {
    X: -122.39192199970051,
    Y: 40.58283200049647,
    OBJECTID: 658,
    STNCODE: "RDD",
    STNNAME: "Redding (Amtrak Station), California",
    ADDRESS1: "1620 Yuba Street",
    ADDRESS2: "",
    CITY: "Redding",
    STATE: "CA",
    ZIP: "96001-1712",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -121.16291078210685,
    Y: 44.25387058206178,
    OBJECTID: 659,
    STNCODE: "RDM",
    STNNAME: "Redmond Airport, Oregon",
    ADDRESS1: "2300 Redmond Airport Way",
    ADDRESS2: "Redmond Airport",
    CITY: "Redmond",
    STATE: "OR",
    ZIP: "97756",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -122.39250743497013,
    Y: 40.58295717983003,
    OBJECTID: 660,
    STNCODE: "RDR",
    STNNAME: "Redding (RABA Transit Center), California",
    ADDRESS1: "1530 Yuba Street",
    ADDRESS2: "",
    CITY: "Redding",
    STATE: "CA",
    ZIP: "96001-1008",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -124.09996000005395,
    Y: 40.484577000228455,
    OBJECTID: 661,
    STNCODE: "RDS",
    STNNAME: "Rio Dell-Scotia, California",
    ADDRESS1: "100 Main Street",
    ADDRESS2: "Scotia Inn",
    CITY: "Scotia",
    STATE: "CA",
    ZIP: "95565",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -92.54183999981609,
    Y: 44.56454099976736,
    OBJECTID: 662,
    STNCODE: "RDW",
    STNNAME: "Red Wing, Minnesota",
    ADDRESS1: "420 Levee Street",
    ADDRESS2: "",
    CITY: "Red Wing",
    STATE: "MN",
    ZIP: "55066",
    STNTYPE: "RAIL",
    STFIPS: 27,
  },
  {
    X: -121.18579900032358,
    Y: 44.24793999923162,
    OBJECTID: 663,
    STNCODE: "RED",
    STNNAME: "Redmond, Oregon",
    ADDRESS1: "2456 South Highway 97",
    ADDRESS2: "McDonald's Restaurant",
    CITY: "Redmond",
    STATE: "OR",
    ZIP: "97756",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -85.51007100027641,
    Y: 43.87459900004387,
    OBJECTID: 664,
    STNCODE: "REE",
    STNNAME: "Reed City, Michigan",
    ADDRESS1: "US 10 & 220th Ave.",
    ADDRESS2: "McDonald's Restaurant",
    CITY: "Reed City",
    STATE: "MI",
    ZIP: "49677-1119",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -87.154479999952,
    Y: 40.94303900014978,
    OBJECTID: 665,
    STNCODE: "REN",
    STNNAME: "Rensselaer, Indiana",
    ADDRESS1: "619 North Cullen Street",
    ADDRESS2: "",
    CITY: "Rensselaer",
    STATE: "IN",
    ZIP: "47978",
    STNTYPE: "RAIL",
    STFIPS: 18,
  },
  {
    X: -78.64448499938317,
    Y: 35.77374999956288,
    OBJECTID: 666,
    STNCODE: "RGH",
    STNNAME: "Raleigh, North Carolina",
    ADDRESS1: "320 West Cabarrus Street",
    ADDRESS2: "",
    CITY: "Raleigh",
    STATE: "NC",
    ZIP: "27601",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -120.64143499962552,
    Y: 47.60528999963384,
    OBJECTID: 862,
    STNCODE: "LWA",
    STNNAME: "Leavenworth, WA",
    ADDRESS1: "11645 North Rd",
    ADDRESS2: "Icicle Station",
    CITY: "Leavenworth",
    STATE: "WA",
    ZIP: "98826",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -76.21458071692649,
    Y: 43.0726713569976,
    OBJECTID: 863,
    STNCODE: "NYF",
    STNNAME: "Syracuse, NY",
    ADDRESS1: "581 State Fair Blvd",
    ADDRESS2: "Gate 11",
    CITY: "Syracuse",
    STATE: "NY",
    ZIP: "13209",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -75.1025093576207,
    Y: 38.33612994574048,
    OBJECTID: 864,
    STNCODE: "OCM",
    STNNAME: "Ocean City, MD",
    ADDRESS1: "12848 Ocean Gateway",
    ADDRESS2: "West Ocean City Park",
    CITY: "Ocean City",
    STATE: "MD",
    ZIP: "21842",
    STNTYPE: "BUS",
    STFIPS: 24,
  },
  {
    X: -116.39966261593696,
    Y: 33.72489156349491,
    OBJECTID: 865,
    STNCODE: "PDC",
    STNNAME: "Palm Desert, CA",
    ADDRESS1: "44449 Towne Center Way",
    ADDRESS2: "Sunline Transit Stop",
    CITY: "Palm Desert",
    STATE: "CA",
    ZIP: "92260",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -89.16482399992759,
    Y: 44.82698000002705,
    OBJECTID: 866,
    STNCODE: "WIT",
    STNNAME: "Wittenberg, WI",
    ADDRESS1: "505 Grand Avenue",
    ADDRESS2: "Wittenberg Shell",
    CITY: "Wittenberg",
    STATE: "WI",
    ZIP: "54499",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -77.87345600958713,
    Y: 34.25052656474924,
    OBJECTID: 867,
    STNCODE: "WMN",
    STNNAME: "Wilmington, NC",
    ADDRESS1: "505 Cando St",
    ADDRESS2: "WAAVE Forden Station Transit Center",
    CITY: "Wilmington",
    STATE: "NC",
    ZIP: "28405",
    STNTYPE: "BUS",
    STFIPS: 37,
  },
  {
    X: -77.40558000001693,
    Y: 39.41185500040797,
    OBJECTID: 868,
    STNCODE: "FRC",
    STNNAME: "Frederick, MD",
    ADDRESS1: "100 South East Street",
    ADDRESS2: "Transit Center",
    CITY: "Frederick",
    STATE: "MD",
    ZIP: "21704",
    STNTYPE: "RAIL",
    STFIPS: 24,
  },
  {
    X: -77.29879000005843,
    Y: 38.79727099995671,
    OBJECTID: 869,
    STNCODE: "BCV",
    STNNAME: "Burke Centre, VA",
    ADDRESS1: "10399 Premier Court",
    ADDRESS2: "Virginia Railway Express Station",
    CITY: "Burke Centre",
    STATE: "VA",
    ZIP: "22015",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -117.3187430002892,
    Y: 33.1092479997954,
    OBJECTID: 870,
    STNCODE: "POI",
    STNNAME: "Carlsbad Poinsettia, CA",
    ADDRESS1: "6511 Avenida Encinas",
    ADDRESS2: "Station",
    CITY: "Carlsbad Poinsettia",
    STATE: "CA",
    ZIP: "92009",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -117.35072999958976,
    Y: 33.16098899994245,
    OBJECTID: 871,
    STNCODE: "CBV",
    STNNAME: "Carlsbad Village, CA",
    ADDRESS1: "2775 State Street",
    ADDRESS2: "Station",
    CITY: "Carlsbad Village",
    STATE: "CA",
    ZIP: "92008",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -117.29320399976473,
    Y: 33.04710900038009,
    OBJECTID: 872,
    STNCODE: "ENC",
    STNNAME: "Encinitas, CA",
    ADDRESS1: "25 East D Street",
    ADDRESS2: "Station",
    CITY: "Encinitas",
    STATE: "CA",
    ZIP: "92024",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -117.22489199986586,
    Y: 32.90268399966692,
    OBJECTID: 873,
    STNCODE: "SRB",
    STNNAME: "Sorrento Valley, CA",
    ADDRESS1: "11170 Sorrento Valley Road",
    ADDRESS2: "Station",
    CITY: "Sorrento Valley",
    STATE: "CA",
    ZIP: "92121",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -121.26365799981681,
    Y: 37.79836000001404,
    OBJECTID: 874,
    STNCODE: "LTM",
    STNNAME: "Manteca, CA",
    ADDRESS1: "17800 Shideler Parkway",
    ADDRESS2: "Station",
    CITY: "Lathrop-Manteca",
    STATE: "CA",
    ZIP: "95330",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -121.88263899978995,
    Y: 37.65815200041453,
    OBJECTID: 875,
    STNCODE: "PLS",
    STNNAME: "Pleasanton, CA",
    ADDRESS1: "4950 Pleasanton Avenue",
    ADDRESS2: "Station",
    CITY: "Pleasanton",
    STATE: "CA",
    ZIP: "94566",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -121.43397000001545,
    Y: 37.69621100003769,
    OBJECTID: 876,
    STNCODE: "TRC",
    STNNAME: "Tracy, CA",
    ADDRESS1: "4800 Tracy Boulevard",
    ADDRESS2: "Station",
    CITY: "Tracy",
    STATE: "CA",
    ZIP: "95377",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -121.71834600016774,
    Y: 37.6969859998041,
    OBJECTID: 877,
    STNCODE: "VAS",
    STNNAME: "Livermore, CA",
    ADDRESS1: "575 South Vasco Road",
    ADDRESS2: "Vasco Road Station",
    CITY: "Livermore",
    STATE: "CA",
    ZIP: "94550",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -90.31466700028182,
    Y: 44.92855300042066,
    OBJECTID: 878,
    STNCODE: "ABB",
    STNNAME: "Abbotsford-Colby, WI",
    ADDRESS1: "1210 North Division St.",
    ADDRESS2: "Shell Station",
    CITY: "Abbotsford-Colby",
    STATE: "WI",
    ZIP: "54421",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -105.8843890000523,
    Y: 37.471658000416426,
    OBJECTID: 879,
    STNCODE: "AMC",
    STNNAME: "Alamosa, CO",
    ADDRESS1: "111 Pike Avenue",
    ADDRESS2: "San Luis Valley Apartments",
    CITY: "Alamosa",
    STATE: "CO",
    ZIP: "81101",
    STNTYPE: "BUS",
    STFIPS: 8,
  },
  {
    X: -110.96593499950058,
    Y: 32.22306100006517,
    OBJECTID: 453,
    STNCODE: "TUS",
    STNNAME: "Tucson, Arizona",
    ADDRESS1: "400 North Toole Avenue",
    ADDRESS2: "",
    CITY: "Tucson",
    STATE: "AZ",
    ZIP: "85701-1815",
    STNTYPE: "RAIL",
    STFIPS: 4,
  },
  {
    X: -94.04244200029802,
    Y: 33.42007400021498,
    OBJECTID: 455,
    STNCODE: "TXA",
    STNNAME: "Texarkana, Arkansas",
    ADDRESS1: "100 East Front Street",
    ADDRESS2: "",
    CITY: "Texarkana",
    STATE: "AR",
    ZIP: "71854-5907",
    STNTYPE: "RAIL",
    STFIPS: 5,
  },
  {
    X: -78.24105100010354,
    Y: 40.67032199986045,
    OBJECTID: 456,
    STNCODE: "TYR",
    STNNAME: "Tyrone, Pennsylvania",
    ADDRESS1: "Pennsylvania Ave and West 10th St.",
    ADDRESS2: "",
    CITY: "Tyrone",
    STATE: "PA",
    ZIP: "16686",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -75.22393799933917,
    Y: 43.10407300016885,
    OBJECTID: 457,
    STNCODE: "UCA",
    STNNAME: "Utica, New York",
    ADDRESS1: "321 Main St.",
    ADDRESS2: "Boehlert Transportation Center",
    CITY: "Utica",
    STATE: "NY",
    ZIP: "13501",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -123.19570199974748,
    Y: 39.15153099965596,
    OBJECTID: 458,
    STNCODE: "UKH",
    STNNAME: "Ukiah, California",
    ADDRESS1: "711 East Perkins Street",
    ADDRESS2: "Burger King",
    CITY: "Ukiah",
    STATE: "CA",
    ZIP: "95482",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -80.22371554383722,
    Y: 36.08846709308193,
    OBJECTID: 459,
    STNCODE: "UWS",
    STNNAME: "Winston-Salem State Univ, Winston-Salem, North Car",
    ADDRESS1: "601 South Martin Luther King, Jr. Dr",
    ADDRESS2: "Bus stop in front of nursing bldg.",
    CITY: "Winston-Salem",
    STATE: "NC",
    ZIP: "27110-0001",
    STNTYPE: "BUS",
    STFIPS: 37,
  },
  {
    X: -75.97650900039002,
    Y: 36.84703099998069,
    OBJECTID: 460,
    STNCODE: "VAB",
    STNNAME: "Virginia Beach, Virginia",
    ADDRESS1: "19th St. and Pacific Ave.",
    ADDRESS2: "",
    CITY: "Virginia Beach",
    STATE: "VA",
    ZIP: "23451",
    STNTYPE: "BUS",
    STFIPS: 51,
  },
  {
    X: -117.2468800003117,
    Y: 43.981918000115684,
    OBJECTID: 462,
    STNCODE: "VAE",
    STNNAME: "Vale, Oregon",
    ADDRESS1: "151 Smith Street North",
    ADDRESS2: "Fletcher Chevron Station",
    CITY: "Vale",
    STATE: "OR",
    ZIP: "97918-1163",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -106.34429900019865,
    Y: 39.64267699954394,
    OBJECTID: 463,
    STNCODE: "VAI",
    STNNAME: "Vail, Colorado",
    ADDRESS1: "241 South Frontage Road East",
    ADDRESS2: "",
    CITY: "Vail",
    STATE: "CO",
    ZIP: "81657",
    STNTYPE: "BUS",
    STFIPS: 8,
  },
  {
    X: -122.25622281593019,
    Y: 38.13298226591888,
    OBJECTID: 464,
    STNCODE: "VAL",
    STNNAME: "Vallejo, California",
    ADDRESS1: "4355 Sonoma Blvd.",
    ADDRESS2: "Denny's Restaurant",
    CITY: "Vallejo",
    STATE: "CA",
    ZIP: "94589",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -122.6847229998665,
    Y: 45.62980300000851,
    OBJECTID: 465,
    STNCODE: "VAN",
    STNNAME: "Vancouver, Washington, United States",
    ADDRESS1: "1301 West 11th Street",
    ADDRESS2: "",
    CITY: "Vancouver",
    STATE: "WA",
    ZIP: "98660",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -119.29657699932903,
    Y: 34.276751999805015,
    OBJECTID: 467,
    STNCODE: "VEC",
    STNNAME: "Ventura, California",
    ADDRESS1: "Harbor Blvd and Figueroa Street",
    ADDRESS2: "",
    CITY: "Ventura",
    STATE: "CA",
    ZIP: "93003",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -119.2777100007159,
    Y: 36.32727399999516,
    OBJECTID: 468,
    STNCODE: "VIS",
    STNNAME: "Visalia, California",
    ADDRESS1: "425 E. Oak Street",
    ADDRESS2: "Visalia Transit Center",
    CITY: "Visalia",
    STATE: "CA",
    ZIP: "93291-5053",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -122.22794299926994,
    Y: 38.134326999691325,
    OBJECTID: 469,
    STNCODE: "VMW",
    STNNAME: "Marine World (Seasonal), Vallejo, California",
    ADDRESS1: "Highway 37 and Fairgrounds Drive",
    ADDRESS2: "See VAL for daily Vallejo bus stop",
    CITY: "Vallejo",
    STATE: "CA",
    ZIP: "94589",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -118.44792200010016,
    Y: 34.21097900008084,
    OBJECTID: 470,
    STNCODE: "VNC",
    STNNAME: "Van Nuys (Amtrak), California",
    ADDRESS1: "7724 Van Nuys Blvd.",
    ADDRESS2: "",
    CITY: "Van Nuys",
    STATE: "CA",
    ZIP: "91405",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -117.29212999969968,
    Y: 34.536628999728634,
    OBJECTID: 472,
    STNCODE: "VRV",
    STNNAME: "Victorville, California",
    ADDRESS1: "16858 D St.",
    ADDRESS2: "train on east side, bus on west side",
    CITY: "Victorville",
    STATE: "CA",
    ZIP: "92392",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -72.75247199998279,
    Y: 44.335072000072785,
    OBJECTID: 473,
    STNCODE: "WAB",
    STNNAME: "Waterbury, Vermont",
    ADDRESS1: "US Hwy 2 and Park Row",
    ADDRESS2: "",
    CITY: "Waterbury",
    STATE: "VT",
    ZIP: "05676",
    STNTYPE: "RAIL",
    STFIPS: 50,
  },
  {
    X: -119.33135200039447,
    Y: 35.594273000298756,
    OBJECTID: 474,
    STNCODE: "WAC",
    STNNAME: "Wasco, California",
    ADDRESS1: "700 G Street",
    ADDRESS2: "",
    CITY: "Wasco",
    STATE: "CA",
    ZIP: "93280",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -91.01222200034499,
    Y: 38.56137499975648,
    OBJECTID: 475,
    STNCODE: "WAH",
    STNNAME: "Washington, Missouri",
    ADDRESS1: "301 West Front St.",
    ADDRESS2: "",
    CITY: "Washington",
    STATE: "MO",
    ZIP: "63090-2118",
    STNTYPE: "RAIL",
    STFIPS: 29,
  },
  {
    X: -93.74045599924494,
    Y: 38.763171999488236,
    OBJECTID: 476,
    STNCODE: "WAR",
    STNNAME: "Warrensburg, Missouri",
    ADDRESS1: "100 South Holden St.",
    ADDRESS2: "",
    CITY: "Warrensburg",
    STATE: "MO",
    ZIP: "64093-2331",
    STNTYPE: "RAIL",
    STFIPS: 29,
  },
  {
    X: -77.00637099952195,
    Y: 38.89730499952617,
    OBJECTID: 477,
    STNCODE: "WAS",
    STNNAME: "Washington, District of Columbia",
    ADDRESS1: "50 Massachusetts Ave NE",
    ADDRESS2: "Union Station",
    CITY: "Washington",
    STATE: "DC",
    ZIP: "20002-4214",
    STNTYPE: "RAIL",
    STFIPS: 11,
  },
  {
    X: -89.11887241063323,
    Y: 44.35611302609533,
    OBJECTID: 478,
    STNCODE: "WAU",
    STNNAME: "Waupaca, Wisconsin",
    ADDRESS1: "1222 West Fulton St.",
    ADDRESS2: "Waupaca Mobil Travel Center",
    CITY: "Waupaca",
    STATE: "WI",
    ZIP: "54981-8236",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -76.70805400039177,
    Y: 37.27572599955528,
    OBJECTID: 479,
    STNCODE: "WBG",
    STNNAME: "Williamsburg, Virginia",
    ADDRESS1: "468 North Boundary Street",
    ADDRESS2: "",
    CITY: "Williamsburg",
    STATE: "VA",
    ZIP: "23185-3650",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -122.81941995756495,
    Y: 42.45694348005759,
    OBJECTID: 480,
    STNCODE: "WCT",
    STNNAME: "White City, Oregon",
    ADDRESS1: "7455 Highway 62",
    ADDRESS2: "at Highway 140",
    CITY: "White City",
    STATE: "OR",
    ZIP: "97503",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -77.24827599983746,
    Y: 38.65744399994071,
    OBJECTID: 481,
    STNCODE: "WDB",
    STNNAME: "Woodbridge, Virginia",
    ADDRESS1: "1040 Express Way",
    ADDRESS2: "",
    CITY: "Woodbridge",
    STATE: "VA",
    ZIP: "22194",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -89.77507800034942,
    Y: 43.62478599927448,
    OBJECTID: 482,
    STNCODE: "WDL",
    STNNAME: "Wisconsin Dells, Wisconsin",
    ADDRESS1: "Superior and La Crosse Sts.",
    ADDRESS2: "",
    CITY: "Wisconsin Dells",
    STATE: "WI",
    ZIP: "53965",
    STNTYPE: "RAIL",
    STFIPS: 55,
  },
  {
    X: -82.16741899958714,
    Y: 29.790170999891757,
    OBJECTID: 483,
    STNCODE: "WDO",
    STNNAME: "Waldo, Florida",
    ADDRESS1: "14648 NE 147th Avenue",
    ADDRESS2: "Intersection Hwy 301 & SR24",
    CITY: "Waldo",
    STATE: "FL",
    ZIP: "32694-0802",
    STNTYPE: "BUS",
    STFIPS: 12,
  },
  {
    X: -69.38561001778805,
    Y: 44.10143999545949,
    OBJECTID: 484,
    STNCODE: "WDR",
    STNNAME: "Waldoboro, Maine",
    ADDRESS1: "US hwy 1 and hwy 32",
    ADDRESS2: "Clipper Mart/Texaco Station",
    CITY: "Waldoboro",
    STATE: "ME",
    ZIP: "04572",
    STNTYPE: "BUS",
    STFIPS: 23,
  },
  {
    X: -70.60963099987072,
    Y: 43.321826000069905,
    OBJECTID: 485,
    STNCODE: "WEM",
    STNNAME: "Wells, Maine",
    ADDRESS1: "696 Sanford Road",
    ADDRESS2: "",
    CITY: "Wells",
    STATE: "ME",
    ZIP: "04090",
    STNTYPE: "RAIL",
    STFIPS: 23,
  },
  {
    X: -120.30584000001596,
    Y: 47.42162300050114,
    OBJECTID: 486,
    STNCODE: "WEN",
    STNNAME: "Wenatchee, Washington",
    ADDRESS1: "Kittitas & South Columbia Sts.",
    ADDRESS2: "Bus stop is across the street from train platform",
    CITY: "Wenatchee",
    STATE: "WA",
    ZIP: "98801-6008",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -72.82535599937984,
    Y: 41.45706899953473,
    OBJECTID: 487,
    STNCODE: "WFD",
    STNNAME: "Wallingford, Connecticut",
    ADDRESS1: "37 Hall Avenue",
    ADDRESS2: "",
    CITY: "Wallingford",
    STATE: "CT",
    ZIP: "06492",
    STNTYPE: "RAIL",
    STFIPS: 9,
  },
  {
    X: -114.33515899978795,
    Y: 48.413570000355264,
    OBJECTID: 488,
    STNCODE: "WFH",
    STNNAME: "Whitefish, Montana",
    ADDRESS1: "500 Depot Street",
    ADDRESS2: "",
    CITY: "Whitefish",
    STATE: "MT",
    ZIP: "59937-2567",
    STNTYPE: "RAIL",
    STFIPS: 30,
  },
  {
    X: -113.97164200037798,
    Y: 48.49873399947455,
    OBJECTID: 489,
    STNCODE: "WGL",
    STNNAME: "West Glacier, Montana",
    ADDRESS1: "Hwy 2 and Going-to-the-Sun Rd.",
    ADDRESS2: "",
    CITY: "West Glacier",
    STATE: "MT",
    ZIP: "59936",
    STNTYPE: "RAIL",
    STFIPS: 30,
  },
  {
    X: -73.40310700008797,
    Y: 43.55496599998099,
    OBJECTID: 490,
    STNCODE: "WHL",
    STNNAME: "Whitehall, New York",
    ADDRESS1: "Main St. and Saunders St.",
    ADDRESS2: "",
    CITY: "Whitehall",
    STATE: "NY",
    ZIP: "12887",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -104.96789994562596,
    Y: 42.04662027100875,
    OBJECTID: 491,
    STNCODE: "WHT",
    STNNAME: "Wheatland, Wyoming",
    ADDRESS1: "1857 West Mariposa Parkway",
    ADDRESS2: "Conoco Gas Station",
    CITY: "Wheatland",
    STATE: "WY",
    ZIP: "82201-3132",
    STNTYPE: "BUS",
    STFIPS: 56,
  },
  {
    X: -120.96631600068287,
    Y: 45.6573099995569,
    OBJECTID: 492,
    STNCODE: "WIH",
    STNNAME: "Wishram, Washington",
    ADDRESS1: "1 Railroad Avenue",
    ADDRESS2: "",
    CITY: "Wishram",
    STATE: "WA",
    ZIP: "98673",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -75.55217700056807,
    Y: 39.73691599987353,
    OBJECTID: 493,
    STNCODE: "WIL",
    STNNAME: "Wilmington, Delaware",
    ADDRESS1: "100 South French Street",
    ADDRESS2: "(at Martin Luther King, Jr. Blvd. & French st.)",
    CITY: "Wilmington",
    STATE: "DE",
    ZIP: "19801-5036",
    STNTYPE: "RAIL",
    STFIPS: 10,
  },
  {
    X: -91.641747000024,
    Y: 44.04493700054218,
    OBJECTID: 494,
    STNCODE: "WIN",
    STNNAME: "Winona, Minnesota",
    ADDRESS1: "65 East Mark Street",
    ADDRESS2: "",
    CITY: "Winona",
    STATE: "MN",
    ZIP: "55987-3611",
    STNTYPE: "RAIL",
    STFIPS: 27,
  },
  {
    X: -105.81736800033292,
    Y: 39.948696000420114,
    OBJECTID: 495,
    STNCODE: "WIP",
    STNNAME: "Winter Park/Fraser, Colorado",
    ADDRESS1: "205 Fraser Avenue",
    ADDRESS2: "",
    CITY: "Fraser",
    STATE: "CO",
    ZIP: "80442",
    STNTYPE: "RAIL",
    STFIPS: 8,
  },
  {
    X: -77.90829500011415,
    Y: 35.72306799968851,
    OBJECTID: 496,
    STNCODE: "WLN",
    STNNAME: "Wilson, North Carolina",
    ADDRESS1: "401 East Nash Street",
    ADDRESS2: "",
    CITY: "Wilson",
    STATE: "NC",
    ZIP: "27893",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -110.6930850002725,
    Y: 35.02090800040395,
    OBJECTID: 497,
    STNCODE: "WLO",
    STNNAME: "Winslow, Arizona",
    ADDRESS1: "501 East Second Street",
    ADDRESS2: "",
    CITY: "Winslow",
    STATE: "AZ",
    ZIP: "86047",
    STNTYPE: "RAIL",
    STFIPS: 4,
  },
  {
    X: -71.83068799995118,
    Y: 41.381015999688714,
    OBJECTID: 498,
    STNCODE: "WLY",
    STNNAME: "Westerly, Rhode Island",
    ADDRESS1: "14 Railroad Avenue",
    ADDRESS2: "",
    CITY: "Westerly",
    STATE: "RI",
    ZIP: "02891",
    STNTYPE: "RAIL",
    STFIPS: 44,
  },
  {
    X: -112.1914600005785,
    Y: 35.249149000126295,
    OBJECTID: 499,
    STNCODE: "WMA",
    STNNAME: "Williams, Arizona",
    ADDRESS1: "233 North Grand Canyon Blvd",
    ADDRESS2: "Grand Canyon Railway Depot",
    CITY: "Williams",
    STATE: "AZ",
    ZIP: "86046-2563",
    STNTYPE: "BUS",
    STFIPS: 4,
  },
  {
    X: -112.18866700038171,
    Y: 35.25239199949124,
    OBJECTID: 500,
    STNCODE: "WMJ",
    STNNAME: "Williams Junction, Arizona",
    ADDRESS1: "No address.  Reserve from WMA.",
    ADDRESS2: "Free shuttle provided WMA-WMJ.",
    CITY: "Williams Junction",
    STATE: "AZ",
    ZIP: "86046",
    STNTYPE: "RAIL",
    STFIPS: 4,
  },
  {
    X: -72.64376100046974,
    Y: 41.851916999470006,
    OBJECTID: 501,
    STNCODE: "WND",
    STNNAME: "Windsor, Connecticut",
    ADDRESS1: "41 Central St.",
    ADDRESS2: "",
    CITY: "Windsor",
    STATE: "CT",
    ZIP: "06095-2908",
    STNTYPE: "RAIL",
    STFIPS: 9,
  },
  {
    X: -84.92808499942316,
    Y: 45.27373099948608,
    OBJECTID: 502,
    STNCODE: "WNK",
    STNNAME: "Walloon Lake, Michigan",
    ADDRESS1: "Hwy 131 & Hwy 75",
    ADDRESS2: "",
    CITY: "Walloon Lake",
    STATE: "MI",
    ZIP: "49796",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -72.62588666273928,
    Y: 41.913552956803585,
    OBJECTID: 503,
    STNCODE: "WNL",
    STNNAME: "Windsor Locks, Connecticut",
    ADDRESS1: "South Main St at Stanton Road",
    ADDRESS2: "",
    CITY: "Windsor Locks",
    STATE: "CT",
    ZIP: "06096",
    STNTYPE: "RAIL",
    STFIPS: 9,
  },
  {
    X: -72.38545200000976,
    Y: 43.48044199959867,
    OBJECTID: 504,
    STNCODE: "WNM",
    STNNAME: "Windsor, Vermont",
    ADDRESS1: "26 Depot Ave",
    ADDRESS2: "",
    CITY: "Windsor",
    STATE: "VT",
    ZIP: "05089-1407",
    STNTYPE: "RAIL",
    STFIPS: 50,
  },
  {
    X: -117.73156700001698,
    Y: 40.96954299931002,
    OBJECTID: 505,
    STNCODE: "WNN",
    STNNAME: "Winnemucca, Nevada",
    ADDRESS1: "209 Railroad Street",
    ADDRESS2: "",
    CITY: "Winnemucca",
    STATE: "NV",
    ZIP: "89445",
    STNTYPE: "RAIL",
    STFIPS: 32,
  },
  {
    X: -90.95616099973034,
    Y: 36.068317000229456,
    OBJECTID: 506,
    STNCODE: "WNR",
    STNNAME: "Walnut Ridge, Arkansas",
    ADDRESS1: "109 Southwest Front Street",
    ADDRESS2: "",
    CITY: "Walnut Ridge",
    STATE: "AR",
    ZIP: "72476",
    STNTYPE: "RAIL",
    STFIPS: 5,
  },
  {
    X: -80.2462080000991,
    Y: 36.09293400050376,
    OBJECTID: 507,
    STNCODE: "WNS",
    STNNAME: "Winston-Salem, North Carolina",
    ADDRESS1: "100 West 5th Street",
    ADDRESS2: "City Transfer Center, 5th & Trade Sts",
    CITY: "Winston-Salem",
    STATE: "NC",
    ZIP: "27101",
    STNTYPE: "BUS",
    STFIPS: 37,
  },
  {
    X: -123.90222448976834,
    Y: 46.15905030272933,
    OBJECTID: 508,
    STNCODE: "WNT",
    STNNAME: "Warrenton, Oregon",
    ADDRESS1: "695 S. Highway 101",
    ADDRESS2: "Fred Meyers Shopping Center",
    CITY: "Warrenton",
    STATE: "OR",
    ZIP: "97146",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -71.14011580569985,
    Y: 42.51397241469522,
    OBJECTID: 509,
    STNCODE: "WOB",
    STNNAME: "Woburn, Massachusetts",
    ADDRESS1: "100 Atlantic Ave.",
    ADDRESS2: "Woburn-Anderson Regional Trans Center",
    CITY: "Woburn",
    STATE: "MA",
    ZIP: "01801-1081",
    STNTYPE: "RAIL",
    STFIPS: 25,
  },
  {
    X: -71.79332700014089,
    Y: 42.26137900064043,
    OBJECTID: 510,
    STNCODE: "WOR",
    STNNAME: "Worcester, Massachusetts",
    ADDRESS1: "2 Washington Square",
    ADDRESS2: "Worcester Union Station",
    CITY: "Worcester",
    STATE: "MA",
    ZIP: "01604",
    STNTYPE: "RAIL",
    STFIPS: 25,
  },
  {
    X: -80.06246200002124,
    Y: 26.71234099963749,
    OBJECTID: 511,
    STNCODE: "WPB",
    STNNAME: "West Palm Beach, Florida",
    ADDRESS1: "201 South Tamarind Ave",
    ADDRESS2: "",
    CITY: "West Palm Beach",
    STATE: "FL",
    ZIP: "33402",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -81.35198199976946,
    Y: 28.59713199954217,
    OBJECTID: 512,
    STNCODE: "WPK",
    STNNAME: "Winter Park, Florida",
    ADDRESS1: "150 West Morse Blvd",
    ADDRESS2: "",
    CITY: "Winter Park",
    STATE: "FL",
    ZIP: "32789-3825",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -105.64035800062118,
    Y: 48.09078200048896,
    OBJECTID: 513,
    STNCODE: "WPT",
    STNNAME: "Wolf Point, Montana",
    ADDRESS1: "320 Front Street",
    ADDRESS2: "",
    CITY: "Wolf Point",
    STATE: "MT",
    ZIP: "59201-1413",
    STNTYPE: "RAIL",
    STFIPS: 30,
  },
  {
    X: -72.31795499992324,
    Y: 43.648556000059386,
    OBJECTID: 514,
    STNCODE: "WRJ",
    STNNAME: "White River Jct., Vermont",
    ADDRESS1: "102 Railroad Row",
    ADDRESS2: "",
    CITY: "White River Jct.",
    STATE: "VT",
    ZIP: "05001-7042",
    STNTYPE: "RAIL",
    STFIPS: 50,
  },
  {
    X: -72.60868100062766,
    Y: 44.25736199935682,
    OBJECTID: 516,
    STNCODE: "MPR",
    STNNAME: "Montpelier, Vermont",
    ADDRESS1: "Junction Rd and Short Rd",
    ADDRESS2: "",
    CITY: "Montpelier",
    STATE: "VT",
    ZIP: "05602",
    STNTYPE: "RAIL",
    STFIPS: 50,
  },
  {
    X: -77.96150200041694,
    Y: 39.45827100050633,
    OBJECTID: 517,
    STNCODE: "MRB",
    STNNAME: "Martinsburg, West Virginia",
    ADDRESS1: "229 East Martin St.",
    ADDRESS2: "",
    CITY: "Martinsburg",
    STATE: "WV",
    ZIP: "25401",
    STNTYPE: "RAIL",
    STFIPS: 54,
  },
  {
    X: -112.04792800057675,
    Y: 33.05843700026742,
    OBJECTID: 518,
    STNCODE: "MRC",
    STNNAME: "Maricopa, Arizona",
    ADDRESS1: "19427 N. John Wayne Parkway",
    ADDRESS2: "P.O. Box 897",
    CITY: "Maricopa",
    STATE: "AZ",
    ZIP: "85239",
    STNTYPE: "RAIL",
    STFIPS: 4,
  },
  {
    X: -119.96954299950977,
    Y: 37.489658000416455,
    OBJECTID: 519,
    STNCODE: "MRP",
    STNNAME: "Mariposa, California",
    ADDRESS1: "5158 State Highway 140",
    ADDRESS2: "Visitor Center Stop Hwy 140 at Hwy 49",
    CITY: "Mariposa",
    STATE: "CA",
    ZIP: "95338",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -121.59718937998588,
    Y: 39.143575292865535,
    OBJECTID: 520,
    STNCODE: "MRV",
    STNNAME: "Marysville, California",
    ADDRESS1: "I Street between 8th and 9th",
    ADDRESS2: "Yuba-Sutter Transit Shelter",
    CITY: "Marysville",
    STATE: "CA",
    ZIP: "95901-5211",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -121.89256299968264,
    Y: 36.598010999807855,
    OBJECTID: 521,
    STNCODE: "MRY",
    STNNAME: "Monterey (Transit Plaza), California",
    ADDRESS1: "500 Tyler Street",
    ADDRESS2: "Corner of East Pearl Street and Tyler Street",
    CITY: "Monterey",
    STATE: "CA",
    ZIP: "93940",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -89.39875799958196,
    Y: 43.075871000046675,
    OBJECTID: 522,
    STNCODE: "MSN",
    STNNAME: "Madison, Wisconsin",
    ADDRESS1: "800 Langdon St.",
    ADDRESS2: "Univ of Wisconsin Memorial Union",
    CITY: "Madison",
    STATE: "WI",
    ZIP: "53706-1419",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -93.18632500049836,
    Y: 44.96332900063294,
    OBJECTID: 523,
    STNCODE: "MSP",
    STNNAME: "St. Paul/Minneapolis, Minnesota",
    ADDRESS1: "Midway Station",
    ADDRESS2: "730 Transfer Road",
    CITY: "St. Paul",
    STATE: "MN",
    ZIP: "55114-1498",
    STNTYPE: "RAIL",
    STFIPS: 27,
  },
  {
    X: -77.47384600049247,
    Y: 38.75003400066862,
    OBJECTID: 524,
    STNCODE: "MSS",
    STNNAME: "Manassas, Virginia",
    ADDRESS1: "9431 West Street",
    ADDRESS2: "",
    CITY: "Manassas",
    STATE: "VA",
    ZIP: "20110",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -91.55123899997983,
    Y: 40.97130599967221,
    OBJECTID: 525,
    STNCODE: "MTP",
    STNNAME: "Mt. Pleasant, Iowa",
    ADDRESS1: "418 North Adams Street",
    ADDRESS2: "",
    CITY: "Mt. Pleasant",
    STATE: "IA",
    ZIP: "52641",
    STNTYPE: "RAIL",
    STFIPS: 19,
  },
  {
    X: -122.13635299969116,
    Y: 38.01973300047763,
    OBJECTID: 527,
    STNCODE: "MTZ",
    STNNAME: "Martinez, California",
    ADDRESS1: "601 Marina Vista Ave.",
    ADDRESS2: "",
    CITY: "Martinez",
    STATE: "CA",
    ZIP: "94553-1132",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -92.81235500018306,
    Y: 34.36591699996961,
    OBJECTID: 528,
    STNCODE: "MVN",
    STNNAME: "Malvern, Arkansas",
    ADDRESS1: "200 East First St.",
    ADDRESS2: "",
    CITY: "Malvern",
    STATE: "AR",
    ZIP: "72104-3922",
    STNTYPE: "RAIL",
    STFIPS: 5,
  },
  {
    X: -122.32978099929363,
    Y: 48.43558900043206,
    OBJECTID: 529,
    STNCODE: "MVW",
    STNNAME: "Mount Vernon, Washington",
    ADDRESS1: "105 East Kincaid St.",
    ADDRESS2: "Skagit Transportation Center",
    CITY: "Mount Vernon",
    STATE: "WA",
    ZIP: "98273-4327",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -121.90142012843614,
    Y: 36.6179193369079,
    OBJECTID: 530,
    STNCODE: "MYA",
    STNNAME: "Monterey (Aquarium), California",
    ADDRESS1: "886 Cannery Row",
    ADDRESS2: "Monterey Bay Aquarium (In Front of)",
    CITY: "Monterey",
    STATE: "CA",
    ZIP: "94940-1023",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -121.87678846201788,
    Y: 36.5931667755263,
    OBJECTID: 531,
    STNCODE: "MYH",
    STNNAME: "Monterey (Hyatt Regency), California",
    ADDRESS1: "1 Old Golf Course Road",
    ADDRESS2: "Hyatt Regency Hotel",
    CITY: "Monterey",
    STATE: "CA",
    ZIP: "93940",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -121.89467395134176,
    Y: 36.60067084908047,
    OBJECTID: 532,
    STNCODE: "MYM",
    STNNAME: "Monterey (Marriott), California",
    ADDRESS1: "350 Calle Principal",
    ADDRESS2: "Marriott Hotel",
    CITY: "Monterey",
    STATE: "CA",
    ZIP: "93940",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -71.95978499977787,
    Y: 41.34920100022606,
    OBJECTID: 533,
    STNCODE: "MYS",
    STNNAME: "Mystic, Connecticut",
    ADDRESS1: "2 Roosevelt Avenue",
    ADDRESS2: "U.S.Route 1",
    CITY: "Mystic",
    STATE: "CT",
    ZIP: "06355",
    STNTYPE: "RAIL",
    STFIPS: 9,
  },
  {
    X: -121.89305447558354,
    Y: 36.59574736394973,
    OBJECTID: 534,
    STNCODE: "MYT",
    STNNAME: "Monterey (Travelodge), California",
    ADDRESS1: "675 Munras Street",
    ADDRESS2: "Casa Munras Garden Hotel",
    CITY: "Monterey",
    STATE: "CA",
    ZIP: "93940",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -116.55715899998785,
    Y: 43.57632100001422,
    OBJECTID: 535,
    STNCODE: "NAM",
    STNNAME: "Nampa, Idaho",
    ADDRESS1: "3116 Garrity Blvd",
    ADDRESS2: "Suite 11",
    CITY: "Nampa",
    STATE: "ID",
    ZIP: "83651",
    STNTYPE: "BUS",
    STFIPS: 16,
  },
  {
    X: -74.44850200056686,
    Y: 40.49535399988724,
    OBJECTID: 537,
    STNCODE: "NBK",
    STNNAME: "New Brunswick, New Jersey",
    ADDRESS1: "French and Albany Streets",
    ADDRESS2: "New Jersey Transit Station",
    CITY: "New Brunswick",
    STATE: "NJ",
    ZIP: "08901",
    STNTYPE: "RAIL",
    STFIPS: 34,
  },
  {
    X: -86.73987599997736,
    Y: 41.787949000246215,
    OBJECTID: 538,
    STNCODE: "NBM",
    STNNAME: "New Buffalo, Michigan",
    ADDRESS1: "517 South Whittaker Street",
    ADDRESS2: "",
    CITY: "New Buffalo",
    STATE: "MI",
    ZIP: "49117",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -89.26296200019613,
    Y: 36.11244999936804,
    OBJECTID: 539,
    STNCODE: "NBN",
    STNNAME: "Newbern-Dyersburg, Tennessee",
    ADDRESS1: "108 Jefferson St",
    ADDRESS2: "",
    CITY: "Newbern",
    STATE: "TN",
    ZIP: "38059",
    STNTYPE: "RAIL",
    STFIPS: 47,
  },
  {
    X: -94.63967099991669,
    Y: 31.618300999391636,
    OBJECTID: 540,
    STNCODE: "NCG",
    STNNAME: "Nacogdoches, Texas",
    ADDRESS1: "University Drive & Starr Road",
    ADDRESS2: "Mobil Oil Convenience Store",
    CITY: "Nacogdoches",
    STATE: "TX",
    ZIP: "75963",
    STNTYPE: "BUS",
    STFIPS: 48,
  },
  {
    X: -123.76024110614208,
    Y: 45.90250033482266,
    OBJECTID: 541,
    STNCODE: "NCM",
    STNNAME: "Necanicum Junction, Oregon",
    ADDRESS1: "Hwy 26 and Hwy 53",
    ADDRESS2: "Bus stop is 100 ft east of junction",
    CITY: "Necanicum Junction",
    STATE: "OR",
    ZIP: "97301",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -76.86443299928345,
    Y: 38.95333099942616,
    OBJECTID: 542,
    STNCODE: "NCR",
    STNNAME: "New Carrollton, Maryland",
    ADDRESS1: "4300 Garden City Drive",
    ADDRESS2: "",
    CITY: "New Carrollton",
    STATE: "MD",
    ZIP: "20785-2209",
    STNTYPE: "RAIL",
    STFIPS: 24,
  },
  {
    X: -70.91896225150668,
    Y: 42.815954655682845,
    OBJECTID: 543,
    STNCODE: "NBT",
    STNNAME: "Newburyport, Massachusetts",
    ADDRESS1: "90 Storey Avenue",
    ADDRESS2: "",
    CITY: "Newburyport",
    STATE: "MA",
    ZIP: "01950",
    STNTYPE: "BUS",
    STFIPS: 25,
  },
  {
    X: -70.80803224948869,
    Y: 43.06286326442819,
    OBJECTID: 544,
    STNCODE: "PTS",
    STNNAME: "Portsmouth, New Hampshire",
    ADDRESS1: "185 Grafton Drive",
    ADDRESS2: "Portsmouth Transportation Center",
    CITY: "Portsmouth",
    STATE: "NH",
    ZIP: "03801",
    STNTYPE: "BUS",
    STFIPS: 33,
  },
  {
    X: -111.75942754404588,
    Y: 34.87108578408174,
    OBJECTID: 545,
    STNCODE: "SDC",
    STNNAME: "Sedona (Center Bus Stop), Arizona",
    ADDRESS1: "300 North Highway 89A",
    ADDRESS2: "Canyon Breeze Restaurant",
    CITY: "Sedona",
    STATE: "AZ",
    ZIP: "86336",
    STNTYPE: "BUS",
    STFIPS: 4,
  },
  {
    X: -114.60487400013494,
    Y: 34.84027900017577,
    OBJECTID: 547,
    STNCODE: "NDL",
    STNNAME: "Needles, California",
    ADDRESS1: "900 Front Street",
    ADDRESS2: "",
    CITY: "Needles",
    STATE: "CA",
    ZIP: "92363",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -97.34460400077398,
    Y: 38.04730999965682,
    OBJECTID: 548,
    STNCODE: "NEW",
    STNNAME: "Newton, Kansas",
    ADDRESS1: "414 North Main St.",
    ADDRESS2: "Newton Station",
    CITY: "Newton",
    STATE: "KS",
    ZIP: "67114-2203",
    STNTYPE: "RAIL",
    STFIPS: 20,
  },
  {
    X: -76.29112251539175,
    Y: 36.85351544198409,
    OBJECTID: 549,
    STNCODE: "NFK",
    STNNAME: "Norfolk, Virginia",
    ADDRESS1: "215 W York Street",
    ADDRESS2: "Stop on West Bute Street at York Street Garage",
    CITY: "Norfolk",
    STATE: "VA",
    ZIP: "23510",
    STNTYPE: "BUS",
    STFIPS: 51,
  },
  {
    X: -79.03066299969765,
    Y: 43.1136019998325,
    OBJECTID: 550,
    STNCODE: "NFL",
    STNNAME: "Niagara Falls, New York, United States",
    ADDRESS1: "27th St. and Lockport Rd.",
    ADDRESS2: "",
    CITY: "Niagara Falls",
    STATE: "NY",
    ZIP: "14305",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -118.52675230967134,
    Y: 34.37898495419233,
    OBJECTID: 552,
    STNCODE: "NHL",
    STNNAME: "Santa Clarita-Newhall, California",
    ADDRESS1: "24300 Railroad Avenue",
    ADDRESS2: "Metrolink Station",
    CITY: "Santa Clarita",
    STATE: "CA",
    ZIP: "91321-0000",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -71.63332690441308,
    Y: 43.61987548236766,
    OBJECTID: 553,
    STNCODE: "NHN",
    STNNAME: "New Hampton, New Hampshire",
    ADDRESS1: "325 Route 104",
    ADDRESS2: "Munce's Konvenience Store/CITGO",
    CITY: "New Hampton",
    STATE: "NH",
    ZIP: "03256-4219",
    STNTYPE: "BUS",
    STFIPS: 33,
  },
  {
    X: -72.92599499986932,
    Y: 41.298668000028215,
    OBJECTID: 554,
    STNCODE: "NHV",
    STNNAME: "New Haven, Connecticut",
    ADDRESS1: "50 Union Avenue",
    ADDRESS2: "Union Station",
    CITY: "New Haven",
    STATE: "CT",
    ZIP: "06519-1754",
    STNTYPE: "RAIL",
    STFIPS: 9,
  },
  {
    X: -91.82351699980967,
    Y: 30.008487999721467,
    OBJECTID: 555,
    STNCODE: "NIB",
    STNNAME: "New Iberia, Louisiana",
    ADDRESS1: "West Washington St.",
    ADDRESS2: "at railroad tracks, downtown",
    CITY: "New Iberia",
    STATE: "LA",
    ZIP: "70560",
    STNTYPE: "RAIL",
    STFIPS: 22,
  },
  {
    X: -72.09388699928553,
    Y: 41.35433200032162,
    OBJECTID: 556,
    STNCODE: "NLC",
    STNNAME: "New London, Connecticut",
    ADDRESS1: "27 Water Street",
    ADDRESS2: "",
    CITY: "New London",
    STATE: "CT",
    ZIP: "06320",
    STNTYPE: "RAIL",
    STFIPS: 9,
  },
  {
    X: -86.25361600057795,
    Y: 41.83657500063583,
    OBJECTID: 557,
    STNCODE: "NLS",
    STNNAME: "Niles, Michigan",
    ADDRESS1: "598 Dey St.",
    ADDRESS2: "",
    CITY: "Niles",
    STATE: "MI",
    ZIP: "49120-1745",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -90.07959699950192,
    Y: 29.94679600023528,
    OBJECTID: 560,
    STNCODE: "NOL",
    STNNAME: "New Orleans, Louisiana",
    ADDRESS1: "1001 Loyola Avenue",
    ADDRESS2: "NEW ORLEANS UNION PASSENGER TERMINAL",
    CITY: "New Orleans",
    STATE: "LA",
    ZIP: "70113",
    STNTYPE: "UNK",
    STFIPS: 22,
  },
  {
    X: -97.44216900069881,
    Y: 35.21962700028587,
    OBJECTID: 561,
    STNCODE: "NOR",
    STNNAME: "Norman, Oklahoma",
    ADDRESS1: "200 South Jones Avenue",
    ADDRESS2: "",
    CITY: "Norman",
    STATE: "OK",
    ZIP: "73069-6023",
    STNTYPE: "RAIL",
    STFIPS: 40,
  },
  {
    X: -76.45104999985756,
    Y: 37.01935599947984,
    OBJECTID: 562,
    STNCODE: "NPN",
    STNNAME: "Newport News, Virginia",
    ADDRESS1: "9304 Warwick Boulevard",
    ADDRESS2: "",
    CITY: "Newport News",
    STATE: "VA",
    ZIP: "23601-4535",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -124.05952500057828,
    Y: 44.62601499999232,
    OBJECTID: 563,
    STNCODE: "NPO",
    STNNAME: "Newport, Oregon",
    ADDRESS1: "956 SW 10th Street",
    ADDRESS2: "Greyhound Station",
    CITY: "Newport",
    STATE: "OR",
    ZIP: "97365",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -88.14504999925805,
    Y: 41.77950700034785,
    OBJECTID: 564,
    STNCODE: "NPV",
    STNNAME: "Naperville, Illinois",
    ADDRESS1: "105 E. Fourth Ave.",
    ADDRESS2: "Corner of 4th Ave. & Ellsworth St.",
    CITY: "Naperville",
    STATE: "IL",
    ZIP: "60540",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -75.75334899935677,
    Y: 39.67032199916099,
    OBJECTID: 566,
    STNCODE: "NRK",
    STNNAME: "Newark, Delaware",
    ADDRESS1: "429 South College Ave.",
    ADDRESS2: "",
    CITY: "Newark",
    STATE: "DE",
    ZIP: "19711-5105",
    STNTYPE: "RAIL",
    STFIPS: 10,
  },
  {
    X: -73.7820050001306,
    Y: 40.91392100005419,
    OBJECTID: 567,
    STNCODE: "NRO",
    STNNAME: "New Rochelle, New York",
    ADDRESS1: "1 Railroad Plaza",
    ADDRESS2: "Metro-North Station",
    CITY: "New Rochelle",
    STATE: "NY",
    ZIP: "10801-6353",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -78.70593366390744,
    Y: 35.79404880970486,
    OBJECTID: 568,
    STNCODE: "NSF",
    STNNAME: "North Carolina State Fair, North Carolina",
    ADDRESS1: "1025 Blue Ridge Blvd.",
    ADDRESS2: "at the railroad crossing",
    CITY: "Raleigh",
    STATE: "NC",
    ZIP: "27607-3902",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -74.16488599948923,
    Y: 40.734279999522414,
    OBJECTID: 569,
    STNCODE: "NWK",
    STNNAME: "Newark (Penn Station), New Jersey",
    ADDRESS1: "1 Raymond Plaza West",
    ADDRESS2: "Market Street",
    CITY: "Newark",
    STATE: "NJ",
    ZIP: "07102-5405",
    STNTYPE: "RAIL",
    STFIPS: 34,
  },
  {
    X: -73.99186700036176,
    Y: 40.749680000131946,
    OBJECTID: 570,
    STNCODE: "NYP",
    STNNAME: "New York (Penn Station), New York",
    ADDRESS1: "8th Ave 31st  Street / 8th Ave 33rd Street",
    ADDRESS2: "Pennsylvania Station",
    CITY: "New York",
    STATE: "NY",
    ZIP: "10001",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -122.19774049682644,
    Y: 37.751881256914544,
    OBJECTID: 571,
    STNCODE: "OAC",
    STNNAME: "Coliseum/Oakland Airport, Oakland, California",
    ADDRESS1: "700 73rd Avenue",
    ADDRESS2: "Across San Leandro Blvd. from BART station",
    CITY: "Oakland",
    STATE: "CA",
    ZIP: "94621-3316",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -82.13639099954497,
    Y: 29.19222800062181,
    OBJECTID: 572,
    STNCODE: "OCA",
    STNNAME: "Ocala, Florida",
    ADDRESS1: "531 Northeast First Ave",
    ADDRESS2: "",
    CITY: "Ocala",
    STATE: "FL",
    ZIP: "34470-6647",
    STNTYPE: "BUS",
    STFIPS: 12,
  },
  {
    X: -111.97890500026551,
    Y: 41.22157299979415,
    OBJECTID: 573,
    STNCODE: "OGD",
    STNNAME: "Ogden, Utah",
    ADDRESS1: "2393 Wall Avenue",
    ADDRESS2: "Greyhound Bus Station",
    CITY: "Ogden",
    STATE: "UT",
    ZIP: "84401",
    STNTYPE: "BUS",
    STFIPS: 49,
  },
  {
    X: -119.58226548446453,
    Y: 48.362645885898985,
    OBJECTID: 574,
    STNCODE: "OGW",
    STNNAME: "Okanagan,  Washington",
    ADDRESS1: "310 2nd Ave South",
    ADDRESS2: "Food Depot",
    CITY: "Okanogan",
    STATE: "WA",
    ZIP: "98840",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -97.512634000059,
    Y: 35.46614500019166,
    OBJECTID: 575,
    STNCODE: "OKC",
    STNNAME: "Oklahoma City, Oklahoma",
    ADDRESS1: "100 South E.K. Gaylord Blvd.",
    ADDRESS2: "",
    CITY: "Oklahoma City",
    STATE: "OK",
    ZIP: "73102",
    STNTYPE: "RAIL",
    STFIPS: 40,
  },
  {
    X: -80.8303069994684,
    Y: 27.251219000056835,
    OBJECTID: 576,
    STNCODE: "OKE",
    STNNAME: "Okeechobee, Florida",
    ADDRESS1: "801 North Parrott Avenue",
    ADDRESS2: "",
    CITY: "Okeechobee",
    STATE: "FL",
    ZIP: "34972-2130",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -122.27074399993563,
    Y: 37.794646999659335,
    OBJECTID: 577,
    STNCODE: "OKJ",
    STNNAME: "Oakland, California",
    ADDRESS1: "245 Second Street",
    ADDRESS2: "",
    CITY: "Oakland",
    STATE: "CA",
    ZIP: "94607",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -72.70835100049823,
    Y: 43.400619999513424,
    OBJECTID: 579,
    STNCODE: "OKO",
    STNNAME: "Okemo, Vermont",
    ADDRESS1: "77 Okemo Ridge Rd",
    ADDRESS2: "The Inn at Jackson Gore",
    CITY: "Ludlow",
    STATE: "VT",
    ZIP: "05149-9692",
    STNTYPE: "BUS",
    STFIPS: 50,
  },
  {
    X: -117.19998812575136,
    Y: 32.75545496227676,
    OBJECTID: 580,
    STNCODE: "OLT",
    STNNAME: "San Diego (Old Town), California",
    ADDRESS1: "4005 Taylor Street",
    ADDRESS2: "",
    CITY: "San Diego",
    STATE: "CA",
    ZIP: "92110",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -122.79580699999303,
    Y: 46.990662000750774,
    OBJECTID: 581,
    STNCODE: "OLW",
    STNNAME: "Olympia/Lacey, Washington",
    ADDRESS1: "6600 Yelm Highway S.E.",
    ADDRESS2: "",
    CITY: "Lacey",
    STATE: "WA",
    ZIP: "98513-6481",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -95.92742199992534,
    Y: 41.250168000053236,
    OBJECTID: 582,
    STNCODE: "OMA",
    STNNAME: "Omaha, Nebraska",
    ADDRESS1: "1003 S. 9th Street",
    ADDRESS2: "",
    CITY: "Omaha",
    STATE: "NE",
    ZIP: "68108",
    STNTYPE: "RAIL",
    STFIPS: 31,
  },
  {
    X: -119.51948767231818,
    Y: 48.41628538096563,
    OBJECTID: 583,
    STNCODE: "OMW",
    STNNAME: "Omak, Washington",
    ADDRESS1: "800 East Riverside Drive",
    ADDRESS2: "Shell Station/Food Mart",
    CITY: "Omak",
    STATE: "WA",
    ZIP: "98841-9580",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -117.64785799964693,
    Y: 34.061706999778266,
    OBJECTID: 584,
    STNCODE: "ONA",
    STNNAME: "Ontario, California",
    ADDRESS1: "228 South Plum Street",
    ADDRESS2: "Amtrak Passenger Platform",
    CITY: "Ontario",
    STATE: "CA",
    ZIP: "91764",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -116.9570663537292,
    Y: 44.02717034493554,
    OBJECTID: 585,
    STNCODE: "ONT",
    STNNAME: "Ontario, Oregon",
    ADDRESS1: "653 East Idaho Avenue",
    ADDRESS2: "Pilot Truck Stop",
    CITY: "Ontario",
    STATE: "OR",
    ZIP: "97914",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -70.37484799973538,
    Y: 43.51578400073112,
    OBJECTID: 586,
    STNCODE: "ORB",
    STNNAME: "Old Orchard Beach, Maine (Seasonal)",
    ADDRESS1: "11 First Street",
    ADDRESS2: "Chamber of Commerce",
    CITY: "Old Orchard Beach",
    STATE: "ME",
    ZIP: "04064",
    STNTYPE: "RAIL",
    STFIPS: 23,
  },
  {
    X: -122.59640800022902,
    Y: 45.36543099964098,
    OBJECTID: 587,
    STNCODE: "ORC",
    STNNAME: "Oregon City, Oregon",
    ADDRESS1: "1757 Washington Street",
    ADDRESS2: "",
    CITY: "Oregon City",
    STATE: "OR",
    ZIP: "97045",
    STNTYPE: "RAIL",
    STFIPS: 41,
  },
  {
    X: -81.38174399988566,
    Y: 28.52569400027795,
    OBJECTID: 588,
    STNCODE: "ORL",
    STNNAME: "Orlando, Florida",
    ADDRESS1: "1400 Sligh Blvd.",
    ADDRESS2: "",
    CITY: "Orlando",
    STATE: "FL",
    ZIP: "32806-3905",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -68.67062117152983,
    Y: 44.903473416764825,
    OBJECTID: 589,
    STNCODE: "ORO",
    STNNAME: "Orono (University of Maine), Maine",
    ADDRESS1: "Squapan Rd and Gym Dr",
    ADDRESS2: "Memorial Gymnasium",
    CITY: "Orono",
    STATE: "ME",
    ZIP: "04473",
    STNTYPE: "BUS",
    STFIPS: 23,
  },
  {
    X: -121.57018299974561,
    Y: 39.51986700006205,
    OBJECTID: 590,
    STNCODE: "ORV",
    STNNAME: "Oroville, California",
    ADDRESS1: "Hwy 70 and Grand Ave.",
    ADDRESS2: "Park and Ride",
    CITY: "Oroville",
    STATE: "CA",
    ZIP: "95965",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -72.37602200041493,
    Y: 41.30053300059757,
    OBJECTID: 591,
    STNCODE: "OSB",
    STNNAME: "Old Saybrook, Connecticut",
    ADDRESS1: "455 Boston Post Road",
    ADDRESS2: "Saybrook Junction Market Place",
    CITY: "Old Saybrook",
    STATE: "CT",
    ZIP: "06475-1516",
    STNTYPE: "RAIL",
    STFIPS: 9,
  },
  {
    X: -93.76574700002402,
    Y: 41.037445000086734,
    OBJECTID: 592,
    STNCODE: "OSC",
    STNNAME: "Osceola, Iowa",
    ADDRESS1: "Main & East Clay Streets",
    ADDRESS2: "",
    CITY: "Osceola",
    STATE: "IA",
    ZIP: "50213",
    STNTYPE: "RAIL",
    STFIPS: 19,
  },
  {
    X: -117.37862399989763,
    Y: 33.192580999913275,
    OBJECTID: 593,
    STNCODE: "OSD",
    STNNAME: "Oceanside, California",
    ADDRESS1: "235 South Tremont Street",
    ADDRESS2: "Oceanside Transit Center",
    CITY: "Oceanside",
    STATE: "CA",
    ZIP: "92054",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -88.53733799984877,
    Y: 44.01501799948113,
    OBJECTID: 594,
    STNCODE: "OSH",
    STNNAME: "Oshkosh, Wisconsin",
    ADDRESS1: "525 West 20th Ave.",
    ADDRESS2: "Wittman Field",
    CITY: "Oshkosh",
    STATE: "WI",
    ZIP: "54902-6871",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -92.41567200016266,
    Y: 41.01964199927892,
    OBJECTID: 595,
    STNCODE: "OTM",
    STNNAME: "Ottumwa, Iowa",
    ADDRESS1: "210 West Main Street",
    ADDRESS2: "",
    CITY: "Ottumwa",
    STATE: "IA",
    ZIP: "52501",
    STNTYPE: "RAIL",
    STFIPS: 19,
  },
  {
    X: -119.17486600016576,
    Y: 34.198833000242814,
    OBJECTID: 596,
    STNCODE: "OXN",
    STNNAME: "Oxnard, California",
    ADDRESS1: "201 East Fourth Street",
    ADDRESS2: "Oxnard Transportation Center",
    CITY: "Oxnard",
    STATE: "CA",
    ZIP: "93030",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -81.64054099946753,
    Y: 29.649308999810557,
    OBJECTID: 598,
    STNCODE: "PAK",
    STNNAME: "Palatka, Florida",
    ADDRESS1: "220 North 11th Street",
    ADDRESS2: "",
    CITY: "Palatka",
    STATE: "FL",
    ZIP: "32077-3615",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -75.48374899981644,
    Y: 40.042286000498564,
    OBJECTID: 599,
    STNCODE: "PAO",
    STNNAME: "Paoli, Pennsylvania",
    ADDRESS1: "13 Lancaster Ave.",
    ADDRESS2: "Lancaster Pike & North Valley Rd",
    CITY: "Paoli",
    STATE: "PA",
    ZIP: "19301",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -75.92177599986246,
    Y: 39.95918299929605,
    OBJECTID: 600,
    STNCODE: "PAR",
    STNNAME: "Parkesburg, Pennsylvania",
    ADDRESS1: "W. First and S. Culvert Streets",
    ADDRESS2: "",
    CITY: "Parkesburg",
    STATE: "PA",
    ZIP: "19365",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -118.14042699950642,
    Y: 34.14333000017939,
    OBJECTID: 601,
    STNCODE: "PAS",
    STNNAME: "Pasadena, California",
    ADDRESS1: "150 South Los Robles Ave.",
    ADDRESS2: "Pasadena Hilton Hotel",
    CITY: "Pasadena",
    STATE: "CA",
    ZIP: "91101-2441",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -90.39343300023273,
    Y: 36.75398599985408,
    OBJECTID: 602,
    STNCODE: "PBF",
    STNNAME: "Poplar Bluff, Missouri",
    ADDRESS1: "400 South Main St.",
    ADDRESS2: "",
    CITY: "Poplar Bluff",
    STATE: "MO",
    ZIP: "63901-5855",
    STNTYPE: "RAIL",
    STFIPS: 29,
  },
  {
    X: -82.05265799986677,
    Y: 27.012430000444226,
    OBJECTID: 604,
    STNCODE: "PCH",
    STNNAME: "Port Charlotte, Florida",
    ADDRESS1: "909 King Highway",
    ADDRESS2: "Amoco/BP Convenience Store, I-75 exit 170",
    CITY: "Port Charlotte",
    STATE: "FL",
    ZIP: "33980-4248",
    STNTYPE: "BUS",
    STFIPS: 12,
  },
  {
    X: -89.4616779999397,
    Y: 41.386905999712155,
    OBJECTID: 605,
    STNCODE: "PCT",
    STNNAME: "Princeton, Illinois",
    ADDRESS1: "107 Bicentennial Dr.",
    ADDRESS2: "",
    CITY: "Princeton",
    STATE: "IL",
    ZIP: "61356",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -120.80158999997849,
    Y: 38.727833000292776,
    OBJECTID: 606,
    STNCODE: "PCV",
    STNNAME: "Placerville, California",
    ADDRESS1: "Mosquito Rd. and Clay St.",
    ADDRESS2: "Placerville Station Transit Center",
    CITY: "Placerville",
    STATE: "CA",
    ZIP: "95667",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -122.67502599965013,
    Y: 45.52868299982066,
    OBJECTID: 607,
    STNCODE: "PDX",
    STNNAME: "Portland, Oregon",
    ADDRESS1: "800 NW Sixth Ave.",
    ADDRESS2: "Union Station",
    CITY: "Portland",
    STATE: "OR",
    ZIP: "97209-3789",
    STNTYPE: "RAIL",
    STFIPS: 41,
  },
  {
    X: -118.78950499975588,
    Y: 45.671852000169736,
    OBJECTID: 608,
    STNCODE: "PEN",
    STNNAME: "Pendleton, Oregon",
    ADDRESS1: "320 SW Court Street",
    ADDRESS2: "Greyhound Station",
    CITY: "Pendleton",
    STATE: "OR",
    ZIP: "97801",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -79.99325600026418,
    Y: 40.44504199998835,
    OBJECTID: 609,
    STNCODE: "PGH",
    STNNAME: "Pittsburgh, Pennsylvania",
    ADDRESS1: "1100 Liberty Avenue",
    ADDRESS2: "",
    CITY: "Pittsburgh",
    STATE: "PA",
    ZIP: "15222",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -112.00904799996522,
    Y: 33.43753100035542,
    OBJECTID: 610,
    STNCODE: "PHA",
    STNNAME: "Phoenix (Airport), Arizona",
    ADDRESS1: "3400 East Sky Harbor Blvd.",
    ADDRESS2: "City-to-City Transport Desk, Terminals 2, 3, or 4",
    CITY: "Phoenix",
    STATE: "AZ",
    ZIP: "85034",
    STNTYPE: "BUS",
    STFIPS: 4,
  },
  {
    X: -112.03599051305173,
    Y: 33.43681037809654,
    OBJECTID: 611,
    STNCODE: "PHG",
    STNNAME: "Phoenix (Greyhound), Arizona",
    ADDRESS1: "2115 East Buckeye Road",
    ADDRESS2: "",
    CITY: "Phoenix",
    STATE: "AZ",
    ZIP: "85034",
    STNTYPE: "BUS",
    STFIPS: 4,
  },
  {
    X: -75.18318899977248,
    Y: 39.95460900060493,
    OBJECTID: 612,
    STNCODE: "PHL",
    STNNAME: "Philadelphia (30th St), Pennsylvania",
    ADDRESS1: "2955 Market St.",
    ADDRESS2: "30th Street Station",
    CITY: "Philadelphia",
    STATE: "PA",
    ZIP: "19104-2898",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -75.15436599979103,
    Y: 39.99690600051156,
    OBJECTID: 613,
    STNCODE: "PHN",
    STNNAME: "Philadelphia (North), Pennsylvania",
    ADDRESS1: "2900 North Broad St.",
    ADDRESS2: "Broad St. and Glenwood Ave.",
    CITY: "Philadelphia",
    STATE: "PA",
    ZIP: "19132-2400",
    STNTYPE: "RAIL",
    STFIPS: 42,
  },
  {
    X: -89.68823199920735,
    Y: 40.670082000484,
    OBJECTID: 614,
    STNCODE: "PIA",
    STNNAME: "Peoria, Illinois",
    ADDRESS1: "6100 West Everett M. Dirksen Parkway",
    ADDRESS2: "Greater Peoria Airport, lower level",
    CITY: "Peoria",
    STATE: "IL",
    ZIP: "61607-1220",
    STNTYPE: "BUS",
    STFIPS: 17,
  },
  {
    X: -89.68013800006861,
    Y: 30.5247119995592,
    OBJECTID: 615,
    STNCODE: "PIC",
    STNNAME: "Picayune, Mississippi",
    ADDRESS1: "US 11 at Tate Street",
    ADDRESS2: "",
    CITY: "Picayune",
    STATE: "MS",
    ZIP: "39466",
    STNTYPE: "RAIL",
    STFIPS: 28,
  },
  {
    X: -73.2560419999383,
    Y: 42.45040100030599,
    OBJECTID: 616,
    STNCODE: "PIT",
    STNNAME: "Pittsfield, Massachusetts",
    ADDRESS1: "1 Columbus Avenue",
    ADDRESS2: "at North St. (US Hwy 7)",
    CITY: "Pittsfield",
    STATE: "MA",
    ZIP: "01201-5058",
    STNTYPE: "RAIL",
    STFIPS: 25,
  },
  {
    X: -74.62323000026424,
    Y: 40.31721899955721,
    OBJECTID: 617,
    STNCODE: "PJC",
    STNNAME: "Princeton Junction, New Jersey",
    ADDRESS1: "2 Wallace Road",
    ADDRESS2: "",
    CITY: "Princeton Junction",
    STATE: "NJ",
    ZIP: "08550-1008",
    STNTYPE: "RAIL",
    STFIPS: 34,
  },
  {
    X: -73.95207199982292,
    Y: 41.92089100021951,
    OBJECTID: 667,
    STNCODE: "RHI",
    STNNAME: "Rhinecliff, New York",
    ADDRESS1: "Hutton and Charles Sts.",
    ADDRESS2: "",
    CITY: "Rhinecliff",
    STATE: "NY",
    ZIP: "12574",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -122.3530500003572,
    Y: 37.93608499932333,
    OBJECTID: 668,
    STNCODE: "RIC",
    STNNAME: "Richmond, California",
    ADDRESS1: "1700 Nevin Avenue",
    ADDRESS2: "BART Station",
    CITY: "Richmond",
    STATE: "CA",
    ZIP: "94802",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -117.36962100020895,
    Y: 33.97652100054381,
    OBJECTID: 669,
    STNCODE: "RIV",
    STNNAME: "Riverside, California",
    ADDRESS1: "4066 Vine St.",
    ADDRESS2: "Metrolink Station",
    CITY: "Riverside",
    STATE: "CA",
    ZIP: "92507-4223",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -85.55965399983216,
    Y: 43.11909500043396,
    OBJECTID: 670,
    STNCODE: "RKF",
    STNNAME: "Rockford, Michigan",
    ADDRESS1: "US 131 & 10 Mile Road NE",
    ADDRESS2: "Amoco Station, Exit 97",
    CITY: "Rockford",
    STATE: "MI",
    ZIP: "49341",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -77.14667017688714,
    Y: 39.08451762438892,
    OBJECTID: 671,
    STNCODE: "RKV",
    STNNAME: "Rockville, Maryland",
    ADDRESS1: "251 Hungerford Drive at Park Rd.",
    ADDRESS2: "Metro/Amtrak/MARC station",
    CITY: "Rockville",
    STATE: "MD",
    ZIP: "20850",
    STNTYPE: "RAIL",
    STFIPS: 24,
  },
  {
    X: -121.23627499969143,
    Y: 38.791546000347694,
    OBJECTID: 672,
    STNCODE: "RLN",
    STNNAME: "Rocklin, California",
    ADDRESS1: "Rocklin Rd. and Railroad Ave.",
    ADDRESS2: "",
    CITY: "Rocklin",
    STATE: "CA",
    ZIP: "95677",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -77.7978970001464,
    Y: 35.938151999715046,
    OBJECTID: 673,
    STNCODE: "RMT",
    STNNAME: "Rocky Mount, North Carolina",
    ADDRESS1: "101 Hammond Street",
    ADDRESS2: "",
    CITY: "Rocky Mount",
    STATE: "NC",
    ZIP: "27804-5820",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -119.8112340006486,
    Y: 39.5286409999822,
    OBJECTID: 674,
    STNCODE: "RNO",
    STNNAME: "Reno, Nevada",
    ADDRESS1: "280 North Center St.",
    ADDRESS2: "East Commercial Row and Center St., by Harrah's Ca",
    CITY: "Reno",
    STATE: "NV",
    ZIP: "89501-1425",
    STNTYPE: "RAIL",
    STFIPS: 32,
  },
  {
    X: -77.60952800001712,
    Y: 43.16260499962107,
    OBJECTID: 675,
    STNCODE: "ROC",
    STNNAME: "Rochester, New York",
    ADDRESS1: "320 Central Avenue",
    ADDRESS2: "",
    CITY: "Rochester",
    STATE: "NY",
    ZIP: "14605",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -69.10918232300577,
    Y: 44.10658588023426,
    OBJECTID: 676,
    STNCODE: "ROD",
    STNNAME: "Rockland, Maine",
    ADDRESS1: "517A Main St.",
    ADDRESS2: "Maine State Ferry Terminal",
    CITY: "Rockland",
    STATE: "ME",
    ZIP: "04841-3366",
    STNTYPE: "BUS",
    STFIPS: 23,
  },
  {
    X: -75.45143900000983,
    Y: 43.19922599948035,
    OBJECTID: 677,
    STNCODE: "ROM",
    STNNAME: "Rome, New York",
    ADDRESS1: "6599 Martin Street",
    ADDRESS2: "",
    CITY: "Rome",
    STATE: "NY",
    ZIP: "13440",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -83.14784199950861,
    Y: 42.48904399988072,
    OBJECTID: 678,
    STNCODE: "ROY",
    STNNAME: "Royal Oak, Michigan",
    ADDRESS1: "202 South Sherman Ave.",
    ADDRESS2: "",
    CITY: "Royal Oak",
    STATE: "MI",
    ZIP: "48069",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -122.70992179945148,
    Y: 38.34802123419263,
    OBJECTID: 679,
    STNCODE: "RPC",
    STNNAME: "Rohnert Park, California",
    ADDRESS1: "6335 Redwood Drive",
    ADDRESS2: "Transit Stop",
    CITY: "Rohnert Park",
    STATE: "CA",
    ZIP: "94928",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -72.66584800008508,
    Y: 43.92285499955864,
    OBJECTID: 680,
    STNCODE: "RPH",
    STNNAME: "Randolph, Vermont",
    ADDRESS1: "South Main and Salisbury Sts.",
    ADDRESS2: "Depot Square",
    CITY: "Randolph",
    STATE: "VT",
    ZIP: "05060",
    STNTYPE: "RAIL",
    STFIPS: 50,
  },
  {
    X: -124.11159934703221,
    Y: 43.69841050584023,
    OBJECTID: 681,
    STNCODE: "RPT",
    STNNAME: "Reedsport, Oregon",
    ADDRESS1: "1401 Highway 101 South",
    ADDRESS2: "Sunrise Shop-n-Save",
    CITY: "Reedsport",
    STATE: "OR",
    ZIP: "97467-1605",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -73.37109400048769,
    Y: 44.99480099956651,
    OBJECTID: 683,
    STNCODE: "RSP",
    STNNAME: "Rouses Point, New York",
    ADDRESS1: "Delaware and Pratt Sts.",
    ADDRESS2: "",
    CITY: "Rouses Point",
    STATE: "NY",
    ZIP: "12979",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -121.28446199962156,
    Y: 38.75056500087413,
    OBJECTID: 684,
    STNCODE: "RSV",
    STNNAME: "Roseville, California",
    ADDRESS1: "201 Pacific Street",
    ADDRESS2: "",
    CITY: "Roseville",
    STATE: "CA",
    ZIP: "95678-2242",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -71.14993999973115,
    Y: 42.2078740000851,
    OBJECTID: 685,
    STNCODE: "RTE",
    STNNAME: "Westwood, Route 128 Station, Massachusetts",
    ADDRESS1: "50 University Ave",
    ADDRESS2: "",
    CITY: "Westwood",
    STATE: "MA",
    ZIP: "02090-2307",
    STNTYPE: "RAIL",
    STFIPS: 25,
  },
  {
    X: -88.15972832090523,
    Y: 40.31051202481012,
    OBJECTID: 686,
    STNCODE: "RTL",
    STNNAME: "Rantoul, Illinois",
    ADDRESS1: "West Sangamon and North Kentucky Aves.",
    ADDRESS2: "",
    CITY: "Rantoul",
    STATE: "IL",
    ZIP: "61866",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -118.36475068999232,
    Y: 47.11902072102953,
    OBJECTID: 687,
    STNCODE: "RTZ",
    STNNAME: "Ritzville, Washington",
    ADDRESS1: "1503 South Smittys Blvd.",
    ADDRESS2: "Zips Drive Inn",
    CITY: "Ritzville",
    STATE: "WA",
    ZIP: "99169",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -72.98224600025264,
    Y: 43.60725800035647,
    OBJECTID: 688,
    STNCODE: "RUD",
    STNNAME: "Rutland, Vermont",
    ADDRESS1: "25 Evelyn Street",
    ADDRESS2: "",
    CITY: "Rutland",
    STATE: "VT",
    ZIP: "05701",
    STNTYPE: "RAIL",
    STFIPS: 50,
  },
  {
    X: -99.99762699998604,
    Y: 48.36928599964921,
    OBJECTID: 689,
    STNCODE: "RUG",
    STNNAME: "Rugby, North Dakota",
    ADDRESS1: "201 West Dewey Street",
    ADDRESS2: "",
    CITY: "Rugby",
    STATE: "ND",
    ZIP: "58368",
    STNTYPE: "RAIL",
    STFIPS: 38,
  },
  {
    X: -77.42979000040816,
    Y: 37.53406000026882,
    OBJECTID: 690,
    STNCODE: "RVM",
    STNNAME: "Richmond (Main St), Virginia",
    ADDRESS1: "1500 East Main Street",
    ADDRESS2: "",
    CITY: "Richmond",
    STATE: "VA",
    ZIP: "23219",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -77.49658199945969,
    Y: 37.61425000023735,
    OBJECTID: 691,
    STNCODE: "RVR",
    STNNAME: "Richmond (Staples Mill Rd), Virginia",
    ADDRESS1: "7519 Staples Mill Road",
    ADDRESS2: "",
    CITY: "Richmond",
    STATE: "VA",
    ZIP: "23228",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -73.08641100056718,
    Y: 44.810951000088664,
    OBJECTID: 692,
    STNCODE: "SAB",
    STNNAME: "St. Albans, Vermont",
    ADDRESS1: "40 Federal Street",
    ADDRESS2: "",
    CITY: "St Albans",
    STATE: "VT",
    ZIP: "05478",
    STNTYPE: "RAIL",
    STFIPS: 50,
  },
  {
    X: -121.49955000073192,
    Y: 38.584030000384246,
    OBJECTID: 693,
    STNCODE: "SAC",
    STNNAME: "Sacramento, California",
    ADDRESS1: "401 I Street",
    ADDRESS2: "",
    CITY: "Sacramento",
    STATE: "CA",
    ZIP: "95814-2308",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -105.92501800038036,
    Y: 35.685897999693,
    OBJECTID: 694,
    STNCODE: "SAF",
    STNNAME: "Santa Fe (Lamy Shuttle), New Mexico",
    ADDRESS1: "No specific stop location",
    ADDRESS2: "Door to door service",
    CITY: "Santa Fe",
    STATE: "NM",
    ZIP: "87501",
    STNTYPE: "BUS",
    STFIPS: 35,
  },
  {
    X: -80.45742000053258,
    Y: 35.673419999833186,
    OBJECTID: 695,
    STNCODE: "SAL",
    STNNAME: "Salisbury, North Carolina",
    ADDRESS1: "Depot and Liberty Sts.",
    ADDRESS2: "",
    CITY: "Salisbury",
    STATE: "NC",
    ZIP: "28144",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -117.16856399952894,
    Y: 32.71616400026846,
    OBJECTID: 696,
    STNCODE: "SAN",
    STNNAME: "San Diego (Downtown), California",
    ADDRESS1: "1050 Kettner Blvd",
    ADDRESS2: "",
    CITY: "San Diego",
    STATE: "CA",
    ZIP: "92101-3339",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -70.44761200079319,
    Y: 43.496303999929694,
    OBJECTID: 697,
    STNCODE: "SAO",
    STNNAME: "Saco, Maine",
    ADDRESS1: "130 Main Street",
    ADDRESS2: "Saco Island on Main Street",
    CITY: "Saco",
    STATE: "ME",
    ZIP: "04072-3502",
    STNTYPE: "RAIL",
    STFIPS: 23,
  },
  {
    X: -119.0694430002942,
    Y: 34.34771300045463,
    OBJECTID: 698,
    STNCODE: "SAP",
    STNNAME: "Santa Paula, California",
    ADDRESS1: "245 South Palm Avenue",
    ADDRESS2: "at Highway 126",
    CITY: "Santa Paula",
    STATE: "CA",
    ZIP: "93060-3376",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -73.81015799979184,
    Y: 43.082115000207125,
    OBJECTID: 699,
    STNCODE: "SAR",
    STNNAME: "Saratoga Springs, New York",
    ADDRESS1: "26 Station Lane",
    ADDRESS2: "",
    CITY: "Saratoga Springs",
    STATE: "NY",
    ZIP: "12866",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -98.47813399978423,
    Y: 29.419104000349364,
    OBJECTID: 700,
    STNCODE: "SAS",
    STNNAME: "San Antonio, Texas",
    ADDRESS1: "350 Hoefgen Street",
    ADDRESS2: "",
    CITY: "San Antonio",
    STATE: "TX",
    ZIP: "78205",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -120.41525299952627,
    Y: 34.95112999944996,
    OBJECTID: 701,
    STNCODE: "SAT",
    STNNAME: "Santa Maria, California",
    ADDRESS1: "205 South Nicholson Avenue",
    ADDRESS2: "International House of Pancakes",
    CITY: "Santa Maria",
    STATE: "CA",
    ZIP: "93455",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -81.14415699994555,
    Y: 32.078505999652236,
    OBJECTID: 702,
    STNCODE: "SAV",
    STNNAME: "Savannah, Georgia",
    ADDRESS1: "2611 Seaboard Coastline Drive",
    ADDRESS2: "",
    CITY: "Savannah",
    STATE: "GA",
    ZIP: "31401-1634",
    STNTYPE: "RAIL",
    STFIPS: 13,
  },
  {
    X: -119.69072000002797,
    Y: 34.41392499973898,
    OBJECTID: 703,
    STNCODE: "SBA",
    STNNAME: "Santa Barbara, California",
    ADDRESS1: "209 State Street",
    ADDRESS2: "",
    CITY: "Santa Barbara",
    STATE: "CA",
    ZIP: "93101-3833",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -81.4347460006274,
    Y: 27.497257000310356,
    OBJECTID: 705,
    STNCODE: "SBG",
    STNNAME: "Sebring, Florida",
    ADDRESS1: "601 East Center St",
    ADDRESS2: "",
    CITY: "Sebring",
    STATE: "FL",
    ZIP: "33870-3513",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -111.85322600067934,
    Y: 48.50531399984129,
    OBJECTID: 706,
    STNCODE: "SBY",
    STNNAME: "Shelby, Montana",
    ADDRESS1: "230 W Central Avenue",
    ADDRESS2: "",
    CITY: "Shelby",
    STATE: "MT",
    ZIP: "59474-2050",
    STNTYPE: "RAIL",
    STFIPS: 30,
  },
  {
    X: -121.93820021656671,
    Y: 37.35199727655311,
    OBJECTID: 708,
    STNCODE: "SCC",
    STNNAME: "Santa Clara (Caltrain/ACE), California",
    ADDRESS1: "1001 Railroad Ave.",
    ADDRESS2: "",
    CITY: "Santa Clara",
    STATE: "CA",
    ZIP: "95050-4319",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -94.1477890002621,
    Y: 45.566891000019666,
    OBJECTID: 709,
    STNCODE: "SCD",
    STNNAME: "St. Cloud, Minnesota",
    ADDRESS1: "555 East St. Germain Street",
    ADDRESS2: "",
    CITY: "St. Cloud",
    STATE: "MN",
    ZIP: "56304-0751",
    STNTYPE: "RAIL",
    STFIPS: 27,
  },
  {
    X: -90.81265299993595,
    Y: 29.74690799950463,
    OBJECTID: 710,
    STNCODE: "SCH",
    STNNAME: "Schriever, Louisiana",
    ADDRESS1: "Hwy 20 and Hwy 24",
    ADDRESS2: "",
    CITY: "Schriever",
    STATE: "LA",
    ZIP: "70395",
    STNTYPE: "RAIL",
    STFIPS: 22,
  },
  {
    X: -121.49528921792302,
    Y: 38.57590796937734,
    OBJECTID: 711,
    STNCODE: "SCS",
    STNNAME: "Sacramento (State Capitol), California",
    ADDRESS1: "1389 10th Street",
    ADDRESS2: "Drop-Only Bus Stop",
    CITY: "Sacramento",
    STATE: "CA",
    ZIP: "95814-4905",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -122.02394100037685,
    Y: 36.9705009993217,
    OBJECTID: 712,
    STNCODE: "SCZ",
    STNNAME: "Santa Cruz (Metro Center), California",
    ADDRESS1: "920 Pacific Ave",
    ADDRESS2: "Highway 17 Express - Metro Center Boards Lane 2",
    CITY: "Santa Cruz",
    STATE: "CA",
    ZIP: "95060",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -89.78243299958325,
    Y: 30.278232999653255,
    OBJECTID: 713,
    STNCODE: "SDL",
    STNNAME: "Slidell, Louisiana",
    ADDRESS1: "1827 Front Street",
    ADDRESS2: "",
    CITY: "Slidell",
    STATE: "LA",
    ZIP: "70458",
    STNTYPE: "RAIL",
    STFIPS: 22,
  },
  {
    X: -73.94282499967397,
    Y: 42.81526599982607,
    OBJECTID: 714,
    STNCODE: "SDY",
    STNNAME: "Schenectady, New York",
    ADDRESS1: "332 Erie Blvd.",
    ADDRESS2: "",
    CITY: "Schenectady",
    STATE: "NY",
    ZIP: "12305-1817",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -122.32842999994449,
    Y: 47.59891100044234,
    OBJECTID: 716,
    STNCODE: "SEA",
    STNNAME: "Seattle (Amtrak), Washington",
    ADDRESS1: "303 South Jackson Street",
    ADDRESS2: "King St. Station",
    CITY: "Seattle",
    STATE: "WA",
    ZIP: "98104-2868",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -93.22837799994471,
    Y: 38.711871999892935,
    OBJECTID: 717,
    STNCODE: "SED",
    STNNAME: "Sedalia, Missouri",
    ADDRESS1: "100 block of Main Street, through parking lot",
    ADDRESS2: "Temporary entrance due to construction",
    CITY: "Sedalia",
    STATE: "MO",
    ZIP: "65301",
    STNTYPE: "RAIL",
    STFIPS: 29,
  },
  {
    X: -81.28858200065878,
    Y: 28.807592000370562,
    OBJECTID: 718,
    STNCODE: "SFA",
    STNNAME: "Sanford (Auto Train), Florida",
    ADDRESS1: "600 South Persimmon Avenue",
    ADDRESS2: "",
    CITY: "Sanford",
    STATE: "FL",
    ZIP: "32771-2385",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -122.39318799962643,
    Y: 37.79525399977234,
    OBJECTID: 719,
    STNCODE: "SFC",
    STNNAME: "San Francisco (Ferry), California",
    ADDRESS1: "101 The Embarcadero",
    ADDRESS2: "at Mission St. and The Embarcadero",
    CITY: "San Francisco",
    STATE: "CA",
    ZIP: "94105-1216",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -122.39518700007994,
    Y: 37.79390699970833,
    OBJECTID: 720,
    STNCODE: "SFF",
    STNNAME: "San Francisco (Financial), California",
    ADDRESS1: "5 Embarcadero Center",
    ADDRESS2: "Corner of California & Drumm Streets",
    CITY: "San Francisco",
    STATE: "CA",
    ZIP: "94111-4800",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -122.40125636538892,
    Y: 37.78415346361152,
    OBJECTID: 721,
    STNCODE: "SFM",
    STNNAME: "San Francisco (Conv Ctr), California",
    ADDRESS1: "747 Howard St.",
    ADDRESS2: "4th & Howard Sts. - Moscone Convention Ctr.",
    CITY: "San Francisco",
    STATE: "CA",
    ZIP: "94103-3118",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -122.3937230000164,
    Y: 37.77701600048806,
    OBJECTID: 722,
    STNCODE: "SFP",
    STNNAME: "San Francisco (Caltrain), California",
    ADDRESS1: "700 4th St.",
    ADDRESS2: "Fourth and Townsend Sts. - Caltrain Station",
    CITY: "San Francisco",
    STATE: "CA",
    ZIP: "94107-1617",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -122.4063189999219,
    Y: 37.78476000057361,
    OBJECTID: 723,
    STNCODE: "SFS",
    STNNAME: "San Francisco (Shopping), California",
    ADDRESS1: "835 Market Street",
    ADDRESS2: "Westfield San Francisco Centre",
    CITY: "San Francisco",
    STATE: "CA",
    ZIP: "94103-1901",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -122.40892000025775,
    Y: 37.8085939998133,
    OBJECTID: 724,
    STNCODE: "SFW",
    STNNAME: "San Francisco (Wharf), California",
    ADDRESS1: "Beach St. & The Embarcadero",
    ADDRESS2: "Pier 39 - Fisherman's Wharf",
    CITY: "San Francisco",
    STATE: "CA",
    ZIP: "94133",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -93.7450031261933,
    Y: 32.51665435151716,
    OBJECTID: 725,
    STNCODE: "SHR",
    STNNAME: "Shreveport, Louisiana",
    ADDRESS1: "451 Clyde Fant Parkway",
    ADDRESS2: "Eldorado Casino Hotel, bus lobby",
    CITY: "Shreveport",
    STATE: "LA",
    ZIP: "71101-3206",
    STNTYPE: "BUS",
    STFIPS: 22,
  },
  {
    X: -118.69371799998567,
    Y: 34.2699469998542,
    OBJECTID: 726,
    STNCODE: "SIM",
    STNNAME: "Simi Valley, California",
    ADDRESS1: "5050 Los Angeles Avenue",
    ADDRESS2: "Amtrak/Metrolink Station",
    CITY: "Simi Valley",
    STATE: "CA",
    ZIP: "93063",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -121.90120699990308,
    Y: 37.33107000038029,
    OBJECTID: 727,
    STNCODE: "SJC",
    STNNAME: "San Jose, California",
    ADDRESS1: "65 Cahill Street",
    ADDRESS2: "",
    CITY: "San Jose",
    STATE: "CA",
    ZIP: "95110",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -86.48674800012009,
    Y: 42.10661699987469,
    OBJECTID: 728,
    STNCODE: "SJM",
    STNNAME: "St. Joseph, Michigan",
    ADDRESS1: "410 1/2 Vine Street",
    ADDRESS2: "",
    CITY: "St. Joseph",
    STATE: "MI",
    ZIP: "49085",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -121.28427099980678,
    Y: 37.946011000207534,
    OBJECTID: 729,
    STNCODE: "SKN",
    STNNAME: "Stockton (711-718), California",
    ADDRESS1: "735 S. San Joaquin St",
    ADDRESS2: "",
    CITY: "Stockton",
    STATE: "CA",
    ZIP: "95203",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -121.27898899994238,
    Y: 37.95666799972844,
    OBJECTID: 730,
    STNCODE: "SKT",
    STNNAME: "Stockton (ACE, 701-704), California",
    ADDRESS1: "949 East Channel St.",
    ADDRESS2: "Robert J. Cabral Station",
    CITY: "Stockton",
    STATE: "CA",
    ZIP: "95202",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -121.35928300021027,
    Y: 47.71152500007872,
    OBJECTID: 731,
    STNCODE: "SKW",
    STNNAME: "Skykomish, Washington",
    ADDRESS1: "90000 Highway 2",
    ADDRESS2: "(westbound - Sky Chalet)",
    CITY: "Skykomish",
    STATE: "WA",
    ZIP: "98288",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -82.71861008398815,
    Y: 41.44075239190943,
    OBJECTID: 732,
    STNCODE: "SKY",
    STNNAME: "Sandusky, Ohio",
    ADDRESS1: "1200 North Depot St.",
    ADDRESS2: "at Shelby St.",
    CITY: "Sandusky",
    STATE: "OH",
    ZIP: "44870-3165",
    STNTYPE: "RAIL",
    STFIPS: 39,
  },
  {
    X: -111.902382000329,
    Y: 40.76201599973865,
    OBJECTID: 733,
    STNCODE: "SLC",
    STNNAME: "Salt Lake City, Utah",
    ADDRESS1: "340 South 600 West",
    ADDRESS2: "",
    CITY: "Salt Lake City",
    STATE: "UT",
    ZIP: "84101",
    STNTYPE: "RAIL",
    STFIPS: 49,
  },
  {
    X: -119.94116200012616,
    Y: 38.95949599954082,
    OBJECTID: 735,
    STNCODE: "SLH",
    STNNAME: "Stateline Transit Center, California",
    ADDRESS1: "4114 Lake Tahoe Blvd",
    ADDRESS2: "Transportation Center",
    CITY: "Stateline",
    STATE: "CA",
    ZIP: "96150",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -123.02623699993757,
    Y: 44.93217099999168,
    OBJECTID: 736,
    STNCODE: "SLM",
    STNNAME: "Salem, Oregon",
    ADDRESS1: "500 13th Street SE",
    ADDRESS2: "",
    CITY: "Salem",
    STATE: "OR",
    ZIP: "97301",
    STNTYPE: "RAIL",
    STFIPS: 41,
  },
  {
    X: -120.6539460001078,
    Y: 35.277416000548044,
    OBJECTID: 737,
    STNCODE: "SLO",
    STNNAME: "San Luis Obispo, California",
    ADDRESS1: "1011 Railroad Avenue",
    ADDRESS2: "",
    CITY: "San Luis Obispo",
    STATE: "CA",
    ZIP: "93401-4449",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -120.65184799958547,
    Y: 35.292580000166936,
    OBJECTID: 738,
    STNCODE: "SLP",
    STNNAME: "San Luis Obispo (Cal Poly), California",
    ADDRESS1: "Grand Avenue & Deer Road",
    ADDRESS2: "Vista Grande Restaurant",
    CITY: "San Luis Obispo",
    STATE: "CA",
    ZIP: "93401",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -120.00222000005294,
    Y: 38.91470699982824,
    OBJECTID: 740,
    STNCODE: "SLT",
    STNNAME: "South Lake Tahoe, California",
    ADDRESS1: "1000 Emerald Bay Road",
    ADDRESS2: "South Y Transit Center",
    CITY: "South Lake Tahoe",
    STATE: "CA",
    ZIP: "96151",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -120.13730599997189,
    Y: 34.59594700035382,
    OBJECTID: 741,
    STNCODE: "SLV",
    STNNAME: "Solvang, California",
    ADDRESS1: "1630 Mission Drive",
    ADDRESS2: "",
    CITY: "Solvang",
    STATE: "CA",
    ZIP: "93463",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -75.60645598645459,
    Y: 38.36946389294434,
    OBJECTID: 742,
    STNCODE: "SLY",
    STNNAME: "Salisbury, Maryland",
    ADDRESS1: "350 Cypress St.",
    ADDRESS2: "Greyhound Station",
    CITY: "Salisbury",
    STATE: "MD",
    ZIP: "21801-4036",
    STNTYPE: "BUS",
    STFIPS: 24,
  },
  {
    X: -97.93567699979366,
    Y: 29.879232000656373,
    OBJECTID: 743,
    STNCODE: "SMC",
    STNNAME: "San Marcos, Texas",
    ADDRESS1: "338 South Guadalupe St.",
    ADDRESS2: "San Marcos Intermodal Station",
    CITY: "San Marcos",
    STATE: "TX",
    ZIP: "78666-6310",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -89.31249200000576,
    Y: 43.04799999990013,
    OBJECTID: 744,
    STNCODE: "SMD",
    STNNAME: "Madison (South), Wisconsin",
    ADDRESS1: "Hwy 51 & East Broadway Ave.",
    ADDRESS2: "Dutch Mill Park and Ride",
    CITY: "Madison",
    STATE: "WI",
    ZIP: "53716",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -87.81317899961113,
    Y: 41.79216399946904,
    OBJECTID: 745,
    STNCODE: "SMT",
    STNNAME: "Summit, Illinois",
    ADDRESS1: "Archer Ave. and South Center Ave.",
    ADDRESS2: "",
    CITY: "Summit",
    STATE: "IL",
    ZIP: "60501",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -117.8550419995886,
    Y: 33.75316599951134,
    OBJECTID: 746,
    STNCODE: "SNA",
    STNNAME: "Santa Ana, California",
    ADDRESS1: "1000 East Santa Ana Boulevard",
    ADDRESS2: "Santa Ana Regional Transportation Center",
    CITY: "Santa Ana",
    STATE: "CA",
    ZIP: "92701",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -117.30693100056521,
    Y: 34.10436200000635,
    OBJECTID: 747,
    STNCODE: "SNB",
    STNNAME: "San Bernardino (Amtrak Station), California",
    ADDRESS1: "1170 West Third Street (all Trains and Buses)",
    ADDRESS2: "** Night Buses will drop at McDonalds, 699 2nd St.",
    CITY: "San Bernardino",
    STATE: "CA",
    ZIP: "92410",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -117.66326099949549,
    Y: 33.501483999786785,
    OBJECTID: 748,
    STNCODE: "SNC",
    STNNAME: "San Juan Capistrano, California",
    ADDRESS1: "26701 Verdugo Street",
    ADDRESS2: "",
    CITY: "San Juan Capistrano",
    STATE: "CA",
    ZIP: "92675",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -102.39905499988828,
    Y: 30.140098999469274,
    OBJECTID: 749,
    STNCODE: "SND",
    STNNAME: "Sanderson, Texas",
    ADDRESS1: "201 West Downey Street",
    ADDRESS2: "",
    CITY: "Sanderson",
    STATE: "TX",
    ZIP: "79848",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -117.61901100035737,
    Y: 33.419159000287664,
    OBJECTID: 750,
    STNCODE: "SNP",
    STNNAME: "San Clemente Pier, California",
    ADDRESS1: "Avenida del Mar and Avenida Victoria",
    ADDRESS2: "(615 Avenida Victoria) at the San Clemente Pier",
    CITY: "San Clemente",
    STATE: "CA",
    ZIP: "92672",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -121.65618899992239,
    Y: 36.67936299940294,
    OBJECTID: 751,
    STNCODE: "SNS",
    STNNAME: "Salinas, California",
    ADDRESS1: "Station Place and Railroad Avenue",
    ADDRESS2: "(30 Station Place)",
    CITY: "Salinas",
    STATE: "CA",
    ZIP: "93901-1432",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -86.2891460004875,
    Y: 41.67900800001922,
    OBJECTID: 752,
    STNCODE: "SOB",
    STNNAME: "South Bend, Indiana",
    ADDRESS1: "2702 West Washington Avenue",
    ADDRESS2: "",
    CITY: "South Bend",
    STATE: "IN",
    ZIP: "46628",
    STNTYPE: "RAIL",
    STFIPS: 18,
  },
  {
    X: -120.370789000412,
    Y: 39.32358900033216,
    OBJECTID: 753,
    STNCODE: "SOD",
    STNNAME: "Soda Springs, California",
    ADDRESS1: "22002 Donner Pass Rd.",
    ADDRESS2: "Donner Summit Lodge",
    CITY: "Soda Springs",
    STATE: "CA",
    ZIP: "95728",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -117.27007299966914,
    Y: 32.992054000291944,
    OBJECTID: 754,
    STNCODE: "SOL",
    STNNAME: "Solana Beach, California",
    ADDRESS1: "105 North Cedros Avenue",
    ADDRESS2: "Solana Beach Transit Center",
    CITY: "Solana Beach",
    STATE: "CA",
    ZIP: "92075",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -79.39189900003879,
    Y: 35.17409900066838,
    OBJECTID: 755,
    STNCODE: "SOP",
    STNNAME: "Southern Pines, North Carolina",
    ADDRESS1: "235 Northwest Broad Street",
    ADDRESS2: "",
    CITY: "Southern Pines",
    STATE: "NC",
    ZIP: "28387",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -81.93573799950906,
    Y: 34.95376999978572,
    OBJECTID: 756,
    STNCODE: "SPB",
    STNNAME: "Spartanburg, South Carolina",
    ADDRESS1: "290 Magnolia St",
    ADDRESS2: "",
    CITY: "Spartanburg",
    STATE: "SC",
    ZIP: "29303",
    STNTYPE: "RAIL",
    STFIPS: 45,
  },
  {
    X: -118.27660399937503,
    Y: 33.74841699994465,
    OBJECTID: 757,
    STNCODE: "SPD",
    STNNAME: "San Pedro (Catalina Terminal), California",
    ADDRESS1: "1st Stop:  N.Front & Swinford, Berth 95, Catalina",
    ADDRESS2: "Catalina Terminal (Air and Sea)",
    CITY: "San Pedro",
    STATE: "CA",
    ZIP: "90731",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -72.59358999987853,
    Y: 42.10596100020007,
    OBJECTID: 758,
    STNCODE: "SPG",
    STNNAME: "Springfield, Massachusetts",
    ADDRESS1: "66 Lyman St.",
    ADDRESS2: "",
    CITY: "Springfield",
    STATE: "MA",
    ZIP: "01103",
    STNTYPE: "RAIL",
    STFIPS: 25,
  },
  {
    X: -89.65167199946319,
    Y: 39.80158599999396,
    OBJECTID: 759,
    STNCODE: "SPI",
    STNNAME: "Springfield, Illinois",
    ADDRESS1: "East Washington and North Third Sts.",
    ADDRESS2: "",
    CITY: "Springfield",
    STATE: "IL",
    ZIP: "62701-1106",
    STNTYPE: "RAIL",
    STFIPS: 17,
  },
  {
    X: -117.41306299985752,
    Y: 47.65698600040366,
    OBJECTID: 760,
    STNCODE: "SPK",
    STNNAME: "Spokane, Washington",
    ADDRESS1: "221 W. 1st Avenue",
    ADDRESS2: "Spokane Train and Bus Station",
    CITY: "Spokane",
    STATE: "WA",
    ZIP: "99201-3704",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -94.79511300056447,
    Y: 46.35458800033598,
    OBJECTID: 761,
    STNCODE: "SPL",
    STNNAME: "Staples, Minnesota",
    ADDRESS1: "First & Fourth Aves",
    ADDRESS2: "",
    CITY: "Staples",
    STATE: "MN",
    ZIP: "56479",
    STNTYPE: "RAIL",
    STFIPS: 27,
  },
  {
    X: -82.9642870001449,
    Y: 38.72091299953536,
    OBJECTID: 762,
    STNCODE: "SPM",
    STNNAME: "South Shore-South Portsmouth, Kentucky",
    ADDRESS1: "Main St & US 23",
    ADDRESS2: "",
    CITY: "South Shore",
    STATE: "KY",
    ZIP: "41174",
    STNTYPE: "RAIL",
    STFIPS: 21,
  },
  {
    X: -118.29250477397608,
    Y: 33.73595451069218,
    OBJECTID: 763,
    STNCODE: "SPO",
    STNNAME: "San Pedro (Downtown), California",
    ADDRESS1: "931 S. Gaffey St.",
    ADDRESS2: "",
    CITY: "San Pedro",
    STATE: "CA",
    ZIP: "90731",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -119.75541800054026,
    Y: 39.53364899980153,
    OBJECTID: 764,
    STNCODE: "SPR",
    STNNAME: "Sparks, Nevada (Train Stop)",
    ADDRESS1: "Nugget Ave. east of 11th St.",
    ADDRESS2: "SP/UP Rail Yard",
    CITY: "Sparks",
    STATE: "NV",
    ZIP: "89431",
    STNTYPE: "RAIL",
    STFIPS: 32,
  },
  {
    X: -116.60822300039115,
    Y: 48.25175899917855,
    OBJECTID: 765,
    STNCODE: "SPT",
    STNNAME: "Sandpoint, Idaho",
    ADDRESS1: "450 Railroad Avenue",
    ADDRESS2: "Former Northern Pacific Station",
    CITY: "Sandpoint",
    STATE: "ID",
    ZIP: "83864",
    STNTYPE: "RAIL",
    STFIPS: 16,
  },
  {
    X: -119.75552141448168,
    Y: 39.53333564452441,
    OBJECTID: 766,
    STNCODE: "SPX",
    STNNAME: "Sparks, Nevada (Thruway Buses)",
    ADDRESS1: "1100 Nugget Avenue",
    ADDRESS2: "John Ascuaga's Nugget Hotel and Casino",
    CITY: "Sparks",
    STATE: "NV",
    ZIP: "89431",
    STNTYPE: "BUS",
    STFIPS: 32,
  },
  {
    X: -82.53127223032914,
    Y: 27.336577884961457,
    OBJECTID: 768,
    STNCODE: "SRA",
    STNNAME: "Sarasota, Florida",
    ADDRESS1: "1993 Main Street",
    ADDRESS2: "US 301 and Main Street, Hollywood 20 complex",
    CITY: "Sarasota",
    STATE: "FL",
    ZIP: "34231",
    STNTYPE: "BUS",
    STFIPS: 12,
  },
  {
    X: -122.71719399990315,
    Y: 38.43672600000497,
    OBJECTID: 769,
    STNCODE: "SRC",
    STNNAME: "Santa Rosa, California",
    ADDRESS1: "175 Railroad Street",
    ADDRESS2: "Courtyard Marriott Hotel",
    CITY: "Santa Rosa",
    STATE: "CA",
    ZIP: "95401",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -68.90881842712867,
    Y: 44.461524881568096,
    OBJECTID: 770,
    STNCODE: "SRT",
    STNNAME: "Searsport, Maine",
    ADDRESS1: "161 East Main St.",
    ADDRESS2: "Steamboat Mobil",
    CITY: "Searsport",
    STATE: "ME",
    ZIP: "04974-3322",
    STNTYPE: "BUS",
    STFIPS: 23,
  },
  {
    X: -123.92363895027728,
    Y: 45.98659015041517,
    OBJECTID: 771,
    STNCODE: "SSD",
    STNNAME: "Seaside, Oregon",
    ADDRESS1: "1215 S. Holladay Drive",
    ADDRESS2: "Del's Chevron, South Holladay Dr at US 101/26",
    CITY: "Seaside",
    STATE: "OR",
    ZIP: "97301",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -78.28144100020194,
    Y: 35.53220399961492,
    OBJECTID: 772,
    STNCODE: "SSM",
    STNNAME: "Selma, North Carolina",
    ADDRESS1: "500 East Railroad Street",
    ADDRESS2: "",
    CITY: "Selma",
    STATE: "NC",
    ZIP: "27576",
    STNTYPE: "RAIL",
    STFIPS: 37,
  },
  {
    X: -121.14437900039053,
    Y: 47.71377200027763,
    OBJECTID: 773,
    STNCODE: "SSW",
    STNNAME: "Stevens Pass, Washington",
    ADDRESS1: "US Highway 2 at Summit Parking Lot",
    ADDRESS2: "WB stop on north side, EB stop on south side US2",
    CITY: "Stevens Pass",
    STATE: "WA",
    ZIP: "98826",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -79.07272300036612,
    Y: 38.14778099959352,
    OBJECTID: 774,
    STNCODE: "STA",
    STNNAME: "Staunton, Virginia",
    ADDRESS1: "1 Middlebrook Avenue",
    ADDRESS2: "",
    CITY: "Staunton",
    STATE: "VA",
    ZIP: "24401",
    STNTYPE: "RAIL",
    STFIPS: 51,
  },
  {
    X: -113.58480788887294,
    Y: 37.087825289905254,
    OBJECTID: 775,
    STNCODE: "STG",
    STNNAME: "St. George, Utah",
    ADDRESS1: "1235 South Bluff St.",
    ADDRESS2: "McDonalds Restaurant",
    CITY: "St. George",
    STATE: "UT",
    ZIP: "84770-5249",
    STNTYPE: "BUS",
    STFIPS: 49,
  },
  {
    X: -84.73040799992924,
    Y: 45.8699649999848,
    OBJECTID: 776,
    STNCODE: "STI",
    STNNAME: "St. Ignace, Michigan",
    ADDRESS1: "448 North State St.",
    ADDRESS2: "St. Ignace Bus Station",
    CITY: "St. Ignace",
    STATE: "MI",
    ZIP: "49781-1427",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -90.20545200000976,
    Y: 38.62394700025391,
    OBJECTID: 777,
    STNCODE: "STL",
    STNNAME: "St. Louis, Missouri",
    ADDRESS1: "551 South 16th St.",
    ADDRESS2: "",
    CITY: "St. Louis",
    STATE: "MO",
    ZIP: "63103",
    STNTYPE: "RAIL",
    STFIPS: 29,
  },
  {
    X: -73.54267900003578,
    Y: 41.04618100005314,
    OBJECTID: 778,
    STNCODE: "STM",
    STNNAME: "Stamford, Connecticut",
    ADDRESS1: "Washington Blvd and South State St.",
    ADDRESS2: "Amtrak/Metro-North Station",
    CITY: "Stamford",
    STATE: "CT",
    ZIP: "06902",
    STNTYPE: "RAIL",
    STFIPS: 9,
  },
  {
    X: -102.39077800040434,
    Y: 48.31936299970272,
    OBJECTID: 779,
    STNCODE: "STN",
    STNNAME: "Stanley, North Dakota",
    ADDRESS1: "Main Street & Railroad Avenue",
    ADDRESS2: "",
    CITY: "Stanley",
    STATE: "ND",
    ZIP: "58784",
    STNTYPE: "RAIL",
    STFIPS: 38,
  },
  {
    X: -82.68467700034324,
    Y: 27.839639999986048,
    OBJECTID: 780,
    STNCODE: "STP",
    STNNAME: "St Petersburg-Pinellas Park-Clearwater, Florida",
    ADDRESS1: "5251 110th Avenue North",
    ADDRESS2: "Pinellas Park Square, Suite 101",
    CITY: "Clearwater",
    STATE: "FL",
    ZIP: "33760-4846",
    STNTYPE: "BUS",
    STFIPS: 12,
  },
  {
    X: -122.03954299950976,
    Y: 38.24346500000979,
    OBJECTID: 781,
    STNCODE: "SUI",
    STNNAME: "Suisun, California",
    ADDRESS1: "177 Main Street",
    ADDRESS2: "",
    CITY: "Suisun",
    STATE: "CA",
    ZIP: "94585",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -121.46315799974184,
    Y: 43.85625500036804,
    OBJECTID: 782,
    STNCODE: "SUN",
    STNNAME: "Sunriver, Oregon",
    ADDRESS1: "One Center Drive",
    ADDRESS2: "Sunriver Lodge and Resort",
    CITY: "Sunriver",
    STATE: "OR",
    ZIP: "97707",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -117.19056323160783,
    Y: 33.71063507604799,
    OBJECTID: 783,
    STNCODE: "SUT",
    STNNAME: "Sun City, California",
    ADDRESS1: "26908 Cherry Hills Blvd.",
    ADDRESS2: "In front of CL Travel Agency",
    CITY: "Sun City",
    STATE: "CA",
    ZIP: "92586",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -122.35280036204705,
    Y: 47.613895394656765,
    OBJECTID: 785,
    STNCODE: "SVF",
    STNNAME: "Seattle (Ferry - Pier 69), Washington",
    ADDRESS1: "2701 Alaskan Way",
    ADDRESS2: "Victoria Clipper Ferry, Pier 69",
    CITY: "Seattle",
    STATE: "WA",
    ZIP: "98121",
    STNTYPE: "OTHER",
    STFIPS: 53,
  },
  {
    X: -89.57498198732884,
    Y: 44.532761018106555,
    OBJECTID: 786,
    STNCODE: "SVP",
    STNNAME: "Stevens Point, Wisconsin",
    ADDRESS1: "200 Division St.",
    ADDRESS2: "Olympic Family Restaurant",
    CITY: "Stevens Point",
    STATE: "WI",
    ZIP: "54481-1843",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -87.90560195846359,
    Y: 42.718794023325586,
    OBJECTID: 787,
    STNCODE: "SVT",
    STNNAME: "Sturtevant, Wisconsin",
    ADDRESS1: "9900 East Exploration Court",
    ADDRESS2: "",
    CITY: "Sturtevant",
    STATE: "WI",
    ZIP: "53177",
    STNTYPE: "RAIL",
    STFIPS: 55,
  },
  {
    X: -122.02801125191769,
    Y: 37.04773811582146,
    OBJECTID: 788,
    STNCODE: "SVY",
    STNNAME: "Scotts Valley, California",
    ADDRESS1: "246 Kings Village Rd.",
    ADDRESS2: "Scotts Valley Transit Center",
    CITY: "Scotts Valley",
    STATE: "CA",
    ZIP: "95066-4029",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -76.15216799985325,
    Y: 43.08637200046752,
    OBJECTID: 789,
    STNCODE: "SYR",
    STNNAME: "Syracuse, New York",
    ADDRESS1: "131 Alliance Bank Parkway",
    ADDRESS2: "Regional Transportation Center",
    CITY: "Syracuse",
    STATE: "NY",
    ZIP: "13208",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -122.41847200008272,
    Y: 47.24182899920902,
    OBJECTID: 790,
    STNCODE: "TAC",
    STNNAME: "Tacoma, Washington",
    ADDRESS1: "1001 Puyallup Avenue",
    ADDRESS2: "",
    CITY: "Tacoma",
    STATE: "WA",
    ZIP: "98421-2122",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -97.40879799962795,
    Y: 30.567435999371924,
    OBJECTID: 791,
    STNCODE: "TAY",
    STNNAME: "Taylor, Texas",
    ADDRESS1: "118 East First St.",
    ADDRESS2: "Union Pacific Yard Office",
    CITY: "Taylor",
    STATE: "TX",
    ZIP: "76574-3627",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -83.33136700018684,
    Y: 34.57853300039773,
    OBJECTID: 792,
    STNCODE: "TCA",
    STNNAME: "Toccoa, Georgia",
    ADDRESS1: "47 North Alexander St.",
    ADDRESS2: "",
    CITY: "Toccoa",
    STATE: "GA",
    ZIP: "30577",
    STNTYPE: "RAIL",
    STFIPS: 13,
  },
  {
    X: -87.56015000072193,
    Y: 33.19225700026038,
    OBJECTID: 793,
    STNCODE: "TCL",
    STNNAME: "Tuscaloosa, Alabama",
    ADDRESS1: "2105 Greensboro Ave",
    ADDRESS2: "",
    CITY: "Tuscaloosa",
    STATE: "AL",
    ZIP: "35401",
    STNTYPE: "RAIL",
    STFIPS: 1,
  },
  {
    X: -123.9486647337904,
    Y: 44.632169949283764,
    OBJECTID: 794,
    STNCODE: "TDO",
    STNNAME: "Toledo, Oregon",
    ADDRESS1: "1805 NW Highway 20",
    ADDRESS2: "Dairy Queen/Valley Retriever Bus Stop",
    CITY: "Toledo",
    STATE: "OR",
    ZIP: "97391",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -118.45230900006027,
    Y: 35.1327320004815,
    OBJECTID: 795,
    STNCODE: "TEH",
    STNNAME: "Tehachapi, California",
    ADDRESS1: "Westside of Mullbery Street",
    ADDRESS2: "50 Yards off Tehachapi Blvd",
    CITY: "Tehachapi",
    STATE: "CA",
    ZIP: "93561",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -114.45990309295337,
    Y: 42.569276119597305,
    OBJECTID: 796,
    STNCODE: "TFI",
    STNNAME: "Twin Falls, Idaho",
    ADDRESS1: "1135 Blue Lakes Circle",
    ADDRESS2: "Snake River Chevron",
    CITY: "Twin Falls",
    STATE: "ID",
    ZIP: "83301-4832",
    STNTYPE: "BUS",
    STFIPS: 16,
  },
  {
    X: -121.17966499983982,
    Y: 45.60080699924367,
    OBJECTID: 797,
    STNCODE: "THD",
    STNNAME: "The Dalles, Oregon",
    ADDRESS1: "201 East Federal Street",
    ADDRESS2: "City Transportation Center",
    CITY: "The Dalles",
    STATE: "OR",
    ZIP: "97058",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -81.0780560003841,
    Y: 37.95666499959009,
    OBJECTID: 798,
    STNCODE: "THN",
    STNNAME: "Thurmond, West Virginia",
    ADDRESS1: "Hwy 25 & Hwy 2",
    ADDRESS2: "platform 1000 ft north of intersection",
    CITY: "Thurmond",
    STATE: "WV",
    ZIP: "25936",
    STNTYPE: "RAIL",
    STFIPS: 54,
  },
  {
    X: -95.98683200029654,
    Y: 36.15397999987715,
    OBJECTID: 800,
    STNCODE: "TLS",
    STNNAME: "Tulsa, Oklahoma",
    ADDRESS1: "317 South Detroit St.",
    ADDRESS2: "",
    CITY: "Tulsa",
    STATE: "OK",
    ZIP: "74120-2424",
    STNTYPE: "BUS",
    STFIPS: 40,
  },
  {
    X: -71.57067658735457,
    Y: 43.453571493429706,
    OBJECTID: 801,
    STNCODE: "TLT",
    STNNAME: "Tilton, New Hampshire",
    ADDRESS1: "I-93 and US hwy 3",
    ADDRESS2: "Evans Expressmart/Exxon Station",
    CITY: "Tilton",
    STATE: "NH",
    ZIP: "03276",
    STNTYPE: "BUS",
    STFIPS: 33,
  },
  {
    X: -107.24169899990886,
    Y: 33.13299200028064,
    OBJECTID: 802,
    STNCODE: "TOC",
    STNNAME: "Truth or Consequences, New Mexico",
    ADDRESS1: "8 South Date St.",
    ADDRESS2: "CW's Premium Water & Ice",
    CITY: "Truth or Consequences",
    STATE: "NM",
    ZIP: "87901-2848",
    STNTYPE: "BUS",
    STFIPS: 35,
  },
  {
    X: -90.50416600036061,
    Y: 43.98572500030855,
    OBJECTID: 803,
    STNCODE: "TOH",
    STNNAME: "Tomah, Wisconsin",
    ADDRESS1: "North Superior Ave. and Washington St.",
    ADDRESS2: "",
    CITY: "Tomah",
    STATE: "WI",
    ZIP: "54660",
    STNTYPE: "RAIL",
    STFIPS: 55,
  },
  {
    X: -83.5412670003717,
    Y: 41.638184000591195,
    OBJECTID: 804,
    STNCODE: "TOL",
    STNNAME: "Toledo, Ohio",
    ADDRESS1: "415 Emerald Ave.",
    ADDRESS2: "Central Union Plaza",
    CITY: "Toledo",
    STATE: "OH",
    ZIP: "43604-8817",
    STNTYPE: "RAIL",
    STFIPS: 39,
  },
  {
    X: -95.66489399915872,
    Y: 39.0513459994184,
    OBJECTID: 805,
    STNCODE: "TOP",
    STNNAME: "Topeka, Kansas",
    ADDRESS1: "500 SE Holliday Place",
    ADDRESS2: "East 5th & Holliday Streets",
    CITY: "Topeka",
    STATE: "KS",
    ZIP: "66607-1100",
    STNTYPE: "RAIL",
    STFIPS: 20,
  },
  {
    X: -82.45091200038848,
    Y: 27.952264999230408,
    OBJECTID: 806,
    STNCODE: "TPA",
    STNNAME: "Tampa, Florida",
    ADDRESS1: "601 North Nebraska Ave",
    ADDRESS2: "",
    CITY: "Tampa",
    STATE: "FL",
    ZIP: "33602-3555",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -97.34480300005839,
    Y: 31.09537900004085,
    OBJECTID: 807,
    STNCODE: "TPL",
    STNNAME: "Temple, Texas",
    ADDRESS1: "315 West Ave B",
    ADDRESS2: "",
    CITY: "Temple",
    STATE: "TX",
    ZIP: "76501",
    STNTYPE: "RAIL",
    STFIPS: 48,
  },
  {
    X: -121.43463099992067,
    Y: 37.76174899971659,
    OBJECTID: 808,
    STNCODE: "TRA",
    STNNAME: "Tracy, California",
    ADDRESS1: "725 West Clover Road",
    ADDRESS2: "Wendy's Restaurant",
    CITY: "Tracy",
    STATE: "CA",
    ZIP: "95376-1746",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -74.75456199973644,
    Y: 40.218249999637806,
    OBJECTID: 809,
    STNCODE: "TRE",
    STNNAME: "Trenton, New Jersey",
    ADDRESS1: "72 South Clinton Avenue",
    ADDRESS2: "",
    CITY: "Trenton",
    STATE: "NJ",
    ZIP: "08609-1238",
    STNTYPE: "RAIL",
    STFIPS: 34,
  },
  {
    X: -104.50727099955697,
    Y: 37.17280199981252,
    OBJECTID: 810,
    STNCODE: "TRI",
    STNNAME: "Trinidad, Colorado",
    ADDRESS1: "110 West Pine Street",
    ADDRESS2: "*(Pine St & North Commercial St)",
    CITY: "Trinidad",
    STATE: "CO",
    ZIP: "81082",
    STNTYPE: "RAIL",
    STFIPS: 8,
  },
  {
    X: -73.45289600015025,
    Y: 44.187096000180304,
    OBJECTID: 811,
    STNCODE: "WSP",
    STNNAME: "Westport, New York",
    ADDRESS1: "Hwy 9N and Ledge Hill Rd",
    ADDRESS2: "at Hwy 9N and railroad tracks",
    CITY: "Westport",
    STATE: "NY",
    ZIP: "12993",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -80.30580900028508,
    Y: 37.78541900038658,
    OBJECTID: 812,
    STNCODE: "WSS",
    STNNAME: "White Sulphur Springs, West Virginia",
    ADDRESS1: "315 West Main Street",
    ADDRESS2: "",
    CITY: "White Sulphur Springs",
    STATE: "WV",
    ZIP: "24986",
    STNTYPE: "RAIL",
    STFIPS: 54,
  },
  {
    X: -69.68636025592104,
    Y: 43.99458100131221,
    OBJECTID: 813,
    STNCODE: "WST",
    STNNAME: "Wiscasset, Maine",
    ADDRESS1: "279 Bath Rd.",
    ADDRESS2: "Huber's Market",
    CITY: "Wiscasset",
    STATE: "ME",
    ZIP: "04578-4624",
    STNTYPE: "BUS",
    STFIPS: 23,
  },
  {
    X: -89.65514399949592,
    Y: 44.96348200049397,
    OBJECTID: 814,
    STNCODE: "WSU",
    STNNAME: "Wausau, Wisconsin",
    ADDRESS1: "2415 Trailwood Lane",
    ADDRESS2: "Lamers Bus Lines station",
    CITY: "Mosinee",
    STATE: "WI",
    ZIP: "54455-7820",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -81.73426099924569,
    Y: 28.00225099938416,
    OBJECTID: 815,
    STNCODE: "WTH",
    STNNAME: "Winter Haven, Florida",
    ADDRESS1: "1800 7th St SW",
    ADDRESS2: "",
    CITY: "Winter Haven",
    STATE: "FL",
    ZIP: "33880-4375",
    STNTYPE: "RAIL",
    STFIPS: 12,
  },
  {
    X: -85.02519199981089,
    Y: 41.43170499988588,
    OBJECTID: 816,
    STNCODE: "WTI",
    STNNAME: "Waterloo, Indiana",
    ADDRESS1: "Lincoln and Center Street",
    ADDRESS2: "",
    CITY: "Waterloo",
    STATE: "IN",
    ZIP: "46793",
    STNTYPE: "RAIL",
    STFIPS: 18,
  },
  {
    X: -103.62037699959882,
    Y: 48.1427650001047,
    OBJECTID: 817,
    STNCODE: "WTN",
    STNNAME: "Williston, North Dakota",
    ADDRESS1: "1 South Main Street",
    ADDRESS2: "",
    CITY: "Williston",
    STATE: "ND",
    ZIP: "58801-6057",
    STNTYPE: "RAIL",
    STFIPS: 38,
  },
  {
    X: -123.34980799993923,
    Y: 39.412196999991636,
    OBJECTID: 818,
    STNCODE: "WTS",
    STNNAME: "Willits, California",
    ADDRESS1: "200 E. Commercial Street",
    ADDRESS2: "California Western Railroad Depot",
    CITY: "Willits",
    STATE: "CA",
    ZIP: "95490",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -82.0395810002629,
    Y: 28.866037000307358,
    OBJECTID: 819,
    STNCODE: "WWD",
    STNNAME: "Wildwood, Florida",
    ADDRESS1: "601 North Main Street",
    ADDRESS2: "",
    CITY: "Wildwood",
    STATE: "FL",
    ZIP: "34785-3842",
    STNTYPE: "OTHER",
    STFIPS: 12,
  },
  {
    X: -90.41503899925038,
    Y: 32.84808299983064,
    OBJECTID: 820,
    STNCODE: "YAZ",
    STNNAME: "Yazoo City, Mississippi",
    ADDRESS1: "West Broadway (SR149) and North Water Street",
    ADDRESS2: "222 West Broadway?",
    CITY: "Yazoo City",
    STATE: "MS",
    ZIP: "39194",
    STNTYPE: "RAIL",
    STFIPS: 28,
  },
  {
    X: -80.84714499984182,
    Y: 32.68814499959211,
    OBJECTID: 821,
    STNCODE: "YEM",
    STNNAME: "Yemassee, South Carolina",
    ADDRESS1: "9 Main Street",
    ADDRESS2: "",
    CITY: "Yemassee",
    STATE: "SC",
    ZIP: "29945",
    STNTYPE: "RAIL",
    STFIPS: 45,
  },
  {
    X: -73.90288500054231,
    Y: 40.93609600013036,
    OBJECTID: 822,
    STNCODE: "YNY",
    STNNAME: "Yonkers, New York",
    ADDRESS1: "5 Buena Vista Ave.",
    ADDRESS2: "Amtrak/Metro-North Station",
    CITY: "Yonkers",
    STATE: "NY",
    ZIP: "10701-3544",
    STNTYPE: "RAIL",
    STFIPS: 36,
  },
  {
    X: -119.59842719735724,
    Y: 37.743168947788774,
    OBJECTID: 823,
    STNCODE: "YOS",
    STNNAME: "Yosemite National Park, California",
    ADDRESS1: "9006 Yosemite Lodge Drive",
    ADDRESS2: "Yosemite Park Lodge",
    CITY: "Yosemite National Park",
    STATE: "CA",
    ZIP: "95389",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -114.6151349993807,
    Y: 32.72202300066101,
    OBJECTID: 824,
    STNCODE: "YUM",
    STNNAME: "Yuma, Arizona",
    ADDRESS1: "281 Gila Street",
    ADDRESS2: "",
    CITY: "Yuma",
    STATE: "AZ",
    ZIP: "85364",
    STNTYPE: "RAIL",
    STFIPS: 4,
  },
  {
    X: -87.08863821917845,
    Y: 45.77989577287167,
    OBJECTID: 825,
    STNCODE: "EMI",
    STNNAME: "Escanaba, Michigan",
    ADDRESS1: "2901 27th Avenue North",
    ADDRESS2: "Delta Area Transit Authority bus stop",
    CITY: "Escanaba",
    STATE: "MI",
    ZIP: "49829",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -88.55012486287211,
    Y: 47.11834403964576,
    OBJECTID: 826,
    STNCODE: "HGH",
    STNNAME: "Houghton, Michigan",
    ADDRESS1: "Townsend Drive and Hubbell Street",
    ADDRESS2: "Michigan Tech University, Memorial Union",
    CITY: "Houghton",
    STATE: "MI",
    ZIP: "49931",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -85.38006986793005,
    Y: 44.40365020019664,
    OBJECTID: 827,
    STNCODE: "MTO",
    STNNAME: "Manton, Michigan",
    ADDRESS1: "Junction U.S. 131 & M-42",
    ADDRESS2: "Manton Shell Station",
    CITY: "Manton",
    STATE: "MI",
    ZIP: "49663",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -87.45300628930875,
    Y: 46.557773995773346,
    OBJECTID: 828,
    STNCODE: "MQT",
    STNNAME: "Marquette, Michigan",
    ADDRESS1: "1325 Commerce Drive",
    ADDRESS2: "Marquette Transit Authority",
    CITY: "Marquette",
    STATE: "MI",
    ZIP: "49855",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -88.00489990430708,
    Y: 44.51460934474551,
    OBJECTID: 829,
    STNCODE: "GBY",
    STNNAME: "Green Bay, Wisconsin",
    ADDRESS1: "800 Cedar Street",
    ADDRESS2: "Greyhound Station",
    CITY: "Green Bay",
    STATE: "WI",
    ZIP: "54301",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -87.70144638684127,
    Y: 44.078763026192746,
    OBJECTID: 830,
    STNCODE: "MTC",
    STNNAME: "Manitowoc, Wisconsin",
    ADDRESS1: "1701 South 41st Street",
    ADDRESS2: "Shell Station",
    CITY: "Manitowoc",
    STATE: "WI",
    ZIP: "54220",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -87.65944432409623,
    Y: 45.08224297873056,
    OBJECTID: 831,
    STNCODE: "MWI",
    STNNAME: "Marinette, Wisconsin",
    ADDRESS1: "W 1390 Old Peshtigo Road",
    ADDRESS2: "Shell Station/Taco Bell",
    CITY: "Marinette",
    STATE: "WI",
    ZIP: "54143",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -87.88716407676071,
    Y: 44.87978819866646,
    OBJECTID: 832,
    STNCODE: "OCO",
    STNNAME: "Oconto, Wisconsin",
    ADDRESS1: "517 Smith Avenue",
    ADDRESS2: "Shell Station",
    CITY: "Oconto",
    STATE: "WI",
    ZIP: "54153",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -119.07336444461339,
    Y: 37.782436111037725,
    OBJECTID: 833,
    STNCODE: "JNL",
    STNNAME: "June Lake, California",
    ADDRESS1: "June Lake Loop",
    ADDRESS2: "June Lake Ski Area Parking Lot",
    CITY: "June Lake",
    STATE: "CA",
    ZIP: "95529",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -121.65071611085978,
    Y: 37.129207777317106,
    OBJECTID: 835,
    STNCODE: "MHC",
    STNNAME: "Morgan Hill, California",
    ADDRESS1: "17300 Depot Street",
    ADDRESS2: "Caltrain Station",
    CITY: "Morgan Hill",
    STATE: "CA",
    ZIP: "95037",
    STNTYPE: "RAIL",
    STFIPS: 6,
  },
  {
    X: -122.41339000044815,
    Y: 37.779831667197755,
    OBJECTID: 836,
    STNCODE: "SFV",
    STNNAME: "San Francisco (Civic Center), California",
    ADDRESS1: "1150 Market Street",
    ADDRESS2: "North side, between 7th and 8th Streets",
    CITY: "San Francisco",
    STATE: "CA",
    ZIP: "94102",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -121.84336277767,
    Y: 36.61925888878676,
    OBJECTID: 837,
    STNCODE: "SES",
    STNNAME: "Seaside, California",
    ADDRESS1: "Playa Ave & California Ave",
    ADDRESS2: "Edgewater Transit Exchange (980 Playa Ave?)",
    CITY: "Seaside",
    STATE: "CA",
    ZIP: "93955",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -119.76181888923031,
    Y: 37.83775499919392,
    OBJECTID: 838,
    STNCODE: "YOW",
    STNNAME: "Yosemite National Park (White Wolf), California",
    ADDRESS1: "Old Tioga ROad at Highway 120 East",
    ADDRESS2: "White Wolfe Lodge",
    CITY: "Yosemite National Park",
    STATE: "CA",
    ZIP: "95389",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -119.11804961309912,
    Y: 37.95438090055819,
    OBJECTID: 840,
    STNCODE: "LVN",
    STNNAME: "Lee Vining, California",
    ADDRESS1: "30 Main Street",
    ADDRESS2: "Lake View Lodge",
    CITY: "Lee Vining",
    STATE: "CA",
    ZIP: "93541",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -119.0378493608593,
    Y: 37.650624620030214,
    OBJECTID: 841,
    STNCODE: "MMK",
    STNNAME: "Mammoth Lake, California",
    ADDRESS1: "1 Minaret Road",
    ADDRESS2: "Mammoth Mountain Inn",
    CITY: "Mammoth Lakes",
    STATE: "CA",
    ZIP: "93546",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -119.57064746670721,
    Y: 37.73764995678016,
    OBJECTID: 842,
    STNCODE: "YOC",
    STNNAME: "Yosemite National Park (Curry Village), California",
    ADDRESS1: "Curry Village",
    ADDRESS2: "",
    CITY: "Yosemite National Park",
    STATE: "CA",
    ZIP: "95389",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -119.37343383930022,
    Y: 37.87190986015196,
    OBJECTID: 843,
    STNCODE: "YOT",
    STNNAME: "Yosemite National Park (Tuolumne), California",
    ADDRESS1: "Tuolumne Meadows Visitors Center",
    ADDRESS2: "Highway 120 East",
    CITY: "Yosemite National Park",
    STATE: "CA",
    ZIP: "95389",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -119.58713686107723,
    Y: 37.74805441228136,
    OBJECTID: 844,
    STNCODE: "YOV",
    STNNAME: "Yosemite National Park (Visitor Center), Californi",
    ADDRESS1: "National Park Visitor Center",
    ADDRESS2: "Yosemite Village. Transfer Point to park shuttles",
    CITY: "Yosemite National Park",
    STATE: "CA",
    ZIP: "95389",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -119.57461318015413,
    Y: 37.74625159173763,
    OBJECTID: 845,
    STNCODE: "YOA",
    STNNAME: "Yosemite National Park (Ahweehnee Htl.), Californi",
    ADDRESS1: "Yosemite Village",
    ADDRESS2: "",
    CITY: "Yosemite National Park",
    STATE: "CA",
    ZIP: "95389",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -119.79713228202917,
    Y: 37.75296242817359,
    OBJECTID: 846,
    STNCODE: "YOF",
    STNNAME: "Yosemite National Park (Crane Flat), California",
    ADDRESS1: "Old Tioga Pass Highway (Highway 120 East)",
    ADDRESS2: "Crane Flat Gas Station-Chevron",
    CITY: "Yosemite National Park",
    STATE: "CA",
    ZIP: "95389",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -121.6719166559289,
    Y: 36.78935640877131,
    OBJECTID: 847,
    STNCODE: "PDL",
    STNNAME: "Prunedale, California",
    ADDRESS1: "Highway 156 and Highway 101",
    ADDRESS2: "Caltrans Park-and-Ride Lot",
    CITY: "Prunedale",
    STATE: "CA",
    ZIP: "93907",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -87.71322537694954,
    Y: 43.749811511891835,
    OBJECTID: 848,
    STNCODE: "SHB",
    STNNAME: "Sheboygan, Wisconsin",
    ADDRESS1: "830 Pennsylvania Avenue",
    ADDRESS2: "Sheboygan Transit Transfer Center",
    CITY: "Sheboygan",
    STATE: "WI",
    ZIP: "53081",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -76.0484899284674,
    Y: 38.56229805041477,
    OBJECTID: 849,
    STNCODE: "CDE",
    STNNAME: "Cambridge, Maryland",
    ADDRESS1: "100 Heron Boulevard",
    ADDRESS2: "Hyatt Regency Chesapeake Bay Resort",
    CITY: "Cmbridge",
    STATE: "MD",
    ZIP: "21613",
    STNTYPE: "BUS",
    STFIPS: 24,
  },
  {
    X: -75.60664644038087,
    Y: 38.36238875733534,
    OBJECTID: 850,
    STNCODE: "SLS",
    STNNAME: "Salisbury (BayRunner Shuttle), Maryland",
    ADDRESS1: "547E Riverside Drive",
    ADDRESS2: "BayRunner Shuttle",
    CITY: "Salisbury",
    STATE: "MD",
    ZIP: "21801",
    STNTYPE: "BUS",
    STFIPS: 24,
  },
  {
    X: -76.06374866087197,
    Y: 38.810321081053075,
    OBJECTID: 851,
    STNCODE: "ESN",
    STNNAME: "Easton Airport, Maryland",
    ADDRESS1: "29137 Newman Road",
    ADDRESS2: "Easton Airport - Main Terminal",
    CITY: "Easton",
    STATE: "MD",
    ZIP: "21601",
    STNTYPE: "BUS",
    STFIPS: 24,
  },
  {
    X: -116.9998065422381,
    Y: 34.891758235554164,
    OBJECTID: 853,
    STNCODE: "BBS",
    STNNAME: "Barstow (Bus), California",
    ADDRESS1: "1611 East Main Street",
    ADDRESS2: "",
    CITY: "Barstow",
    STATE: "CA",
    ZIP: "92311-3239",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -121.30561935205145,
    Y: 44.08002990655501,
    OBJECTID: 854,
    STNCODE: "BDR",
    STNNAME: "Bend, OR",
    ADDRESS1: "3075 North Business Highway 97",
    ADDRESS2: "The Riverhouse Resort",
    CITY: "Bend",
    STATE: "OR",
    ZIP: "97701",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -116.79423168934096,
    Y: 33.919728580409696,
    OBJECTID: 855,
    STNCODE: "CBZ",
    STNNAME: "Cabazon, CA",
    ADDRESS1: "49500 Seminole Drive",
    ADDRESS2: "Morongo Casino, Hotel & Spa",
    CITY: "Cabazon",
    STATE: "CA",
    ZIP: "92230",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -73.17135700042519,
    Y: 43.61342899984851,
    OBJECTID: 856,
    STNCODE: "CNV",
    STNNAME: "Castleton, VT",
    ADDRESS1: "266 Main Street",
    ADDRESS2: "",
    CITY: "Castleton",
    STATE: "VT",
    ZIP: "05735",
    STNTYPE: "RAIL",
    STFIPS: 50,
  },
  {
    X: -118.38276825195322,
    Y: 33.90558509547583,
    OBJECTID: 857,
    STNCODE: "ESG",
    STNNAME: "El Segundo, CA",
    ADDRESS1: "700 South Douglas Street",
    ADDRESS2: "Douglas Green Line Station",
    CITY: "El Segundo",
    STATE: "CA",
    ZIP: "90245",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -123.29824107616469,
    Y: 42.43375358246192,
    OBJECTID: 858,
    STNCODE: "GTP",
    STNNAME: "Grants Pass, OR",
    ADDRESS1: "460 NE Agness Avenue",
    ADDRESS2: "Grants Pass Transportation Ctr/Greyhound Station",
    CITY: "Grants Pass",
    STATE: "OR",
    ZIP: "97526",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -93.59221100043726,
    Y: 33.66894899999642,
    OBJECTID: 859,
    STNCODE: "HOP",
    STNNAME: "Hope, AR",
    ADDRESS1: "100 East Division Street",
    ADDRESS2: "",
    CITY: "Hope",
    STATE: "AR",
    ZIP: "71801",
    STNTYPE: "RAIL",
    STFIPS: 5,
  },
  {
    X: -77.41878729699613,
    Y: 34.748665958167464,
    OBJECTID: 860,
    STNCODE: "JNC",
    STNNAME: "Jacksonville, NC",
    ADDRESS1: "850 New Bridge Street",
    ADDRESS2: "",
    CITY: "Jacksonville",
    STATE: "NC",
    ZIP: "28540",
    STNTYPE: "BUS",
    STFIPS: 37,
  },
  {
    X: -77.58532366535485,
    Y: 35.24384422313244,
    OBJECTID: 861,
    STNCODE: "KNC",
    STNNAME: "Kinston, NC",
    ADDRESS1: "101 East New Bern Road",
    ADDRESS2: "Vistor and Information Center",
    CITY: "Kinston",
    STATE: "NC",
    ZIP: "28504",
    STNTYPE: "BUS",
    STFIPS: 37,
  },
  {
    X: -84.7905960002052,
    Y: 45.44020099967645,
    OBJECTID: 880,
    STNCODE: "ALA",
    STNNAME: "Alanson, MI",
    ADDRESS1: "7640 Burr Avenue",
    ADDRESS2: "Marathon Gas Station EZ-Mart",
    CITY: "Alanson",
    STATE: "MI",
    ZIP: "49706",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -83.4923849998678,
    Y: 45.061841000162076,
    OBJECTID: 881,
    STNCODE: "ALM",
    STNNAME: "Alpena, MI",
    ADDRESS1: "2060 Michigan Highway 32 West",
    ADDRESS2: "Thunder Baykery",
    CITY: "Alpena",
    STATE: "MI",
    ZIP: "49707",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -69.79913300028767,
    Y: 44.355912999785176,
    OBJECTID: 882,
    STNCODE: "AGM",
    STNNAME: "Augusta, ME",
    ADDRESS1: "9 Industrial Drive",
    ADDRESS2: "Transportation Center",
    CITY: "Augusta",
    STATE: "ME",
    ZIP: "04330",
    STNTYPE: "BUS",
    STFIPS: 23,
  },
  {
    X: -83.88692199985036,
    Y: 43.60184699993914,
    OBJECTID: 883,
    STNCODE: "BCY",
    STNNAME: "Bay City, MI",
    ADDRESS1: "1124 Washington Avenue",
    ADDRESS2: "Central Bus Terminal",
    CITY: "Bay City",
    STATE: "MI",
    ZIP: "48708",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -88.81694200027306,
    Y: 43.45604000024588,
    OBJECTID: 884,
    STNCODE: "BVD",
    STNNAME: "Beaver Dam, WI",
    ADDRESS1: "817 Park Avenue",
    ADDRESS2: "Crossroads Shell Station",
    CITY: "Beaver Dam",
    STATE: "WI",
    ZIP: "53916",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -121.30126600022572,
    Y: 44.05821999975325,
    OBJECTID: 885,
    STNCODE: "BND",
    STNNAME: "Bend, OR",
    ADDRESS1: "334 Hawthorne Avenue",
    ADDRESS2: "Hawthorne Station Intermodal Center",
    CITY: "Bend",
    STATE: "OR",
    ZIP: "97701",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -108.50212599981501,
    Y: 45.783747999970274,
    OBJECTID: 886,
    STNCODE: "BLG",
    STNNAME: "Billings, MT",
    ADDRESS1: "2501 1st Avenue North",
    ADDRESS2: "Bus Station",
    CITY: "Billings",
    STATE: "MT",
    ZIP: "59701",
    STNTYPE: "BUS",
    STFIPS: 30,
  },
  {
    X: -88.88976100026991,
    Y: 30.39811900009181,
    OBJECTID: 887,
    STNCODE: "BIG",
    STNNAME: "Biloxi, MS",
    ADDRESS1: "820 Martin Luther King Jr. Boulevard",
    ADDRESS2: "Greyhound Bus Station",
    CITY: "Biloxi",
    STATE: "MS",
    ZIP: "39530",
    STNTYPE: "BUS",
    STFIPS: 28,
  },
  {
    X: -80.41836800008309,
    Y: 37.2299070000081,
    OBJECTID: 888,
    STNCODE: "BLK",
    STNNAME: "Blacksburg, VA",
    ADDRESS1: "291 Alumni Mall -- Transit Concourse",
    ADDRESS2: "Exterior Bus Shelter and Interior Waiting Lounge",
    CITY: "Blacksburg",
    STATE: "VA",
    ZIP: "24061",
    STNTYPE: "BUS",
    STFIPS: 51,
  },
  {
    X: -111.18597399960038,
    Y: 45.76486899990448,
    OBJECTID: 889,
    STNCODE: "BOZ",
    STNNAME: "Bozeman, MT",
    ADDRESS1: "6505 Jack Rabbit Lane",
    ADDRESS2: "Flying J/Conoco Travel Plaza",
    CITY: "Bozeman",
    STATE: "MT",
    ZIP: "59714",
    STNTYPE: "BUS",
    STFIPS: 30,
  },
  {
    X: -87.17173399972427,
    Y: 32.958645000166655,
    OBJECTID: 890,
    STNCODE: "BRR",
    STNNAME: "Brent, AL",
    ADDRESS1: "10393 Alabama Highway 5",
    ADDRESS2: "Wendy's Restaurant",
    CITY: "Brent",
    STATE: "AL",
    ZIP: "35034",
    STNTYPE: "BUS",
    STFIPS: 1,
  },
  {
    X: -124.28156400027837,
    Y: 42.05077799960503,
    OBJECTID: 891,
    STNCODE: "BKO",
    STNNAME: "Brookings, OR",
    ADDRESS1: "624 Railroad Street",
    ADDRESS2: "Southwest Point Depot",
    CITY: "Brookings",
    STATE: "OR",
    ZIP: "97415",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -96.37178099969333,
    Y: 30.67322399988774,
    OBJECTID: 892,
    STNCODE: "BRY",
    STNNAME: "Bryan, TX",
    ADDRESS1: "301 East 26th Street",
    ADDRESS2: "Greyhound Station, Roy Kelly Parking Garage",
    CITY: "Bryan",
    STATE: "TX",
    ZIP: "77803",
    STNTYPE: "BUS",
    STFIPS: 48,
  },
  {
    X: -106.10668099972833,
    Y: 38.81493399970435,
    OBJECTID: 893,
    STNCODE: "BUV",
    STNNAME: "Buena Vista, CO",
    ADDRESS1: "27318 County Road 314",
    ADDRESS2: "Veterans of Foreign Wars",
    CITY: "Buena Vista",
    STATE: "CO",
    ZIP: "81211",
    STNTYPE: "BUS",
    STFIPS: 8,
  },
  {
    X: -112.52085600030415,
    Y: 46.00194299956985,
    OBJECTID: 894,
    STNCODE: "BUT",
    STNNAME: "Butte, MT",
    ADDRESS1: "1324 Harrison Avenue",
    ADDRESS2: "Bus Station",
    CITY: "Butte",
    STATE: "MT",
    ZIP: "59701",
    STNTYPE: "BUS",
    STFIPS: 30,
  },
  {
    X: -87.27863700039723,
    Y: 31.994073000068965,
    OBJECTID: 895,
    STNCODE: "CMD",
    STNNAME: "Camden, AL",
    ADDRESS1: "8 Claiborne Street \n8 Claiborne Street \n",
    ADDRESS2: "Shell Gas Station",
    CITY: "Camden",
    STATE: "AL",
    ZIP: "36726",
    STNTYPE: "BUS",
    STFIPS: 1,
  },
  {
    X: -123.64700000024976,
    Y: 42.16300200014223,
    OBJECTID: 896,
    STNCODE: "CVJ",
    STNNAME: "Cave Junction, OR",
    ADDRESS1: "406 Redwood Coast Highway",
    ADDRESS2: "Junction Inn",
    CITY: "Cave Junction",
    STATE: "OR",
    ZIP: "97523",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -88.57581699995455,
    Y: 37.05691600037318,
    OBJECTID: 965,
    STNCODE: "PAD",
    STNNAME: "Paducah, KY",
    ADDRESS1: "2719 Irvin Cobb Avenue",
    ADDRESS2: "Greyhound Bus Station",
    CITY: "Paducah",
    STATE: "KY",
    ZIP: "42001",
    STNTYPE: "BUS",
    STFIPS: 21,
  },
  {
    X: -75.06202199961552,
    Y: 39.978051999800016,
    OBJECTID: 966,
    STNCODE: "PNK",
    STNNAME: "Pennsauken, NJ",
    ADDRESS1: "215 Derousse Avenue",
    ADDRESS2: "Transit Center",
    CITY: "Pennsauken",
    STATE: "NJ",
    ZIP: "08110",
    STNTYPE: "BUS",
    STFIPS: 34,
  },
  {
    X: -116.54544000005592,
    Y: 33.82464299967472,
    OBJECTID: 967,
    STNCODE: "PSS",
    STNNAME: "Palm Springs Downtown, CA",
    ADDRESS1: "190 North Indian Canyon Drive",
    ADDRESS2: "SunLine Transit Bus Stop at southeast corner of I*",
    CITY: "Palm Springs Downtown",
    STATE: "CA",
    ZIP: "92262",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -105.39701499964247,
    Y: 39.46739000014844,
    OBJECTID: 968,
    STNCODE: "PJT",
    STNNAME: "Pine Junction, CO",
    ADDRESS1: "76 Mount Evans Boulevard",
    ADDRESS2: "Denver RTA Park-n-Ride Lot",
    CITY: "Pine Junction",
    STATE: "CO",
    ZIP: "80470",
    STNTYPE: "BUS",
    STFIPS: 8,
  },
  {
    X: -106.07643099959091,
    Y: 38.51217599992253,
    OBJECTID: 969,
    STNCODE: "PSG",
    STNNAME: "Poncha Springs, CO",
    ADDRESS1: "6250 US Highway 285",
    ADDRESS2: "High Valley Center Pub & Grub",
    CITY: "Poncha Springs",
    STATE: "CO",
    ZIP: "81242",
    STNTYPE: "BUS",
    STFIPS: 8,
  },
  {
    X: -122.67647499992125,
    Y: 45.52736100001022,
    OBJECTID: 970,
    STNCODE: "PDG",
    STNNAME: "Portland, OR",
    ADDRESS1: "550 NW 6th Avenue",
    ADDRESS2: "Greyhound Station",
    CITY: "Portland",
    STATE: "OR",
    ZIP: "97209",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -95.9922930003217,
    Y: 30.072967000027063,
    OBJECTID: 971,
    STNCODE: "PVW",
    STNNAME: "Prairie View, TX",
    ADDRESS1: "44814 US Highway 290 Business \n",
    ADDRESS2: "Unco Food Store and Gas Station",
    CITY: "Prairie View",
    STATE: "TX",
    ZIP: "77446",
    STNTYPE: "BUS",
    STFIPS: 48,
  },
  {
    X: -121.6908949996045,
    Y: 38.15570800002422,
    OBJECTID: 972,
    STNCODE: "RVT",
    STNNAME: "Rio Vista, CA",
    ADDRESS1: "28 South Front Street",
    ADDRESS2: "Delta Breeze Transit Bus Stop",
    CITY: "Rio Vista",
    STATE: "CA",
    ZIP: "94571",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -79.93617800041437,
    Y: 37.27780800023908,
    OBJECTID: 973,
    STNCODE: "RNK",
    STNNAME: "Roanoke, VA",
    ADDRESS1: "710 Williamson Road NE",
    ADDRESS2: "Civic Center Parking Lot C",
    CITY: "Roanoke",
    STATE: "VA",
    ZIP: "24016",
    STNTYPE: "BUS",
    STFIPS: 51,
  },
  {
    X: -90.55038899965257,
    Y: 41.50622299999151,
    OBJECTID: 974,
    STNCODE: "RKI",
    STNNAME: "Rock Island, IL",
    ADDRESS1: "3500 5th Avenue",
    ADDRESS2: "Augustana College Carver P.E. Center",
    CITY: "Rock Island",
    STATE: "IL",
    ZIP: "61201",
    STNTYPE: "BUS",
    STFIPS: 17,
  },
  {
    X: -83.93342899964858,
    Y: 43.43492799972745,
    OBJECTID: 975,
    STNCODE: "SGW",
    STNNAME: "Saginaw, MI",
    ADDRESS1: "511 Johnson Street",
    ADDRESS2: "Bus Center",
    CITY: "Saginaw",
    STATE: "MI",
    ZIP: "48607",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -105.99450000027474,
    Y: 38.52504699991914,
    OBJECTID: 976,
    STNCODE: "SLD",
    STNNAME: "Salida, CO",
    ADDRESS1: "54 Jones Avenue",
    ADDRESS2: "Bus Depot",
    CITY: "Salida",
    STATE: "CO",
    ZIP: "81201",
    STNTYPE: "BUS",
    STFIPS: 8,
  },
  {
    X: -111.90850999963675,
    Y: 40.76304000019593,
    OBJECTID: 977,
    STNCODE: "SLB",
    STNNAME: "Salt Lake City, UT",
    ADDRESS1: "300 South 600 West",
    ADDRESS2: "Intermodal Hub Bus Terminal",
    CITY: "Salt Lake City",
    STATE: "UT",
    ZIP: "84101",
    STNTYPE: "BUS",
    STFIPS: 49,
  },
  {
    X: -84.37170500038542,
    Y: 46.46346100012511,
    OBJECTID: 978,
    STNCODE: "SMI",
    STNNAME: "Sault Sainte Marie, MI",
    ADDRESS1: "4001 I-75 Business Spur",
    ADDRESS2: "Eastern Upper Peninsula Transit Authority Term",
    CITY: "Sault Sainte Marie",
    STATE: "MI",
    ZIP: "49783",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -75.6702100000914,
    Y: 41.4101699996458,
    OBJECTID: 979,
    STNCODE: "SRN",
    STNNAME: "Scranton, PA",
    ADDRESS1: "23 Lackawanna Avenue",
    ADDRESS2: "Martz Trailways Station",
    CITY: "Scranton",
    STATE: "PA",
    ZIP: "18503",
    STNTYPE: "BUS",
    STFIPS: 42,
  },
  {
    X: -87.02225999999894,
    Y: 32.412143999845796,
    OBJECTID: 980,
    STNCODE: "SLA",
    STNNAME: "Selma, AL",
    ADDRESS1: "434 Broad Street",
    ADDRESS2: "Trailways Bus Station",
    CITY: "Selma",
    STATE: "AL",
    ZIP: "36701",
    STNTYPE: "BUS",
    STFIPS: 1,
  },
  {
    X: -88.61533899959511,
    Y: 44.75314700003406,
    OBJECTID: 981,
    STNCODE: "SHW",
    STNNAME: "Shawano, WI",
    ADDRESS1: "N4543 State Highway 22",
    ADDRESS2: "Shell Station",
    CITY: "Shawano",
    STATE: "WI",
    ZIP: "54166",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -85.25794099967737,
    Y: 45.318448000374985,
    OBJECTID: 897,
    STNCODE: "CHL",
    STNNAME: "Charlevoix, MI",
    ADDRESS1: "103 Bridge Park Drive",
    ADDRESS2: "Beaver Island Boat Company Ferry Terminal",
    CITY: "Charlevoix",
    STATE: "MI",
    ZIP: "49720",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -84.46981800040038,
    Y: 45.64487900006583,
    OBJECTID: 898,
    STNCODE: "CHB",
    STNNAME: "Cheboygan, MI",
    ADDRESS1: "309 East State Street",
    ADDRESS2: "Marathon Gas Station",
    CITY: "Cheboygan",
    STATE: "MI",
    ZIP: "49721",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -117.71563500005516,
    Y: 48.279192999857116,
    OBJECTID: 899,
    STNCODE: "CWL",
    STNNAME: "Chewelah, WA",
    ADDRESS1: "10 West Colville Avenue",
    ADDRESS2: "Bus Stop Next to Safeway",
    CITY: "Chewelah",
    STATE: "WA",
    ZIP: "99109",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -91.42779399999307,
    Y: 44.883095999580746,
    OBJECTID: 900,
    STNCODE: "CHP",
    STNNAME: "Chippewa Falls, WI",
    ADDRESS1: "2750 120th Street",
    ADDRESS2: "Holiday Gas Station Store",
    CITY: "Chippewa Falls",
    STATE: "WI",
    ZIP: "54729",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -84.50446900024411,
    Y: 39.10757299959431,
    OBJECTID: 901,
    STNCODE: "CIG",
    STNNAME: "Cincinnati, OH",
    ADDRESS1: "1005 Gilbert Avenue",
    ADDRESS2: "Greyhound Terminal",
    CITY: "Cincinnati",
    STATE: "OH",
    ZIP: "45202",
    STNTYPE: "BUS",
    STFIPS: 39,
  },
  {
    X: -87.36370499958605,
    Y: 36.53075199990491,
    OBJECTID: 902,
    STNCODE: "CRK",
    STNNAME: "Clarksville, TN",
    ADDRESS1: "11 Jefferson Street \n",
    ADDRESS2: "Greyhound Bus Station",
    CITY: "Clarksville",
    STATE: "TN",
    ZIP: "37040",
    STNTYPE: "BUS",
    STFIPS: 47,
  },
  {
    X: -82.9963599998141,
    Y: 39.95873400017405,
    OBJECTID: 903,
    STNCODE: "COL",
    STNNAME: "Columbus, OH",
    ADDRESS1: "111 East Town Street",
    ADDRESS2: "Greyhound Bus station",
    CITY: "Columbus",
    STATE: "OH",
    ZIP: "43215",
    STNTYPE: "BUS",
    STFIPS: 39,
  },
  {
    X: -117.90837800044432,
    Y: 48.53587900011581,
    OBJECTID: 904,
    STNCODE: "CVL",
    STNNAME: "Colville, WA",
    ADDRESS1: "956 South Main Street",
    ADDRESS2: "Rural Rescources Community Action",
    CITY: "Colville",
    STATE: "WA",
    ZIP: "99114",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -124.19347500027101,
    Y: 41.75237300001402,
    OBJECTID: 905,
    STNCODE: "CRC",
    STNNAME: "Crescent City, CA",
    ADDRESS1: "1001 Front Street",
    ADDRESS2: "Cultural Center RCT Bus Stop",
    CITY: "Crescent City",
    STATE: "CA",
    ZIP: "95531",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -78.73043799981383,
    Y: 39.65045200015976,
    OBJECTID: 906,
    STNCODE: "CUA",
    STNNAME: "Cumberland, MD",
    ADDRESS1: "12401 Willowbrook Road SE",
    ADDRESS2: "Allegheny College of MD, Ctr for Continuing Educa*",
    CITY: "Cumberland",
    STATE: "MD",
    ZIP: "21502",
    STNTYPE: "BUS",
    STFIPS: 24,
  },
  {
    X: -96.80412100008402,
    Y: 32.778636999797754,
    OBJECTID: 907,
    STNCODE: "DAG",
    STNNAME: "Dallas, TX",
    ADDRESS1: "205 South Lamar Street",
    ADDRESS2: "Greyhound Station",
    CITY: "Dallas",
    STATE: "TX",
    ZIP: "75202",
    STNTYPE: "BUS",
    STFIPS: 48,
  },
  {
    X: -117.47887699967379,
    Y: 47.945446000032916,
    OBJECTID: 908,
    STNCODE: "DPK",
    STNNAME: "Deer Park, WA",
    ADDRESS1: "822 South Main Street",
    ADDRESS2: "Bus Stop Next to Fresenius Medical Center",
    CITY: "Deer Park",
    STATE: "WA",
    ZIP: "99006",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -91.5063389996451,
    Y: 44.79655800005173,
    OBJECTID: 909,
    STNCODE: "EUC",
    STNNAME: "Eau Claire, WI",
    ADDRESS1: "642 University Drive",
    ADDRESS2: "University of Wisconsin Towers Hall",
    CITY: "Eau Claire",
    STATE: "WI",
    ZIP: "54702",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -91.5950840002264,
    Y: 44.843005999827085,
    OBJECTID: 910,
    STNCODE: "EUM",
    STNNAME: "Eau Claire, WI",
    ADDRESS1: "6251 Traux Lane",
    ADDRESS2: "McDonald's Restaurant",
    CITY: "Eau Claire",
    STATE: "WI",
    ZIP: "54703",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -119.5612019996725,
    Y: 47.30677400031993,
    OBJECTID: 911,
    STNCODE: "EPR",
    STNNAME: "Ephrata, WA",
    ADDRESS1: "1352 Basin Street SW",
    ADDRESS2: "Shell Gasoline Station",
    CITY: "Ephrata",
    STATE: "WA",
    ZIP: "98823",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -123.08959899999383,
    Y: 44.04903399971937,
    OBJECTID: 912,
    STNCODE: "EUB",
    STNNAME: "Eugene, OR",
    ADDRESS1: "987 Pearl Street",
    ADDRESS2: "Greyhound Station",
    CITY: "Eugene",
    STATE: "OR",
    ZIP: "97401",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -123.0743490000063,
    Y: 44.04337499955665,
    OBJECTID: 913,
    STNCODE: "EUO",
    STNNAME: "Eugene, OR",
    ADDRESS1: "1320 East 15th Avenue",
    ADDRESS2: "University of Oregon across street from Student R*",
    CITY: "Eugene",
    STATE: "OR",
    ZIP: "97403",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -87.56953399999406,
    Y: 37.973786000423615,
    OBJECTID: 914,
    STNCODE: "EVN",
    STNNAME: "Evansville, IN",
    ADDRESS1: "119 Northwest 6th Street",
    ADDRESS2: "Greyhound/METS Bus Terminal",
    CITY: "Evansville",
    STATE: "IN",
    ZIP: "47708",
    STNTYPE: "BUS",
    STFIPS: 18,
  },
  {
    X: -105.99160800000914,
    Y: 39.2255160003632,
    OBJECTID: 915,
    STNCODE: "FRP",
    STNNAME: "Fairplay, CO",
    ADDRESS1: "620 US Highway 285",
    ADDRESS2: "Sinclair Gas Station",
    CITY: "Fairplay",
    STATE: "CO",
    ZIP: "80421",
    STNTYPE: "BUS",
    STFIPS: 8,
  },
  {
    X: -77.38229900019866,
    Y: 39.416261000344946,
    OBJECTID: 916,
    STNCODE: "FRR",
    STNNAME: "Frederick Airport, MD",
    ADDRESS1: "1341 Hughes Ford Road",
    ADDRESS2: "BayRunner Shuttle Office",
    CITY: "Frederick Airport",
    STATE: "MD",
    ZIP: "21705",
    STNTYPE: "BUS",
    STFIPS: 24,
  },
  {
    X: -78.93316800030294,
    Y: 39.64889999963532,
    OBJECTID: 917,
    STNCODE: "FSB",
    STNNAME: "Frostburg, MD",
    ADDRESS1: "101 Braddock Road",
    ADDRESS2: "Frostburg State Univ, Harold J Cordts PE Center",
    CITY: "Frostburg",
    STATE: "MD",
    ZIP: "21532",
    STNTYPE: "BUS",
    STFIPS: 24,
  },
  {
    X: -87.33894900009625,
    Y: 41.6042689996147,
    OBJECTID: 918,
    STNCODE: "GRY",
    STNNAME: "Gary, IN",
    ADDRESS1: "100 West 4th Avenue",
    ADDRESS2: "Metro Center Station",
    CITY: "Gary",
    STATE: "IN",
    ZIP: "46402",
    STNTYPE: "BUS",
    STFIPS: 18,
  },
  {
    X: -104.73194800039988,
    Y: 47.10718599993402,
    OBJECTID: 919,
    STNCODE: "GLD",
    STNNAME: "Glendive, MT",
    ADDRESS1: "1302 West Towne Street",
    ADDRESS2: "Robins Service",
    CITY: "Glendive",
    STATE: "MT",
    ZIP: "59330",
    STNTYPE: "BUS",
    STFIPS: 30,
  },
  {
    X: -123.0546459997131,
    Y: 42.43197999977724,
    OBJECTID: 920,
    STNCODE: "GHL",
    STNNAME: "Gold Hill, OR",
    ADDRESS1: "868 2nd Avenue",
    ADDRESS2: "Ray's Market",
    CITY: "Gold Hill",
    STATE: "OR",
    ZIP: "97525",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -77.96913800001863,
    Y: 35.38271500009722,
    OBJECTID: 921,
    STNCODE: "GBO",
    STNNAME: "Goldsboro, NC",
    ADDRESS1: "1615 East Beech Street",
    ADDRESS2: "GATEWAY Transit Terminal",
    CITY: "Goldsboro",
    STATE: "NC",
    ZIP: "27350",
    STNTYPE: "BUS",
    STFIPS: 37,
  },
  {
    X: -79.10032599984498,
    Y: 39.69235399983728,
    OBJECTID: 922,
    STNCODE: "GTV",
    STNNAME: "Grantsville, MD",
    ADDRESS1: "3000 Chestnut Ridge Road",
    ADDRESS2: "Pilot Travel Center",
    CITY: "Grantsville",
    STATE: "MD",
    ZIP: "21536",
    STNTYPE: "BUS",
    STFIPS: 24,
  },
  {
    X: -77.37004699996902,
    Y: 35.613549999832685,
    OBJECTID: 923,
    STNCODE: "GRN",
    STNNAME: "Greenville, NC",
    ADDRESS1: "Second and Reade Streets",
    ADDRESS2: "Greenville Area Transit Transfer Center",
    CITY: "Greenville",
    STATE: "NC",
    ZIP: "27834",
    STNTYPE: "BUS",
    STFIPS: 37,
  },
  {
    X: -87.78011800024547,
    Y: 31.6875159995638,
    OBJECTID: 924,
    STNCODE: "GVH",
    STNNAME: "Grove Hill, AL",
    ADDRESS1: "430 South Jackson Street",
    ADDRESS2: "Dunn's Exxon Gas Station",
    CITY: "Grove Hill",
    STATE: "AL",
    ZIP: "36451",
    STNTYPE: "BUS",
    STFIPS: 1,
  },
  {
    X: -89.09316200022607,
    Y: 30.427873999885264,
    OBJECTID: 925,
    STNCODE: "GUG",
    STNNAME: "Gulfport, MS",
    ADDRESS1: "10015 US Highway 49",
    ADDRESS2: "Clark Convenience Store",
    CITY: "Gulfport",
    STATE: "MS",
    ZIP: "39501",
    STNTYPE: "BUS",
    STFIPS: 28,
  },
  {
    X: -106.9273360000563,
    Y: 38.553944999761995,
    OBJECTID: 926,
    STNCODE: "GUN",
    STNNAME: "Gunnison-Downtown, CO",
    ADDRESS1: "905 North Main Street",
    ADDRESS2: "Powerstop Gas Station",
    CITY: "Gunnison-Downtown",
    STATE: "CO",
    ZIP: "81230",
    STNTYPE: "BUS",
    STFIPS: 8,
  },
  {
    X: -106.92293899963511,
    Y: 38.547831000200574,
    OBJECTID: 927,
    STNCODE: "GNW",
    STNNAME: "Gunnison-Western State Univ, CO",
    ADDRESS1: "400 North Colorado Street \n",
    ADDRESS2: "Gunnison Valley RTA Transit Bus Stop",
    CITY: "Gunnison-Western State Un*",
    STATE: "CO",
    ZIP: "81230",
    STNTYPE: "BUS",
    STFIPS: 8,
  },
  {
    X: -77.72249699983661,
    Y: 39.64466000015892,
    OBJECTID: 928,
    STNCODE: "HAG",
    STNNAME: "Hagerstown, MD",
    ADDRESS1: "123 West Franklin Street",
    ADDRESS2: "Washington County Transit Transfer Center",
    CITY: "Hagerstown",
    STATE: "MD",
    ZIP: "21740",
    STNTYPE: "BUS",
    STFIPS: 24,
  },
  {
    X: -78.1539190001617,
    Y: 39.695657000170456,
    OBJECTID: 929,
    STNCODE: "HNK",
    STNNAME: "Hancock, MD",
    ADDRESS1: "434 East Main Street",
    ADDRESS2: "Hancock Truck Plaza",
    CITY: "Hancock",
    STATE: "MD",
    ZIP: "21750",
    STNTYPE: "BUS",
    STFIPS: 24,
  },
  {
    X: -88.58029499961452,
    Y: 47.126982000019325,
    OBJECTID: 930,
    STNCODE: "HKM",
    STNNAME: "Hancock, MI",
    ADDRESS1: "125 Quincy Street",
    ADDRESS2: "Shottle Bop Liquor Store",
    CITY: "Hancock",
    STATE: "MI",
    ZIP: "49930",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -89.37917500032597,
    Y: 31.390856000404142,
    OBJECTID: 931,
    STNCODE: "HBI",
    STNNAME: "Hattiesburg, MS",
    ADDRESS1: "7297 US Highway 49",
    ADDRESS2: "Shell Gas Station",
    CITY: "Hattiesburg",
    STATE: "MS",
    ZIP: "39401",
    STNTYPE: "BUS",
    STFIPS: 28,
  },
  {
    X: -76.92611500010713,
    Y: 34.89119099986482,
    OBJECTID: 932,
    STNCODE: "HVL",
    STNNAME: "Havelock, NC",
    ADDRESS1: "201 Tourist Center Drive",
    ADDRESS2: "Tourism and Event Center",
    CITY: "Havelock",
    STATE: "NC",
    ZIP: "28532",
    STNTYPE: "BUS",
    STFIPS: 37,
  },
  {
    X: -95.37161400028583,
    Y: 29.748301999937382,
    OBJECTID: 933,
    STNCODE: "HOG",
    STNNAME: "Houston, TX",
    ADDRESS1: "2121 Main Street",
    ADDRESS2: "Greyhound Terminal",
    CITY: "Houston",
    STATE: "TX",
    ZIP: "77002",
    STNTYPE: "BUS",
    STFIPS: 48,
  },
  {
    X: -87.87980099981627,
    Y: 31.54745500044794,
    OBJECTID: 934,
    STNCODE: "JAA",
    STNNAME: "Jackson, AL",
    ADDRESS1: "3603 North College Avenue",
    ADDRESS2: "Citgo Gas Station",
    CITY: "Jackson",
    STATE: "AL",
    ZIP: "36545",
    STNTYPE: "BUS",
    STFIPS: 1,
  },
  {
    X: -70.10235800002164,
    Y: 43.85503499986538,
    OBJECTID: 935,
    STNCODE: "FRE",
    STNNAME: "Freeport, ME",
    ADDRESS1: "36 Depot Street",
    ADDRESS2: "Station",
    CITY: "Freeport",
    STATE: "ME",
    ZIP: "04032",
    STNTYPE: "RAIL",
    STFIPS: 23,
  },
  {
    X: -72.60076499980488,
    Y: 42.58545799978691,
    OBJECTID: 936,
    STNCODE: "GFD",
    STNNAME: "Greenfield, MA",
    ADDRESS1: "12 Olive Street",
    ADDRESS2: "John W. Olver Transit Center",
    CITY: "Greenfield",
    STATE: "MA",
    ZIP: "01301",
    STNTYPE: "RAIL",
    STFIPS: 25,
  },
  {
    X: -76.24082700006596,
    Y: 38.966497999583055,
    OBJECTID: 937,
    STNCODE: "KNT",
    STNNAME: "Kent Island, MD",
    ADDRESS1: "3206 Main Street",
    ADDRESS2: "Hilton Garden Inn",
    CITY: "Kent Island",
    STATE: "MD",
    ZIP: "21638",
    STNTYPE: "BUS",
    STFIPS: 24,
  },
  {
    X: -118.06189899973901,
    Y: 48.61036999987567,
    OBJECTID: 938,
    STNCODE: "KTF",
    STNNAME: "Kettle Falls, WA",
    ADDRESS1: "425 West Third Avenue",
    ADDRESS2: "Chamber of Commerce Visitor's Center",
    CITY: "Kettle Falls",
    STATE: "WA",
    ZIP: "99141",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -116.28996399983868,
    Y: 33.71097900018077,
    OBJECTID: 939,
    STNCODE: "LQT",
    STNNAME: "La Quinta, CA",
    ADDRESS1: "78822 Highway 111",
    ADDRESS2: "SunLine Transit Stop next to Eisenhower Occupatio*",
    CITY: "La Quinta",
    STATE: "CA",
    ZIP: "92253",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -88.45359299961723,
    Y: 46.75844900042108,
    OBJECTID: 940,
    STNCODE: "LAN",
    STNNAME: "L'Anse, MI",
    ADDRESS1: "102 North Main Street",
    ADDRESS2: "In The Mind's Eye Store",
    CITY: "L'Anse",
    STATE: "MI",
    ZIP: "49946",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -115.16402400010747,
    Y: 36.06852599997495,
    OBJECTID: 941,
    STNCODE: "LVT",
    STNNAME: "Las Vegas, NV",
    ADDRESS1: "6675 Gilespie Street",
    ADDRESS2: "South Strip Transfer Terminal",
    CITY: "Las Vegas",
    STATE: "NV",
    ZIP: "89119",
    STNTYPE: "BUS",
    STFIPS: 32,
  },
  {
    X: -110.54582900030806,
    Y: 45.67026699992215,
    OBJECTID: 942,
    STNCODE: "LVG",
    STNNAME: "Livingston, MT",
    ADDRESS1: "1404 East Park Street \n",
    ADDRESS2: "Fair Winds Coffee",
    CITY: "Livingston",
    STATE: "MT",
    ZIP: "59047",
    STNTYPE: "BUS",
    STFIPS: 30,
  },
  {
    X: -117.62174799977032,
    Y: 48.060505000005776,
    OBJECTID: 943,
    STNCODE: "LLK",
    STNNAME: "Loon Lake, WA",
    ADDRESS1: "State Highway 292 & Colville Road",
    ADDRESS2: "Dinner Bell Restaurant",
    CITY: "Loon Lake",
    STATE: "WA",
    ZIP: "99148",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -87.48851000023626,
    Y: 37.3824720001827,
    OBJECTID: 944,
    STNCODE: "MDV",
    STNNAME: "Madisonville, KY",
    ADDRESS1: "4765 Hanson Road",
    ADDRESS2: "Red Cardinal Inn",
    CITY: "Madisonville",
    STATE: "KY",
    ZIP: "42431",
    STNTYPE: "BUS",
    STFIPS: 21,
  },
  {
    X: -87.31505800002662,
    Y: 32.63591400023097,
    OBJECTID: 945,
    STNCODE: "MAA",
    STNNAME: "Marion, AL",
    ADDRESS1: "26400 Alabama Highway 14",
    ADDRESS2: "Perry's Trading Post",
    CITY: "Marion",
    STATE: "AL",
    ZIP: "36756",
    STNTYPE: "BUS",
    STFIPS: 1,
  },
  {
    X: -88.95053899987488,
    Y: 37.73084299990455,
    OBJECTID: 946,
    STNCODE: "MAI",
    STNNAME: "Marion, IL",
    ADDRESS1: "2100 West Main Street",
    ADDRESS2: "Motel Marion",
    CITY: "Marion",
    STATE: "IL",
    ZIP: "62959",
    STNTYPE: "BUS",
    STFIPS: 17,
  },
  {
    X: -119.96620500026052,
    Y: 37.485746999924174,
    OBJECTID: 947,
    STNCODE: "MRM",
    STNNAME: "Mariposa, CA",
    ADDRESS1: "Highway 140 and 7th Street",
    ADDRESS2: "Midtown YARTS Bus Stop",
    CITY: "Mariposa",
    STATE: "CA",
    ZIP: "95338",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -91.92605899992287,
    Y: 44.87366499993988,
    OBJECTID: 948,
    STNCODE: "MNM",
    STNNAME: "Menomonie, WI",
    ADDRESS1: "302 10th Avenue East",
    ADDRESS2: "UW-Stout Memorial Union",
    CITY: "Menomonie",
    STATE: "WI",
    ZIP: "54751",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -96.61749400024786,
    Y: 32.793300999741405,
    OBJECTID: 949,
    STNCODE: "MSQ",
    STNNAME: "Mesquite, TX",
    ADDRESS1: "1331 Highway 80 East \n1331 Highway 80 East \n",
    ADDRESS2: "Greyhound Station",
    CITY: "Mesquite",
    STATE: "TX",
    ZIP: "75150",
    STNTYPE: "BUS",
    STFIPS: 48,
  },
  {
    X: -105.8449650004344,
    Y: 46.408196000245255,
    OBJECTID: 950,
    STNCODE: "MLS",
    STNNAME: "Miles City, MT",
    ADDRESS1: "1019 Main Street",
    ADDRESS2: "M & H Gas Station",
    CITY: "Miles City",
    STATE: "MT",
    ZIP: "59301",
    STNTYPE: "BUS",
    STFIPS: 30,
  },
  {
    X: -101.29697799983478,
    Y: 48.21507900019577,
    OBJECTID: 951,
    STNCODE: "MTB",
    STNNAME: "Minot, ND",
    ADDRESS1: "300 18th Avenue SW",
    ADDRESS2: "Jefferson Lines Bus Depot",
    CITY: "Minot",
    STATE: "ND",
    ZIP: "58701",
    STNTYPE: "BUS",
    STFIPS: 38,
  },
  {
    X: -114.02037999963721,
    Y: 46.87966099995526,
    OBJECTID: 952,
    STNCODE: "MLA",
    STNNAME: "Missoula, MT",
    ADDRESS1: "1660 West Broadway Street",
    ADDRESS2: "Greyhound Lines Terminal",
    CITY: "Missoula",
    STATE: "MT",
    ZIP: "59808",
    STNTYPE: "BUS",
    STFIPS: 30,
  },
  {
    X: -121.96625200022959,
    Y: 47.85821600006841,
    OBJECTID: 953,
    STNCODE: "MEE",
    STNNAME: "Monroe (Eastbound), WA",
    ADDRESS1: "19746 US Highway 2",
    ADDRESS2: "Community Transit Bus Stop Next to Grocery Outlet",
    CITY: "Monroe (Eastbound)",
    STATE: "WA",
    ZIP: "98272",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -86.32739699997154,
    Y: 32.3268740003349,
    OBJECTID: 954,
    STNCODE: "MGM",
    STNNAME: "Montgomery, AL",
    ADDRESS1: "950 West South Boulevard",
    ADDRESS2: "Starnes Travel, Inc.",
    CITY: "Montgomery",
    STATE: "AL",
    ZIP: "36105",
    STNTYPE: "BUS",
    STFIPS: 1,
  },
  {
    X: -76.71568000043163,
    Y: 34.72138300042519,
    OBJECTID: 955,
    STNCODE: "MHD",
    STNNAME: "Morehead City, NC",
    ADDRESS1: "1001 Arendell Street",
    ADDRESS2: "Train Station",
    CITY: "Morehead City",
    STATE: "NC",
    ZIP: "28557",
    STNTYPE: "BUS",
    STFIPS: 37,
  },
  {
    X: -88.00930699961827,
    Y: 31.127181999849483,
    OBJECTID: 956,
    STNCODE: "MTV",
    STNNAME: "Mt. Vernon, AL",
    ADDRESS1: "20890 US Highway 43",
    ADDRESS2: "McDonald's Restaurant",
    CITY: "Mt. Vernon",
    STATE: "AL",
    ZIP: "36560",
    STNTYPE: "BUS",
    STFIPS: 1,
  },
  {
    X: -88.95642599976003,
    Y: 38.31391100029248,
    OBJECTID: 957,
    STNCODE: "MVI",
    STNNAME: "Mt. Vernon, IL",
    ADDRESS1: "102 Potomac Boulevard",
    ADDRESS2: "McDonald's Restaurant",
    CITY: "Mt. Vernon",
    STATE: "IL",
    ZIP: "62864",
    STNTYPE: "BUS",
    STFIPS: 17,
  },
  {
    X: -71.50386600021568,
    Y: 42.790718000035724,
    OBJECTID: 958,
    STNCODE: "NSH",
    STNNAME: "Nashua, NH",
    ADDRESS1: "8 North Southwood Drive",
    ADDRESS2: "Transporation Center",
    CITY: "Nashua",
    STATE: "NH",
    ZIP: "03064",
    STNTYPE: "BUS",
    STFIPS: 33,
  },
  {
    X: -86.77305000005742,
    Y: 36.15206799983838,
    OBJECTID: 959,
    STNCODE: "NVL",
    STNNAME: "Nashville, TN",
    ADDRESS1: "705 5th Avenue South",
    ADDRESS2: "Greyhound Terminal",
    CITY: "Nashville",
    STATE: "TN",
    ZIP: "37203",
    STNTYPE: "BUS",
    STFIPS: 47,
  },
  {
    X: -77.03694800034992,
    Y: 35.10441599959876,
    OBJECTID: 960,
    STNCODE: "NBR",
    STNNAME: "New Bern, NC",
    ADDRESS1: "203 South Front Street",
    ADDRESS2: "Convention Center",
    CITY: "New Bern",
    STATE: "NC",
    ZIP: "28560",
    STNTYPE: "BUS",
    STFIPS: 37,
  },
  {
    X: -71.1294609996254,
    Y: 44.05448500018264,
    OBJECTID: 961,
    STNCODE: "NCW",
    STNNAME: "North Conway, NH",
    ADDRESS1: "2760 White Mountain Highway",
    ADDRESS2: "Eastern Slope Inn Resort",
    CITY: "North Conway",
    STATE: "NH",
    ZIP: "03860",
    STNTYPE: "BUS",
    STFIPS: 33,
  },
  {
    X: -75.16414400014543,
    Y: 38.376209999891614,
    OBJECTID: 962,
    STNCODE: "OCP",
    STNNAME: "Ocean Pines, MD",
    ADDRESS1: "11011 Manklin Creek Road",
    ADDRESS2: "Rite Aid Pharmacy",
    CITY: "Ocean Pines",
    STATE: "MD",
    ZIP: "21811",
    STNTYPE: "BUS",
    STFIPS: 24,
  },
  {
    X: -88.54889899968907,
    Y: 44.022746999774256,
    OBJECTID: 963,
    STNCODE: "OSU",
    STNNAME: "Oshkosh, WI",
    ADDRESS1: "208 Osceola Street",
    ADDRESS2: "University of Wisconsin Gruenhagen Conference Cen*",
    CITY: "Oshkosh",
    STATE: "WI",
    ZIP: "54901",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -84.17008499982285,
    Y: 42.99663600005141,
    OBJECTID: 964,
    STNCODE: "OWO",
    STNNAME: "Owosso, MI",
    ADDRESS1: "109 Comstock Street",
    ADDRESS2: "Indian Trails Bus Station",
    CITY: "Owosso",
    STATE: "MI",
    ZIP: "48867",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -93.75068299962072,
    Y: 32.51507399986525,
    OBJECTID: 982,
    STNCODE: "SHG",
    STNNAME: "Shreveport, LA",
    ADDRESS1: "408 Fannin Street",
    ADDRESS2: "Greyhound Station",
    CITY: "Shreveport",
    STATE: "LA",
    ZIP: "71101",
    STNTYPE: "BUS",
    STFIPS: 22,
  },
  {
    X: -104.17248100019799,
    Y: 47.71845500039802,
    OBJECTID: 983,
    STNCODE: "SIY",
    STNNAME: "Sidney, MT",
    ADDRESS1: "1201 West Holly Street",
    ADDRESS2: "Richland County Community Services Building",
    CITY: "Sidney",
    STATE: "MT",
    ZIP: "59270",
    STNTYPE: "BUS",
    STFIPS: 30,
  },
  {
    X: -121.54714200020311,
    Y: 44.29146900019424,
    OBJECTID: 984,
    STNCODE: "STO",
    STNNAME: "Sisters, OR",
    ADDRESS1: "310 East Cascade Avenue",
    ADDRESS2: "Ski Inn Restaurant",
    CITY: "Sisters",
    STATE: "OR",
    ZIP: "97759",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -121.36173800010857,
    Y: 47.71122899991849,
    OBJECTID: 985,
    STNCODE: "SKE",
    STNNAME: "Skykomish (Eastbound), WA",
    ADDRESS1: "147 5th Street North",
    ADDRESS2: "Sky Gas Station",
    CITY: "Skykomish (Eastbound)",
    STATE: "WA",
    ZIP: "98288",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -124.20378099979325,
    Y: 41.95749800033252,
    OBJECTID: 986,
    STNCODE: "SMR",
    STNNAME: "Smith River, CA",
    ADDRESS1: "13450 US Highway 101 North",
    ADDRESS2: "Shell Station Lucky 7 Casino Store",
    CITY: "Smith River",
    STATE: "CA",
    ZIP: "95567",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -90.93835200044441,
    Y: 44.94981299967026,
    OBJECTID: 987,
    STNCODE: "SNY",
    STNNAME: "Stanley, WI",
    ADDRESS1: "604 South Broadway Street",
    ADDRESS2: "Shell Station Travel Plaza",
    CITY: "Stanley",
    STATE: "WI",
    ZIP: "54768",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -119.93481599975854,
    Y: 38.96990700030784,
    OBJECTID: 988,
    STNCODE: "SLN",
    STNNAME: "Stateline, NV",
    ADDRESS1: "169 Highway 50",
    ADDRESS2: "Kingsbury Transit Center",
    CITY: "Stateline",
    STATE: "NV",
    ZIP: "89449",
    STNTYPE: "BUS",
    STFIPS: 32,
  },
  {
    X: -89.5715780003244,
    Y: 44.52894100022701,
    OBJECTID: 989,
    STNCODE: "SVU",
    STNNAME: "Stevens Point, WI",
    ADDRESS1: "2050 4th Avenue",
    ADDRESS2: "University of Wisconsin Health Enhancement Center",
    CITY: "Stevens Point",
    STATE: "WI",
    ZIP: "54481",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -83.53105899997286,
    Y: 44.2572810001181,
    OBJECTID: 990,
    STNCODE: "TWC",
    STNNAME: "Tawas City, MI",
    ADDRESS1: "1020 West Lake Street",
    ADDRESS2: "Bay Inn",
    CITY: "Tawas City",
    STATE: "MI",
    ZIP: "48763",
    STNTYPE: "BUS",
    STFIPS: 26,
  },
  {
    X: -81.94067399960534,
    Y: 28.937532000401575,
    OBJECTID: 991,
    STNCODE: "TVF",
    STNNAME: "The Villages-Lady Lake, FL",
    ADDRESS1: "401 North US Highway 441",
    ADDRESS2: "BP Gas Station/Kangaroo Express Market",
    CITY: "Lady Lake",
    STATE: "FL",
    ZIP: "32159",
    STNTYPE: "BUS",
    STFIPS: 12,
  },
  {
    X: -87.73646499985983,
    Y: 31.941001999742525,
    OBJECTID: 992,
    STNCODE: "THM",
    STNNAME: "Thomasville, AL",
    ADDRESS1: "34390 US Highway 43",
    ADDRESS2: "Chevron Gas Station",
    CITY: "Thomasville",
    STATE: "AL",
    ZIP: "36784",
    STNTYPE: "BUS",
    STFIPS: 1,
  },
  {
    X: -118.28667599979752,
    Y: 33.84336399964894,
    OBJECTID: 993,
    STNCODE: "TOA",
    STNNAME: "Torrance, CA",
    ADDRESS1: "20575 Hamilton Avenue",
    ADDRESS2: "Alpine Village MTA Transit Bus Stop",
    CITY: "Torrance",
    STATE: "CA",
    ZIP: "90502",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -95.30270900002029,
    Y: 32.35301199970405,
    OBJECTID: 994,
    STNCODE: "TYL",
    STNNAME: "Tyler, TX",
    ADDRESS1: "303 North Bois D'Arc Street",
    ADDRESS2: "Greyhound Station",
    CITY: "Tyler",
    STATE: "TX",
    ZIP: "75702",
    STNTYPE: "BUS",
    STFIPS: 48,
  },
  {
    X: -90.87571899983192,
    Y: 32.31630300028331,
    OBJECTID: 995,
    STNCODE: "VKS",
    STNNAME: "Vicksburg, MS",
    ADDRESS1: "1295 South Frontage Road",
    ADDRESS2: "Greyhound Bus Station",
    CITY: "Vicksburg",
    STATE: "MS",
    ZIP: "39180",
    STNTYPE: "BUS",
    STFIPS: 28,
  },
  {
    X: -117.29391800031544,
    Y: 34.5374669997023,
    OBJECTID: 996,
    STNCODE: "VRB",
    STNNAME: "Victorville, CA",
    ADDRESS1: "16838 South D Street",
    ADDRESS2: "Victor Valley Transit Center",
    CITY: "Victorville",
    STATE: "CA",
    ZIP: "92395",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -88.89764899980145,
    Y: 37.41538399987172,
    OBJECTID: 997,
    STNCODE: "VNA",
    STNNAME: "Vienna, IL",
    ADDRESS1: "504 West Vine Street",
    ADDRESS2: "Hospitality House of Vienna",
    CITY: "Vienna",
    STATE: "IL",
    ZIP: "62995",
    STNTYPE: "BUS",
    STFIPS: 17,
  },
  {
    X: -97.13234499972191,
    Y: 31.552238999830024,
    OBJECTID: 998,
    STNCODE: "WCX",
    STNNAME: "Waco, TX",
    ADDRESS1: "301 South 8th Street",
    ADDRESS2: "Transit Center",
    CITY: "Waco",
    STATE: "TX",
    ZIP: "76701",
    STNTYPE: "BUS",
    STFIPS: 48,
  },
  {
    X: -118.3415020001172,
    Y: 46.06598899969265,
    OBJECTID: 999,
    STNCODE: "WWA",
    STNNAME: "Walla Walla, WA",
    ADDRESS1: "108 West Main Street",
    ADDRESS2: "Transit Center",
    CITY: "Walla Walla",
    STATE: "WA",
    ZIP: "99362",
    STNTYPE: "BUS",
    STFIPS: 53,
  },
  {
    X: -88.71797200030755,
    Y: 43.63333499961061,
    OBJECTID: 1000,
    STNCODE: "WPN",
    STNNAME: "Waupun, WI",
    ADDRESS1: "928 East Main Street",
    ADDRESS2: "End of the Trail Candy Shop",
    CITY: "Waupun",
    STATE: "WI",
    ZIP: "53963",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -89.62462799968239,
    Y: 44.959456000094406,
    OBJECTID: 1001,
    STNCODE: "WSJ",
    STNNAME: "Wausau, WI",
    ADDRESS1: "555 Jefferson Street",
    ADDRESS2: "Transit Center",
    CITY: "Wausau",
    STATE: "WI",
    ZIP: "54403",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -118.39238999959878,
    Y: 33.97582499992387,
    OBJECTID: 1002,
    STNCODE: "WCH",
    STNNAME: "Westchester, CA",
    ADDRESS1: "6860 Park Terrace Drive",
    ADDRESS2: "Culver City Transit Northbound Route 6 Bus Stop",
    CITY: "Westchester",
    STATE: "CA",
    ZIP: "90045",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -89.48408900010725,
    Y: 43.88779099955502,
    OBJECTID: 1003,
    STNCODE: "WSF",
    STNNAME: "Westfield, WI",
    ADDRESS1: "244 North Pioneer Park Road",
    ADDRESS2: "Mobil Station",
    CITY: "Westfield",
    STATE: "WI",
    ZIP: "53964",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -118.44897900028059,
    Y: 34.06877200002782,
    OBJECTID: 1004,
    STNCODE: "WES",
    STNNAME: "Westwood-UCLA, CA",
    ADDRESS1: "592 Gayley Ave.",
    ADDRESS2: "Los Angeles MTA Westbound Route 2 Transit Bus Stop",
    CITY: "Westwood-UCLA",
    STATE: "CA",
    ZIP: "90024",
    STNTYPE: "BUS",
    STFIPS: 6,
  },
  {
    X: -75.70201299989998,
    Y: 41.07137900014078,
    OBJECTID: 1005,
    STNCODE: "WHV",
    STNNAME: "White Haven, PA",
    ADDRESS1: "I-476, Exit 95/I-80, Exit 277, at Hwy 940",
    ADDRESS2: "McDonald's Restaurant",
    CITY: "White Haven",
    STATE: "PA",
    ZIP: "18661",
    STNTYPE: "BUS",
    STFIPS: 42,
  },
  {
    X: -75.88319599959567,
    Y: 41.245024000257445,
    OBJECTID: 1006,
    STNCODE: "WKB",
    STNNAME: "Wilkes-Barre, PA",
    ADDRESS1: "47 South Washington Street",
    ADDRESS2: "Intermodal Transportation Center",
    CITY: "Wilkes-Barre",
    STATE: "PA",
    ZIP: "18701",
    STNTYPE: "BUS",
    STFIPS: 42,
  },
  {
    X: -89.85666099980529,
    Y: 44.39698599990402,
    OBJECTID: 1007,
    STNCODE: "WIR",
    STNNAME: "Wisconsin Rapids, WI",
    ADDRESS1: "2611 West Grand Avenue",
    ADDRESS2: "Lamers Connect Bus Station",
    CITY: "Wisconsin Rapids",
    STATE: "WI",
    ZIP: "54495",
    STNTYPE: "BUS",
    STFIPS: 55,
  },
  {
    X: -122.87638199972946,
    Y: 45.15158900023221,
    OBJECTID: 1008,
    STNCODE: "WBN",
    STNNAME: "Woodburn, OR",
    ADDRESS1: "2900 Tom Tennant Drive",
    ADDRESS2: "Transit Center",
    CITY: "Woodburn",
    STATE: "OR",
    ZIP: "97071",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -122.14500600032665,
    Y: 42.91090099978135,
    OBJECTID: 1009,
    STNCODE: "CLK",
    STNNAME: "Crater Lake, OR",
    ADDRESS1: "Rim Drive",
    ADDRESS2: "Community House at Rim Village",
    CITY: "Crater Lake",
    STATE: "OR",
    ZIP: "97604",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -121.88515699989557,
    Y: 42.27687999961233,
    OBJECTID: 1010,
    STNCODE: "RNY",
    STNNAME: "Klamath Falls, OR",
    ADDRESS1: "5500 Running Y Road",
    ADDRESS2: "Lodge",
    CITY: "Klamath Falls",
    STATE: "OR",
    ZIP: "97601",
    STNTYPE: "BUS",
    STFIPS: 41,
  },
  {
    X: -73.77101699973468,
    Y: 43.07460700021295,
    OBJECTID: 1011,
    STNCODE: "SRK",
    STNNAME: "Saratoga Springs, NY",
    ADDRESS1: "267 Union Avenue",
    ADDRESS2: "Entrance Bus Stop",
    CITY: "Saratoga Springs",
    STATE: "NY",
    ZIP: "12866",
    STNTYPE: "BUS",
    STFIPS: 36,
  },
  {
    X: -122.34993499970045,
    Y: 48.242638000343504,
    OBJECTID: 1012,
    STNCODE: "STW",
    STNNAME: "Stanwood, WA",
    ADDRESS1: "27111 Florence Way",
    ADDRESS2: "Station",
    CITY: "Stanwood",
    STATE: "WA",
    ZIP: "98292",
    STNTYPE: "RAIL",
    STFIPS: 53,
  },
  {
    X: -83.19102599984996,
    Y: 42.54255499981343,
    OBJECTID: 1013,
    STNCODE: "TRM",
    STNNAME: "Troy, MI",
    ADDRESS1: "1201 Doyle Drive",
    ADDRESS2: "Troy Transit Center",
    CITY: "Troy",
    STATE: "MI",
    ZIP: "48084",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -86.74578199983938,
    Y: 41.7966559997746,
    OBJECTID: 1014,
    STNCODE: "NBU",
    STNNAME: "New Buffalo, MI",
    ADDRESS1: "226 North Whittaker Street",
    ADDRESS2: "Station",
    CITY: "New Buffalo",
    STATE: "MI",
    ZIP: "49117",
    STNTYPE: "RAIL",
    STFIPS: 26,
  },
  {
    X: -72.6263790001907,
    Y: 42.31885800009667,
    OBJECTID: 1015,
    STNCODE: "NHT",
    STNNAME: "Northampton, MA",
    ADDRESS1: "170 Pleasant Street",
    ADDRESS2: "Station",
    CITY: "Northampton",
    STATE: "MA",
    ZIP: "01060",
    STNTYPE: "RAIL",
    STFIPS: 25,
  },
  {
    X: -97.42969800026248,
    Y: 35.87786100008515,
    OBJECTID: 1016,
    STNCODE: "GUT",
    STNNAME: "Guthrie, OK",
    ADDRESS1: "409 West Oklahoma Ave.",
    ADDRESS2: "Santa Fe Depot",
    CITY: "Guthrie",
    STATE: "OK",
    ZIP: "73044",
    STNTYPE: "RAIL",
    STFIPS: 40,
  },
];
